export const POSTCODE_OUTCODES = {
  AB10: {latitude: 57.1353138, longitude: -2.1202461},
  AB11: {latitude: 57.1392011, longitude: -2.0928839},
  AB12: {latitude: 57.1020973, longitude: -2.1129498},
  AB13: {latitude: 57.1082022, longitude: -2.2368915},
  AB14: {latitude: 57.1004493, longitude: -2.2713239},
  AB15: {latitude: 57.1375445, longitude: -2.16861},
  AB16: {latitude: 57.1600441, longitude: -2.1566958},
  AB21: {latitude: 57.2093798, longitude: -2.2016004},
  AB22: {latitude: 57.1865864, longitude: -2.1223591},
  AB23: {latitude: 57.2132774, longitude: -2.0892647},
  AB24: {latitude: 57.1639292, longitude: -2.1079218},
  AB25: {latitude: 57.1527168, longitude: -2.1140756},
  AB30: {latitude: 56.8467032, longitude: -2.4778654},
  AB31: {latitude: 57.0729813, longitude: -2.522251},
  AB32: {latitude: 57.1550293, longitude: -2.317922},
  AB33: {latitude: 57.2255966, longitude: -2.740868},
  AB34: {latitude: 57.0936452, longitude: -2.8113866},
  AB35: {latitude: 57.0384103, longitude: -3.1496008},
  AB36: {latitude: 57.1971865, longitude: -3.0683197},
  AB37: {latitude: 57.3275842, longitude: -3.3524834},
  AB38: {latitude: 57.4863473, longitude: -3.2264677},
  AB39: {latitude: 56.979377, longitude: -2.2170154},
  AB41: {latitude: 57.3739596, longitude: -2.1040725},
  AB42: {latitude: 57.5010193, longitude: -1.8922218},
  AB43: {latitude: 57.6572238, longitude: -2.0442865},
  AB44: {latitude: 57.6682668, longitude: -2.4922135},
  AB45: {latitude: 57.6517031, longitude: -2.5676286},
  AB51: {latitude: 57.2876297, longitude: -2.403827},
  AB52: {latitude: 57.3437877, longitude: -2.6088547},
  AB53: {latitude: 57.5250408, longitude: -2.3937282},
  AB54: {latitude: 57.4540447, longitude: -2.761688},
  AB55: {latitude: 57.5245238, longitude: -2.9896438},
  AB56: {latitude: 57.6743925, longitude: -2.9288909},
  AB99: {latitude: 57.1113406, longitude: -2.0939925},
  AL1: {latitude: 51.7489129, longitude: -0.323756},
  AL10: {latitude: 51.7604054, longitude: -0.2323864},
  AL2: {latitude: 51.7191035, longitude: -0.3354863},
  AL3: {latitude: 51.7803976, longitude: -0.3775501},
  AL4: {latitude: 51.7739838, longitude: -0.295024},
  AL5: {latitude: 51.8153821, longitude: -0.3520548},
  AL6: {latitude: 51.832147, longitude: -0.1998286},
  AL7: {latitude: 51.7969028, longitude: -0.1872378},
  AL8: {latitude: 51.803623, longitude: -0.2117607},
  AL9: {latitude: 51.7445903, longitude: -0.1976882},
  B1: {latitude: 52.4799811, longitude: -1.9091472},
  B10: {latitude: 52.4695926, longitude: -1.8523465},
  B11: {latitude: 52.4544936, longitude: -1.8581324},
  B12: {latitude: 52.4607564, longitude: -1.8836558},
  B13: {latitude: 52.4375032, longitude: -1.8790028},
  B14: {latitude: 52.4173564, longitude: -1.8898132},
  B15: {latitude: 52.4661665, longitude: -1.9233802},
  B16: {latitude: 52.4771886, longitude: -1.9342144},
  B17: {latitude: 52.461233, longitude: -1.9586781},
  B18: {latitude: 52.4913461, longitude: -1.9255863},
  B19: {latitude: 52.4971338, longitude: -1.9057716},
  B2: {latitude: 52.4893361, longitude: -1.8965236},
  B20: {latitude: 52.515504, longitude: -1.9192015},
  B21: {latitude: 52.506938, longitude: -1.9415679},
  B23: {latitude: 52.5285384, longitude: -1.8553035},
  B24: {latitude: 52.5196415, longitude: -1.8271375},
  B25: {latitude: 52.4649901, longitude: -1.8219999},
  B26: {latitude: 52.4615675, longitude: -1.7887486},
  B27: {latitude: 52.4445575, longitude: -1.8228123},
  B28: {latitude: 52.4272318, longitude: -1.8432114},
  B29: {latitude: 52.4376384, longitude: -1.947722},
  B3: {latitude: 52.4850123, longitude: -1.9024305},
  B30: {latitude: 52.421961, longitude: -1.9277595},
  B31: {latitude: 52.4081108, longitude: -1.9733848},
  B32: {latitude: 52.4486238, longitude: -1.9945407},
  B33: {latitude: 52.4802868, longitude: -1.7884156},
  B34: {latitude: 52.4964133, longitude: -1.7817039},
  B35: {latitude: 52.5188542, longitude: -1.7890673},
  B36: {latitude: 52.5042044, longitude: -1.7784585},
  B37: {latitude: 52.4784345, longitude: -1.7421791},
  B38: {latitude: 52.3999018, longitude: -1.9347197},
  B4: {latitude: 52.4857738, longitude: -1.8928567},
  B40: {latitude: 52.4569283, longitude: -1.7225262},
  B42: {latitude: 52.5346593, longitude: -1.9124526},
  B43: {latitude: 52.5485092, longitude: -1.9307835},
  B44: {latitude: 52.5456674, longitude: -1.8850992},
  B45: {latitude: 52.3885168, longitude: -2.0090938},
  B46: {latitude: 52.5088835, longitude: -1.6949788},
  B47: {latitude: 52.3852897, longitude: -1.8800827},
  B48: {latitude: 52.3547623, longitude: -1.9470221},
  B49: {latitude: 52.2178973, longitude: -1.866774},
  B5: {latitude: 52.4694163, longitude: -1.8975868},
  B50: {latitude: 52.1683483, longitude: -1.8562373},
  B6: {latitude: 52.5051401, longitude: -1.8860786},
  B60: {latitude: 52.3240959, longitude: -2.0491825},
  B61: {latitude: 52.3464135, longitude: -2.068307},
  B62: {latitude: 52.4571593, longitude: -2.0337937},
  B63: {latitude: 52.4514517, longitude: -2.0699158},
  B64: {latitude: 52.4725264, longitude: -2.0694635},
  B65: {latitude: 52.4836373, longitude: -2.0437814},
  B66: {latitude: 52.4926661, longitude: -1.9647632},
  B67: {latitude: 52.485705, longitude: -1.9787293},
  B68: {latitude: 52.4785994, longitude: -2.0014018},
  B69: {latitude: 52.5027111, longitude: -2.030311},
  B7: {latitude: 52.4941549, longitude: -1.8723775},
  B70: {latitude: 52.5209224, longitude: -2.0044143},
  B71: {latitude: 52.5360066, longitude: -1.9904942},
  B72: {latitude: 52.5501949, longitude: -1.8219989},
  B73: {latitude: 52.5537182, longitude: -1.841907},
  B74: {latitude: 52.5843126, longitude: -1.8621609},
  B75: {latitude: 52.578728, longitude: -1.808515},
  B76: {latitude: 52.5434894, longitude: -1.7825543},
  B77: {latitude: 52.6185928, longitude: -1.66868},
  B78: {latitude: 52.6055691, longitude: -1.6733206},
  B79: {latitude: 52.6506131, longitude: -1.6815794},
  B8: {latitude: 52.4911095, longitude: -1.8413277},
  B80: {latitude: 52.2735522, longitude: -1.8923001},
  B9: {latitude: 52.4781837, longitude: -1.8508904},
  B90: {latitude: 52.3989824, longitude: -1.8260954},
  B91: {latitude: 52.4139981, longitude: -1.7833291},
  B92: {latitude: 52.4372881, longitude: -1.7739201},
  B93: {latitude: 52.3804941, longitude: -1.7438511},
  B94: {latitude: 52.3495479, longitude: -1.793885},
  B95: {latitude: 52.2859172, longitude: -1.7806898},
  B96: {latitude: 52.2517197, longitude: -1.9602473},
  B97: {latitude: 52.2996987, longitude: -1.9545616},
  B98: {latitude: 52.3022428, longitude: -1.9130643},
  B99: {latitude: 52.4959257, longitude: -1.8942585},
  BA1: {latitude: 51.3927912, longitude: -2.3611374},
  BA10: {latitude: 51.1131761, longitude: -2.4478513},
  BA11: {latitude: 51.2332006, longitude: -2.3245542},
  BA12: {latitude: 51.1708259, longitude: -2.1888898},
  BA13: {latitude: 51.2621061, longitude: -2.1816707},
  BA14: {latitude: 51.3191164, longitude: -2.2025658},
  BA15: {latitude: 51.3482711, longitude: -2.2580986},
  BA16: {latitude: 51.124174, longitude: -2.7457829},
  BA2: {latitude: 51.3592543, longitude: -2.3793066},
  BA20: {latitude: 50.937984, longitude: -2.6452044},
  BA21: {latitude: 50.9520712, longitude: -2.6336799},
  BA22: {latitude: 50.9695037, longitude: -2.6381055},
  BA3: {latitude: 51.2717539, longitude: -2.4785029},
  BA4: {latitude: 51.1724351, longitude: -2.5320463},
  BA5: {latitude: 51.212571, longitude: -2.6552733},
  BA6: {latitude: 51.1420762, longitude: -2.7078987},
  BA7: {latitude: 51.0894942, longitude: -2.5194603},
  BA8: {latitude: 50.9962542, longitude: -2.411865},
  BA9: {latitude: 51.0576908, longitude: -2.4101382},
  BB1: {latitude: 53.7567872, longitude: -2.462979},
  BB10: {latitude: 53.7995625, longitude: -2.2195134},
  BB11: {latitude: 53.7826402, longitude: -2.2539059},
  BB12: {latitude: 53.8034114, longitude: -2.2927166},
  BB18: {latitude: 53.9145757, longitude: -2.1720306},
  BB2: {latitude: 53.7416815, longitude: -2.5018572},
  BB3: {latitude: 53.6978859, longitude: -2.4662858},
  BB4: {latitude: 53.7037431, longitude: -2.2919089},
  BB5: {latitude: 53.754299, longitude: -2.37346},
  BB6: {latitude: 53.7929328, longitude: -2.4175001},
  BB7: {latitude: 53.8708936, longitude: -2.3888971},
  BB8: {latitude: 53.8580089, longitude: -2.1635237},
  BB9: {latitude: 53.8374035, longitude: -2.2156194},
  BB94: {latitude: 53.9152416, longitude: -2.1380327},
  BD1: {latitude: 53.7966616, longitude: -1.7545344},
  BD10: {latitude: 53.8329365, longitude: -1.7248454},
  BD11: {latitude: 53.752252, longitude: -1.6757083},
  BD12: {latitude: 53.7456818, longitude: -1.7626592},
  BD13: {latitude: 53.7867466, longitude: -1.8612838},
  BD14: {latitude: 53.7821908, longitude: -1.8183815},
  BD15: {latitude: 53.8100727, longitude: -1.8383321},
  BD16: {latitude: 53.8484508, longitude: -1.8331337},
  BD17: {latitude: 53.8475875, longitude: -1.768364},
  BD18: {latitude: 53.8304494, longitude: -1.7768469},
  BD19: {latitude: 53.7273298, longitude: -1.7141196},
  BD2: {latitude: 53.8152428, longitude: -1.7344633},
  BD20: {latitude: 53.8982751, longitude: -1.9501915},
  BD21: {latitude: 53.864231, longitude: -1.9076629},
  BD22: {latitude: 53.8457607, longitude: -1.9553752},
  BD23: {latitude: 53.993339, longitude: -2.0569312},
  BD24: {latitude: 54.080044, longitude: -2.2841297},
  BD3: {latitude: 53.7984863, longitude: -1.7267147},
  BD4: {latitude: 53.7763907, longitude: -1.7186609},
  BD5: {latitude: 53.7781758, longitude: -1.7591405},
  BD6: {latitude: 53.7645222, longitude: -1.7861654},
  BD7: {latitude: 53.783468, longitude: -1.7857283},
  BD8: {latitude: 53.8017321, longitude: -1.7839736},
  BD9: {latitude: 53.8128852, longitude: -1.7924051},
  BD97: {latitude: 53.8266825, longitude: -1.7967244},
  BD98: {latitude: 53.816805, longitude: -1.7653258},
  BD99: {latitude: 53.7947563, longitude: -1.7663604},
  BH1: {latitude: 50.7249204, longitude: -1.8602459},
  BH10: {latitude: 50.7595614, longitude: -1.8929555},
  BH11: {latitude: 50.7622035, longitude: -1.9198635},
  BH12: {latitude: 50.7374063, longitude: -1.9273505},
  BH13: {latitude: 50.7088605, longitude: -1.920442},
  BH14: {latitude: 50.7214367, longitude: -1.9445851},
  BH15: {latitude: 50.7223607, longitude: -1.985506},
  BH16: {latitude: 50.740203, longitude: -2.0474413},
  BH17: {latitude: 50.746875, longitude: -1.9800404},
  BH18: {latitude: 50.7595167, longitude: -1.9984276},
  BH19: {latitude: 50.611489, longitude: -1.97082},
  BH2: {latitude: 50.7210819, longitude: -1.8840411},
  BH20: {latitude: 50.6871662, longitude: -2.1485991},
  BH21: {latitude: 50.8125355, longitude: -1.974537},
  BH22: {latitude: 50.8053042, longitude: -1.888586},
  BH23: {latitude: 50.7475595, longitude: -1.7543605},
  BH24: {latitude: 50.8432801, longitude: -1.7884673},
  BH25: {latitude: 50.75283, longitude: -1.6579866},
  BH3: {latitude: 50.7365886, longitude: -1.8833558},
  BH31: {latitude: 50.8760396, longitude: -1.872606},
  BH4: {latitude: 50.7212551, longitude: -1.8997372},
  BH5: {latitude: 50.725298, longitude: -1.8322739},
  BH6: {latitude: 50.7276493, longitude: -1.8019536},
  BH7: {latitude: 50.7364005, longitude: -1.8263105},
  BH8: {latitude: 50.7419912, longitude: -1.8519359},
  BH9: {latitude: 50.749635, longitude: -1.8727345},
  BL0: {latitude: 53.6484286, longitude: -2.3169628},
  BL1: {latitude: 53.5905339, longitude: -2.4448299},
  BL11: {latitude: 53.5723273, longitude: -2.425451},
  BL2: {latitude: 53.5885067, longitude: -2.3950838},
  BL3: {latitude: 53.5646619, longitude: -2.4321772},
  BL4: {latitude: 53.5462411, longitude: -2.4015686},
  BL5: {latitude: 53.5481623, longitude: -2.5154623},
  BL6: {latitude: 53.5917532, longitude: -2.5408608},
  BL7: {latitude: 53.6317625, longitude: -2.4223993},
  BL78: {latitude: 53.5641145, longitude: -2.410661},
  BL8: {latitude: 53.6048216, longitude: -2.3275802},
  BL9: {latitude: 53.5918117, longitude: -2.2870531},
  BN1: {latitude: 50.8423629, longitude: -0.1395112},
  BN10: {latitude: 50.7959843, longitude: 0.0013219},
  BN11: {latitude: 50.8135706, longitude: -0.3771568},
  BN12: {latitude: 50.8139666, longitude: -0.4292747},
  BN13: {latitude: 50.8326835, longitude: -0.4113838},
  BN14: {latitude: 50.8340609, longitude: -0.3817303},
  BN15: {latitude: 50.8303272, longitude: -0.3257841},
  BN16: {latitude: 50.814554, longitude: -0.4957555},
  BN17: {latitude: 50.8149225, longitude: -0.5399594},
  BN18: {latitude: 50.8476816, longitude: -0.5840822},
  BN2: {latitude: 50.8250741, longitude: -0.1010175},
  BN20: {latitude: 50.7748096, longitude: 0.2519395},
  BN21: {latitude: 50.7726897, longitude: 0.2765565},
  BN22: {latitude: 50.7896229, longitude: 0.2838081},
  BN23: {latitude: 50.7976028, longitude: 0.3125132},
  BN24: {latitude: 50.8167744, longitude: 0.3261108},
  BN25: {latitude: 50.7765238, longitude: 0.1083361},
  BN26: {latitude: 50.8211682, longitude: 0.2228173},
  BN27: {latitude: 50.8718389, longitude: 0.2634568},
  BN3: {latitude: 50.8352718, longitude: -0.1777197},
  BN41: {latitude: 50.8414939, longitude: -0.2174858},
  BN42: {latitude: 50.8376298, longitude: -0.2347507},
  BN43: {latitude: 50.8360644, longitude: -0.2669108},
  BN44: {latitude: 50.8910892, longitude: -0.322266},
  BN45: {latitude: 50.8967169, longitude: -0.1902402},
  BN5: {latitude: 50.9270143, longitude: -0.2687648},
  BN50: {latitude: 50.8263299, longitude: -0.1408006},
  BN51: {latitude: 50.8048207, longitude: -0.0586638},
  BN52: {latitude: 50.8344048, longitude: -0.1680463},
  BN6: {latitude: 50.931059, longitude: -0.1555778},
  BN7: {latitude: 50.877372, longitude: -0.0008331},
  BN8: {latitude: 50.9166625, longitude: 0.0527321},
  BN88: {latitude: 50.8274838, longitude: -0.1400575},
  BN9: {latitude: 50.795683, longitude: 0.0498051},
  BN95: {latitude: 50.823154, longitude: -0.330024},
  BN99: {latitude: 50.8231149, longitude: -0.3490648},
  BR1: {latitude: 51.4119969, longitude: 0.0208833},
  BR2: {latitude: 51.387269, longitude: 0.0224568},
  BR3: {latitude: 51.4045675, longitude: -0.0305611},
  BR4: {latitude: 51.3750032, longitude: -0.0083853},
  BR5: {latitude: 51.3917166, longitude: 0.1033934},
  BR6: {latitude: 51.3652346, longitude: 0.0912592},
  BR7: {latitude: 51.4148588, longitude: 0.0645782},
  BR8: {latitude: 51.3985498, longitude: 0.1743791},
  BS1: {latitude: 51.4532627, longitude: -2.5935387},
  BS10: {latitude: 51.5067451, longitude: -2.610823},
  BS11: {latitude: 51.4973558, longitude: -2.6752683},
  BS13: {latitude: 51.4120999, longitude: -2.6119989},
  BS14: {latitude: 51.412973, longitude: -2.5632222},
  BS15: {latitude: 51.4596293, longitude: -2.5068855},
  BS16: {latitude: 51.4868114, longitude: -2.5100273},
  BS2: {latitude: 51.4599036, longitude: -2.5819782},
  BS20: {latitude: 51.4806147, longitude: -2.7535558},
  BS21: {latitude: 51.4350533, longitude: -2.8498455},
  BS22: {latitude: 51.3610555, longitude: -2.9293627},
  BS23: {latitude: 51.3430959, longitude: -2.9718955},
  BS24: {latitude: 51.3303607, longitude: -2.9292938},
  BS25: {latitude: 51.3199339, longitude: -2.820467},
  BS26: {latitude: 51.2788645, longitude: -2.8569371},
  BS27: {latitude: 51.272182, longitude: -2.7717346},
  BS28: {latitude: 51.2260512, longitude: -2.8149367},
  BS29: {latitude: 51.3306402, longitude: -2.8750405},
  BS3: {latitude: 51.4386547, longitude: -2.6031568},
  BS30: {latitude: 51.4447118, longitude: -2.4713845},
  BS31: {latitude: 51.4087555, longitude: -2.4924616},
  BS32: {latitude: 51.5444813, longitude: -2.5576565},
  BS34: {latitude: 51.523502, longitude: -2.5667207},
  BS35: {latitude: 51.5977668, longitude: -2.5487713},
  BS36: {latitude: 51.5257135, longitude: -2.4864768},
  BS37: {latitude: 51.5409765, longitude: -2.4141076},
  BS39: {latitude: 51.3282866, longitude: -2.5335653},
  BS4: {latitude: 51.435356, longitude: -2.5636106},
  BS40: {latitude: 51.346529, longitude: -2.6919383},
  BS41: {latitude: 51.4220916, longitude: -2.6534866},
  BS48: {latitude: 51.4251376, longitude: -2.7478067},
  BS49: {latitude: 51.3829265, longitude: -2.8123525},
  BS5: {latitude: 51.4620533, longitude: -2.5517422},
  BS6: {latitude: 51.4707656, longitude: -2.6003841},
  BS7: {latitude: 51.4869402, longitude: -2.5814899},
  BS8: {latitude: 51.4575672, longitude: -2.6221985},
  BS9: {latitude: 51.487328, longitude: -2.6267518},
  BS98: {latitude: 51.4597488, longitude: -2.5889635},
  BS99: {latitude: 51.4450405, longitude: -2.5956233},
  BT1: {latitude: 54.5997539, longitude: -5.9284735},
  BT10: {latitude: 54.5594341, longitude: -5.9851563},
  BT11: {latitude: 54.5762546, longitude: -5.9981326},
  BT12: {latitude: 54.5929184, longitude: -5.9584163},
  BT13: {latitude: 54.6058982, longitude: -5.9596444},
  BT14: {latitude: 54.621457, longitude: -5.9626627},
  BT15: {latitude: 54.6234399, longitude: -5.9320317},
  BT16: {latitude: 54.5906801, longitude: -5.7976783},
  BT17: {latitude: 54.5534071, longitude: -6.0198284},
  BT18: {latitude: 54.6412227, longitude: -5.8220028},
  BT19: {latitude: 54.6513331, longitude: -5.6671749},
  BT2: {latitude: 54.5937744, longitude: -5.9306374},
  BT20: {latitude: 54.6585904, longitude: -5.665505},
  BT21: {latitude: 54.6400923, longitude: -5.54674},
  BT22: {latitude: 54.5017687, longitude: -5.5145457},
  BT23: {latitude: 54.564476, longitude: -5.7153624},
  BT24: {latitude: 54.4173126, longitude: -5.8716837},
  BT25: {latitude: 54.3959469, longitude: -6.1138325},
  BT26: {latitude: 54.4542746, longitude: -6.0639346},
  BT27: {latitude: 54.5091942, longitude: -6.0237607},
  BT28: {latitude: 54.5227918, longitude: -6.0866891},
  BT29: {latitude: 54.6209431, longitude: -6.196934},
  BT3: {latitude: 54.6172417, longitude: -5.903704},
  BT30: {latitude: 54.3352858, longitude: -5.702726},
  BT31: {latitude: 54.2769937, longitude: -5.9689188},
  BT32: {latitude: 54.3355257, longitude: -6.2456426},
  BT33: {latitude: 54.2233393, longitude: -5.8913207},
  BT34: {latitude: 54.1531164, longitude: -6.1774814},
  BT35: {latitude: 54.1620226, longitude: -6.4418816},
  BT36: {latitude: 54.6768193, longitude: -5.9562895},
  BT37: {latitude: 54.6775107, longitude: -5.9080795},
  BT38: {latitude: 54.7289788, longitude: -5.8008313},
  BT39: {latitude: 54.745645, longitude: -6.0174462},
  BT4: {latitude: 54.6025629, longitude: -5.869615},
  BT40: {latitude: 54.8457073, longitude: -5.8237859},
  BT41: {latitude: 54.7322694, longitude: -6.2572788},
  BT42: {latitude: 54.8548266, longitude: -6.2755735},
  BT43: {latitude: 54.8926899, longitude: -6.2647155},
  BT44: {latitude: 54.9722864, longitude: -6.287524},
  BT45: {latitude: 54.7600743, longitude: -6.6390822},
  BT46: {latitude: 54.8654569, longitude: -6.6634111},
  BT47: {latitude: 54.9739997, longitude: -7.2126901},
  BT48: {latitude: 55.0103984, longitude: -7.3273919},
  BT49: {latitude: 55.0473469, longitude: -6.9508217},
  BT5: {latitude: 54.5891629, longitude: -5.871144},
  BT51: {latitude: 55.060214, longitude: -6.6830653},
  BT52: {latitude: 55.134521, longitude: -6.6551623},
  BT53: {latitude: 55.0857068, longitude: -6.4749555},
  BT54: {latitude: 55.2043862, longitude: -6.2565641},
  BT55: {latitude: 55.179239, longitude: -6.7104568},
  BT56: {latitude: 55.197616, longitude: -6.6503827},
  BT57: {latitude: 55.2034959, longitude: -6.5177372},
  BT6: {latitude: 54.5799883, longitude: -5.897917},
  BT60: {latitude: 54.2928226, longitude: -6.6487383},
  BT61: {latitude: 54.3687705, longitude: -6.6224601},
  BT62: {latitude: 54.411752, longitude: -6.4661507},
  BT63: {latitude: 54.4072137, longitude: -6.3906387},
  BT64: {latitude: 54.4490883, longitude: -6.3901653},
  BT65: {latitude: 54.4445858, longitude: -6.3654149},
  BT66: {latitude: 54.4550926, longitude: -6.3329464},
  BT67: {latitude: 54.4869748, longitude: -6.2660667},
  BT68: {latitude: 54.3649415, longitude: -6.84812},
  BT69: {latitude: 54.4199975, longitude: -6.9502828},
  BT7: {latitude: 54.5819589, longitude: -5.9245497},
  BT70: {latitude: 54.5139825, longitude: -6.8875077},
  BT71: {latitude: 54.5128046, longitude: -6.7043034},
  BT74: {latitude: 54.3451053, longitude: -7.6650636},
  BT75: {latitude: 54.3726416, longitude: -7.3171652},
  BT76: {latitude: 54.4200957, longitude: -7.1921901},
  BT77: {latitude: 54.4273568, longitude: -7.1188959},
  BT78: {latitude: 54.5709348, longitude: -7.3760979},
  BT79: {latitude: 54.623159, longitude: -7.200907},
  BT8: {latitude: 54.540416, longitude: -5.9063825},
  BT80: {latitude: 54.6462975, longitude: -6.74572},
  BT81: {latitude: 54.6958267, longitude: -7.6113132},
  BT82: {latitude: 54.8264822, longitude: -7.4303378},
  BT9: {latitude: 54.5721032, longitude: -5.9500064},
  BT92: {latitude: 54.2245245, longitude: -7.4675641},
  BT93: {latitude: 54.4678402, longitude: -7.8268864},
  BT94: {latitude: 54.3760757, longitude: -7.5336959},
  CA1: {latitude: 54.8858561, longitude: -2.9124405},
  CA10: {latitude: 54.6118806, longitude: -2.6584077},
  CA11: {latitude: 54.6644988, longitude: -2.7842759},
  CA12: {latitude: 54.6025378, longitude: -3.1344633},
  CA13: {latitude: 54.6598623, longitude: -3.3683706},
  CA14: {latitude: 54.6346926, longitude: -3.5380221},
  CA15: {latitude: 54.7122276, longitude: -3.4809087},
  CA16: {latitude: 54.5740293, longitude: -2.4838426},
  CA17: {latitude: 54.4800608, longitude: -2.3509231},
  CA18: {latitude: 54.3543145, longitude: -3.3912119},
  CA19: {latitude: 54.3869014, longitude: -3.3839245},
  CA2: {latitude: 54.8838592, longitude: -2.9512475},
  CA20: {latitude: 54.4104053, longitude: -3.4622406},
  CA21: {latitude: 54.4454251, longitude: -3.5163777},
  CA22: {latitude: 54.4806529, longitude: -3.5329009},
  CA23: {latitude: 54.5152203, longitude: -3.4929534},
  CA24: {latitude: 54.5154439, longitude: -3.5435607},
  CA25: {latitude: 54.5231026, longitude: -3.5191491},
  CA26: {latitude: 54.5445875, longitude: -3.4825948},
  CA27: {latitude: 54.4910171, longitude: -3.5934811},
  CA28: {latitude: 54.5435085, longitude: -3.5785239},
  CA3: {latitude: 54.9093172, longitude: -2.9402815},
  CA4: {latitude: 54.8471428, longitude: -2.8318231},
  CA5: {latitude: 54.85508, longitude: -3.0194131},
  CA6: {latitude: 54.9933146, longitude: -2.8949601},
  CA7: {latitude: 54.8076079, longitude: -3.2392072},
  CA8: {latitude: 54.9394064, longitude: -2.686449},
  CA9: {latitude: 54.8009692, longitude: -2.4136614},
  CA95: {latitude: 54.6446666, longitude: -3.5664497},
  CB1: {latitude: 52.1953297, longitude: 0.1420534},
  CB10: {latitude: 52.028753, longitude: 0.2627396},
  CB11: {latitude: 51.9992272, longitude: 0.2120024},
  CB2: {latitude: 52.1858693, longitude: 0.1231567},
  CB21: {latitude: 52.128038, longitude: 0.2815412},
  CB22: {latitude: 52.1284294, longitude: 0.1354878},
  CB23: {latitude: 52.2151042, longitude: -0.0318968},
  CB24: {latitude: 52.2782051, longitude: 0.0817273},
  CB25: {latitude: 52.2608073, longitude: 0.2541302},
  CB3: {latitude: 52.212482, longitude: 0.0981705},
  CB4: {latitude: 52.2229046, longitude: 0.1298349},
  CB5: {latitude: 52.2123417, longitude: 0.1539646},
  CB6: {latitude: 52.4046657, longitude: 0.2216208},
  CB7: {latitude: 52.3612799, longitude: 0.3252127},
  CB8: {latitude: 52.2302078, longitude: 0.4279081},
  CB9: {latitude: 52.0833705, longitude: 0.439697},
  CF10: {latitude: 51.4748057, longitude: -3.1731995},
  CF11: {latitude: 51.4724155, longitude: -3.1922157},
  CF14: {latitude: 51.5198959, longitude: -3.2042721},
  CF15: {latitude: 51.5333849, longitude: -3.271715},
  CF23: {latitude: 51.5146202, longitude: -3.1554545},
  CF24: {latitude: 51.4880332, longitude: -3.1619481},
  CF3: {latitude: 51.5203429, longitude: -3.1110728},
  CF30: {latitude: 51.5196309, longitude: -3.1195669},
  CF31: {latitude: 51.5088642, longitude: -3.5784949},
  CF32: {latitude: 51.5599583, longitude: -3.5842696},
  CF33: {latitude: 51.5255628, longitude: -3.6931827},
  CF34: {latitude: 51.610543, longitude: -3.6520832},
  CF35: {latitude: 51.5227048, longitude: -3.5254789},
  CF36: {latitude: 51.4850992, longitude: -3.6994938},
  CF37: {latitude: 51.6033134, longitude: -3.3343249},
  CF38: {latitude: 51.5605507, longitude: -3.3327717},
  CF39: {latitude: 51.5999318, longitude: -3.4255613},
  CF40: {latitude: 51.6203262, longitude: -3.4516265},
  CF41: {latitude: 51.64737, longitude: -3.4820101},
  CF42: {latitude: 51.667356, longitude: -3.5238408},
  CF43: {latitude: 51.6576285, longitude: -3.4504756},
  CF44: {latitude: 51.7182832, longitude: -3.4588338},
  CF45: {latitude: 51.6696017, longitude: -3.3622637},
  CF46: {latitude: 51.6647879, longitude: -3.300659},
  CF47: {latitude: 51.7515033, longitude: -3.3750262},
  CF48: {latitude: 51.7415755, longitude: -3.3715116},
  CF5: {latitude: 51.4829052, longitude: -3.2447881},
  CF61: {latitude: 51.4083951, longitude: -3.4812082},
  CF62: {latitude: 51.4039362, longitude: -3.310979},
  CF63: {latitude: 51.4122519, longitude: -3.2572808},
  CF64: {latitude: 51.4332091, longitude: -3.1917807},
  CF71: {latitude: 51.4609003, longitude: -3.4589993},
  CF72: {latitude: 51.5298928, longitude: -3.4021313},
  CF81: {latitude: 51.7017292, longitude: -3.2446317},
  CF82: {latitude: 51.6509975, longitude: -3.2379255},
  CF83: {latitude: 51.5867146, longitude: -3.2188145},
  CF91: {latitude: 51.4655659, longitude: -3.1939894},
  CF95: {latitude: 51.4811947, longitude: -3.1710394},
  CF99: {latitude: 51.464505, longitude: -3.16135},
  CH1: {latitude: 53.2022603, longitude: -2.9089758},
  CH2: {latitude: 53.2178821, longitude: -2.8689752},
  CH25: {latitude: 53.3970307, longitude: -3.01145},
  CH26: {latitude: 53.365703, longitude: -3.0659079},
  CH27: {latitude: 53.4197266, longitude: -3.0367611},
  CH28: {latitude: 53.4005658, longitude: -3.1119268},
  CH29: {latitude: 53.3901667, longitude: -3.1794125},
  CH3: {latitude: 53.1647192, longitude: -2.8197563},
  CH30: {latitude: 53.3789453, longitude: -3.0984344},
  CH31: {latitude: 53.3297, longitude: -3.0988332},
  CH32: {latitude: 53.3619659, longitude: -2.9976234},
  CH33: {latitude: 53.2905598, longitude: -3.0626386},
  CH34: {latitude: 53.2790404, longitude: -2.9050848},
  CH4: {latitude: 53.165525, longitude: -2.9481695},
  CH41: {latitude: 53.3942234, longitude: -3.0326994},
  CH42: {latitude: 53.3738774, longitude: -3.0227343},
  CH43: {latitude: 53.3843247, longitude: -3.0596357},
  CH44: {latitude: 53.415302, longitude: -3.0370999},
  CH45: {latitude: 53.4289247, longitude: -3.0517282},
  CH46: {latitude: 53.4039828, longitude: -3.1108625},
  CH47: {latitude: 53.3964675, longitude: -3.1691925},
  CH48: {latitude: 53.3701791, longitude: -3.1693842},
  CH49: {latitude: 53.3810989, longitude: -3.1039353},
  CH5: {latitude: 53.2040122, longitude: -3.04214},
  CH6: {latitude: 53.2492592, longitude: -3.1443958},
  CH60: {latitude: 53.32649, longitude: -3.0960749},
  CH61: {latitude: 53.3491491, longitude: -3.1020354},
  CH62: {latitude: 53.334283, longitude: -2.981572},
  CH63: {latitude: 53.3442867, longitude: -3.0125451},
  CH64: {latitude: 53.2882069, longitude: -3.0476231},
  CH65: {latitude: 53.2771085, longitude: -2.9018402},
  CH66: {latitude: 53.2774095, longitude: -2.9364965},
  CH7: {latitude: 53.1699651, longitude: -3.1322347},
  CH70: {latitude: 53.1927439, longitude: -2.9225567},
  CH8: {latitude: 53.2830042, longitude: -3.2465239},
  CH88: {latitude: 53.1945673, longitude: -2.874551},
  CH99: {latitude: 53.1763583, longitude: -2.8948703},
  CM0: {latitude: 51.6627266, longitude: 0.8342244},
  CM1: {latitude: 51.7467319, longitude: 0.4577894},
  CM11: {latitude: 51.6235893, longitude: 0.4459616},
  CM12: {latitude: 51.6282277, longitude: 0.4145027},
  CM13: {latitude: 51.6152603, longitude: 0.3385145},
  CM14: {latitude: 51.6186789, longitude: 0.2921453},
  CM15: {latitude: 51.6443998, longitude: 0.3035113},
  CM16: {latitude: 51.7002877, longitude: 0.1200906},
  CM17: {latitude: 51.7731801, longitude: 0.1464635},
  CM18: {latitude: 51.7552911, longitude: 0.1060047},
  CM19: {latitude: 51.7594581, longitude: 0.0711651},
  CM2: {latitude: 51.7208592, longitude: 0.4866343},
  CM20: {latitude: 51.7753987, longitude: 0.1026721},
  CM21: {latitude: 51.8122758, longitude: 0.1452281},
  CM22: {latitude: 51.8657844, longitude: 0.2271806},
  CM23: {latitude: 51.872518, longitude: 0.1583719},
  CM24: {latitude: 51.8992323, longitude: 0.2039133},
  CM3: {latitude: 51.7211161, longitude: 0.5842087},
  CM4: {latitude: 51.6750757, longitude: 0.3903574},
  CM5: {latitude: 51.7217242, longitude: 0.2482353},
  CM6: {latitude: 51.8783006, longitude: 0.3661906},
  CM7: {latitude: 51.897274, longitude: 0.5373554},
  CM77: {latitude: 51.8667384, longitude: 0.5523052},
  CM8: {latitude: 51.8055915, longitude: 0.6374042},
  CM9: {latitude: 51.7408752, longitude: 0.7010671},
  CM92: {latitude: 51.7693558, longitude: 0.0612532},
  CM98: {latitude: 51.7521007, longitude: 0.5184271},
  CM99: {latitude: 51.7424938, longitude: 0.5005836},
  CO1: {latitude: 51.8840222, longitude: 0.8963748},
  CO10: {latitude: 52.058478, longitude: 0.7211086},
  CO11: {latitude: 51.942012, longitude: 1.0767083},
  CO12: {latitude: 51.9312042, longitude: 1.2528957},
  CO13: {latitude: 51.8389206, longitude: 1.2367597},
  CO14: {latitude: 51.8502715, longitude: 1.2671935},
  CO15: {latitude: 51.7963698, longitude: 1.1548306},
  CO16: {latitude: 51.8219619, longitude: 1.1229273},
  CO2: {latitude: 51.8697798, longitude: 0.8943735},
  CO3: {latitude: 51.88449, longitude: 0.8563017},
  CO4: {latitude: 51.9091409, longitude: 0.9196829},
  CO5: {latitude: 51.8152485, longitude: 0.8199292},
  CO6: {latitude: 51.9252061, longitude: 0.7920011},
  CO7: {latitude: 51.8816629, longitude: 1.0052818},
  CO8: {latitude: 51.9733754, longitude: 0.7656644},
  CO9: {latitude: 51.9689789, longitude: 0.6094407},
  CR0: {latitude: 51.3732242, longitude: -0.0775432},
  CR2: {latitude: 51.3480184, longitude: -0.0820678},
  CR3: {latitude: 51.2881312, longitude: -0.0824599},
  CR4: {latitude: 51.4043894, longitude: -0.1591591},
  CR44: {latitude: 51.3823469, longitude: -0.1328753},
  CR5: {latitude: 51.311096, longitude: -0.1414477},
  CR6: {latitude: 51.3092312, longitude: -0.0527574},
  CR7: {latitude: 51.3991799, longitude: -0.1067344},
  CR8: {latitude: 51.3319133, longitude: -0.1138248},
  CR9: {latitude: 51.3740708, longitude: -0.098286},
  CR90: {latitude: 51.3780681, longitude: -0.113274},
  CT1: {latitude: 51.2776176, longitude: 1.0859171},
  CT10: {latitude: 51.3631369, longitude: 1.4294367},
  CT11: {latitude: 51.3360593, longitude: 1.4132445},
  CT12: {latitude: 51.3433748, longitude: 1.369083},
  CT13: {latitude: 51.2664408, longitude: 1.327004},
  CT14: {latitude: 51.2167502, longitude: 1.3854115},
  CT15: {latitude: 51.1725483, longitude: 1.2818765},
  CT16: {latitude: 51.1421367, longitude: 1.2992504},
  CT17: {latitude: 51.1291169, longitude: 1.2937687},
  CT18: {latitude: 51.1156399, longitude: 1.1492879},
  CT19: {latitude: 51.0890794, longitude: 1.1679444},
  CT2: {latitude: 51.2936699, longitude: 1.0799396},
  CT20: {latitude: 51.0798258, longitude: 1.1630593},
  CT21: {latitude: 51.0725975, longitude: 1.0760693},
  CT3: {latitude: 51.2768265, longitude: 1.2113391},
  CT4: {latitude: 51.2238425, longitude: 1.0647403},
  CT5: {latitude: 51.3534291, longitude: 1.0349292},
  CT50: {latitude: 51.0795333, longitude: 1.1435601},
  CT6: {latitude: 51.3644106, longitude: 1.1295235},
  CT7: {latitude: 51.3704017, longitude: 1.2964069},
  CT8: {latitude: 51.3799305, longitude: 1.3366875},
  CT9: {latitude: 51.3833635, longitude: 1.389298},
  CV1: {latitude: 52.4094028, longitude: -1.5065272},
  CV10: {latitude: 52.5260857, longitude: -1.502331},
  CV11: {latitude: 52.5198747, longitude: -1.453464},
  CV12: {latitude: 52.4789841, longitude: -1.4724008},
  CV13: {latitude: 52.6173527, longitude: -1.413049},
  CV2: {latitude: 52.4244967, longitude: -1.4635562},
  CV21: {latitude: 52.3768752, longitude: -1.25063},
  CV22: {latitude: 52.359079, longitude: -1.2784656},
  CV23: {latitude: 52.3683793, longitude: -1.2835273},
  CV3: {latitude: 52.3909775, longitude: -1.4781403},
  CV31: {latitude: 52.2778388, longitude: -1.5246631},
  CV32: {latitude: 52.2979862, longitude: -1.531491},
  CV33: {latitude: 52.2554168, longitude: -1.4875182},
  CV34: {latitude: 52.2816351, longitude: -1.5783799},
  CV35: {latitude: 52.2215666, longitude: -1.593202},
  CV36: {latitude: 52.0590955, longitude: -1.6218655},
  CV37: {latitude: 52.1827385, longitude: -1.715127},
  CV4: {latitude: 52.3972327, longitude: -1.5714648},
  CV47: {latitude: 52.2354306, longitude: -1.3854686},
  CV5: {latitude: 52.412484, longitude: -1.555389},
  CV6: {latitude: 52.4341647, longitude: -1.5074757},
  CV7: {latitude: 52.446762, longitude: -1.569683},
  CV8: {latitude: 52.3519562, longitude: -1.5420194},
  CV9: {latitude: 52.5861653, longitude: -1.5616215},
  CW1: {latitude: 53.1036281, longitude: -2.4360889},
  CW10: {latitude: 53.1887768, longitude: -2.4436061},
  CW11: {latitude: 53.1431937, longitude: -2.3673649},
  CW12: {latitude: 53.1659013, longitude: -2.2135769},
  CW2: {latitude: 53.0798218, longitude: -2.4465966},
  CW3: {latitude: 52.9979416, longitude: -2.4084452},
  CW4: {latitude: 53.2088755, longitude: -2.3556124},
  CW5: {latitude: 53.0619376, longitude: -2.5221792},
  CW6: {latitude: 53.1625246, longitude: -2.6672351},
  CW7: {latitude: 53.1899294, longitude: -2.5290755},
  CW8: {latitude: 53.2534481, longitude: -2.5652379},
  CW9: {latitude: 53.2584003, longitude: -2.5017811},
  CW98: {latitude: 53.0886586, longitude: -2.4311449},
  DA1: {latitude: 51.4480982, longitude: 0.209464},
  DA10: {latitude: 51.4417805, longitude: 0.3049871},
  DA11: {latitude: 51.4344917, longitude: 0.3506663},
  DA12: {latitude: 51.4278035, longitude: 0.3871907},
  DA13: {latitude: 51.3784991, longitude: 0.3518275},
  DA14: {latitude: 51.4250037, longitude: 0.1117751},
  DA15: {latitude: 51.4414641, longitude: 0.0981804},
  DA16: {latitude: 51.4648617, longitude: 0.1062654},
  DA17: {latitude: 51.4861908, longitude: 0.1491035},
  DA18: {latitude: 51.4942848, longitude: 0.1364966},
  DA2: {latitude: 51.4320776, longitude: 0.2331447},
  DA3: {latitude: 51.3841204, longitude: 0.3083751},
  DA4: {latitude: 51.3885873, longitude: 0.232219},
  DA5: {latitude: 51.4406947, longitude: 0.1461798},
  DA6: {latitude: 51.4551736, longitude: 0.1388193},
  DA7: {latitude: 51.4656011, longitude: 0.1459735},
  DA8: {latitude: 51.4757724, longitude: 0.1758771},
  DA9: {latitude: 51.4481337, longitude: 0.2783186},
  DD1: {latitude: 56.4610055, longitude: -2.9764463},
  DD10: {latitude: 56.7487217, longitude: -2.4270468},
  DD11: {latitude: 56.5735539, longitude: -2.5990122},
  DD2: {latitude: 56.4703225, longitude: -3.0317411},
  DD3: {latitude: 56.4831651, longitude: -2.9898945},
  DD4: {latitude: 56.4821151, longitude: -2.935612},
  DD5: {latitude: 56.4799789, longitude: -2.8580673},
  DD6: {latitude: 56.4363293, longitude: -2.9262534},
  DD7: {latitude: 56.5028985, longitude: -2.7195271},
  DD8: {latitude: 56.6558721, longitude: -2.9220215},
  DD9: {latitude: 56.7482711, longitude: -2.6683631},
  DE1: {latitude: 52.9221535, longitude: -1.4774894},
  DE11: {latitude: 52.7727609, longitude: -1.556556},
  DE12: {latitude: 52.7233343, longitude: -1.5535436},
  DE13: {latitude: 52.8072661, longitude: -1.6937154},
  DE14: {latitude: 52.8047417, longitude: -1.643379},
  DE15: {latitude: 52.7980963, longitude: -1.6087583},
  DE21: {latitude: 52.9340572, longitude: -1.4320438},
  DE22: {latitude: 52.9340758, longitude: -1.4996719},
  DE23: {latitude: 52.9003792, longitude: -1.4978936},
  DE24: {latitude: 52.8891675, longitude: -1.4528507},
  DE3: {latitude: 52.9096926, longitude: -1.5425124},
  DE4: {latitude: 53.1268023, longitude: -1.5654429},
  DE45: {latitude: 53.2147846, longitude: -1.6782889},
  DE5: {latitude: 53.0449455, longitude: -1.4028946},
  DE55: {latitude: 53.1022937, longitude: -1.3722605},
  DE56: {latitude: 53.0219424, longitude: -1.4750676},
  DE6: {latitude: 52.9922845, longitude: -1.7179509},
  DE65: {latitude: 52.8669174, longitude: -1.6116951},
  DE7: {latitude: 52.9734328, longitude: -1.3232261},
  DE72: {latitude: 52.8931608, longitude: -1.3588522},
  DE73: {latitude: 52.8472038, longitude: -1.438215},
  DE74: {latitude: 52.8395922, longitude: -1.3258768},
  DE75: {latitude: 53.0130721, longitude: -1.3543073},
  DE99: {latitude: 52.9150384, longitude: -1.4661393},
  DG1: {latitude: 55.0735752, longitude: -3.5817215},
  DG10: {latitude: 55.3200502, longitude: -3.4381997},
  DG11: {latitude: 55.113619, longitude: -3.3386407},
  DG12: {latitude: 54.9901401, longitude: -3.2513519},
  DG13: {latitude: 55.1733051, longitude: -3.0305281},
  DG14: {latitude: 55.0819733, longitude: -2.9826094},
  DG16: {latitude: 54.9971615, longitude: -3.0685694},
  DG2: {latitude: 55.0646623, longitude: -3.6588521},
  DG3: {latitude: 55.237439, longitude: -3.799286},
  DG4: {latitude: 55.3754906, longitude: -3.9527786},
  DG5: {latitude: 54.9212114, longitude: -3.8110519},
  DG6: {latitude: 54.8371503, longitude: -4.0555469},
  DG7: {latitude: 54.9685747, longitude: -4.0135194},
  DG8: {latitude: 54.8722279, longitude: -4.5163917},
  DG9: {latitude: 54.8777681, longitude: -5.0228028},
  DH1: {latitude: 54.7820794, longitude: -1.565542},
  DH2: {latitude: 54.8597025, longitude: -1.5995581},
  DH3: {latitude: 54.8727478, longitude: -1.5679921},
  DH4: {latitude: 54.8540433, longitude: -1.4925925},
  DH5: {latitude: 54.8232696, longitude: -1.4551478},
  DH6: {latitude: 54.7527793, longitude: -1.4640636},
  DH7: {latitude: 54.7897219, longitude: -1.6660103},
  DH8: {latitude: 54.8569909, longitude: -1.8504107},
  DH9: {latitude: 54.8684514, longitude: -1.7109643},
  DH97: {latitude: 54.7927104, longitude: -1.5351133},
  DH98: {latitude: 54.8873334, longitude: -1.5884088},
  DH99: {latitude: 54.7882304, longitude: -1.5493991},
  DL1: {latitude: 54.529558, longitude: -1.5387005},
  DL10: {latitude: 54.4138943, longitude: -1.6913727},
  DL11: {latitude: 54.4394631, longitude: -1.876604},
  DL12: {latitude: 54.5721304, longitude: -1.9855857},
  DL13: {latitude: 54.7169113, longitude: -1.9573372},
  DL14: {latitude: 54.6515089, longitude: -1.6921535},
  DL15: {latitude: 54.7109706, longitude: -1.7302545},
  DL16: {latitude: 54.6989434, longitude: -1.6056739},
  DL17: {latitude: 54.6805221, longitude: -1.5410837},
  DL2: {latitude: 54.5282376, longitude: -1.5973398},
  DL3: {latitude: 54.5324842, longitude: -1.5715984},
  DL4: {latitude: 54.6301995, longitude: -1.6443807},
  DL5: {latitude: 54.6176722, longitude: -1.578451},
  DL6: {latitude: 54.371022, longitude: -1.3904975},
  DL7: {latitude: 54.3378836, longitude: -1.4855331},
  DL8: {latitude: 54.2928606, longitude: -1.7868123},
  DL9: {latitude: 54.3754022, longitude: -1.7075078},
  DL98: {latitude: 54.5275154, longitude: -1.5597017},
  DN1: {latitude: 53.5216788, longitude: -1.1307019},
  DN10: {latitude: 53.424485, longitude: -0.9350013},
  DN11: {latitude: 53.448826, longitude: -1.0821884},
  DN12: {latitude: 53.4826131, longitude: -1.2241725},
  DN14: {latitude: 53.7086376, longitude: -0.9413185},
  DN15: {latitude: 53.6143425, longitude: -0.6522291},
  DN16: {latitude: 53.5674423, longitude: -0.6397388},
  DN17: {latitude: 53.5727238, longitude: -0.7059175},
  DN18: {latitude: 53.6811955, longitude: -0.4476705},
  DN19: {latitude: 53.6841316, longitude: -0.3604471},
  DN2: {latitude: 53.5337629, longitude: -1.1026264},
  DN20: {latitude: 53.5580271, longitude: -0.5063124},
  DN21: {latitude: 53.4200117, longitude: -0.7020715},
  DN22: {latitude: 53.3237589, longitude: -0.9278773},
  DN3: {latitude: 53.546061, longitude: -1.059325},
  DN31: {latitude: 53.5699931, longitude: -0.0891049},
  DN32: {latitude: 53.5621163, longitude: -0.070213},
  DN33: {latitude: 53.5394663, longitude: -0.0990748},
  DN34: {latitude: 53.5573926, longitude: -0.1133186},
  DN35: {latitude: 53.5545579, longitude: -0.036351},
  DN36: {latitude: 53.5114674, longitude: -0.039586},
  DN37: {latitude: 53.5399911, longitude: -0.1383433},
  DN38: {latitude: 53.5604981, longitude: -0.3911523},
  DN39: {latitude: 53.6166111, longitude: -0.3355842},
  DN4: {latitude: 53.504999, longitude: -1.1211527},
  DN40: {latitude: 53.6210283, longitude: -0.2267379},
  DN41: {latitude: 53.581266, longitude: -0.1952465},
  DN5: {latitude: 53.538349, longitude: -1.1744232},
  DN55: {latitude: 53.5129234, longitude: -1.1257209},
  DN6: {latitude: 53.597914, longitude: -1.1785488},
  DN7: {latitude: 53.5833786, longitude: -1.01316},
  DN8: {latitude: 53.6152815, longitude: -0.9552368},
  DN9: {latitude: 53.5059237, longitude: -0.8929973},
  DT1: {latitude: 50.7118787, longitude: -2.4448216},
  DT10: {latitude: 50.9376061, longitude: -2.3343561},
  DT11: {latitude: 50.8615403, longitude: -2.1834102},
  DT2: {latitude: 50.7497424, longitude: -2.4509175},
  DT3: {latitude: 50.6422651, longitude: -2.4683307},
  DT4: {latitude: 50.6095897, longitude: -2.4654498},
  DT5: {latitude: 50.5488467, longitude: -2.4424653},
  DT6: {latitude: 50.7391695, longitude: -2.7754498},
  DT7: {latitude: 50.7294287, longitude: -2.9474704},
  DT8: {latitude: 50.8199071, longitude: -2.7589018},
  DT9: {latitude: 50.9420485, longitude: -2.5162283},
  DY1: {latitude: 52.5164236, longitude: -2.0965765},
  DY10: {latitude: 52.386159, longitude: -2.2238755},
  DY11: {latitude: 52.3845094, longitude: -2.2621081},
  DY12: {latitude: 52.3864341, longitude: -2.3329518},
  DY13: {latitude: 52.3367283, longitude: -2.2813551},
  DY14: {latitude: 52.3804492, longitude: -2.4685572},
  DY2: {latitude: 52.4963087, longitude: -2.0814401},
  DY3: {latitude: 52.5308396, longitude: -2.1312352},
  DY4: {latitude: 52.5328792, longitude: -2.0552638},
  DY5: {latitude: 52.4804556, longitude: -2.1239401},
  DY6: {latitude: 52.4984945, longitude: -2.1644135},
  DY7: {latitude: 52.466416, longitude: -2.2308062},
  DY8: {latitude: 52.460812, longitude: -2.1557543},
  DY9: {latitude: 52.4332065, longitude: -2.122508},
  E1: {latitude: 51.5173859, longitude: -0.0595023},
  E10: {latitude: 51.5679608, longitude: -0.0143353},
  E11: {latitude: 51.5686864, longitude: 0.0135501},
  E12: {latitude: 51.5507498, longitude: 0.0529473},
  E13: {latitude: 51.5278271, longitude: 0.0267009},
  E14: {latitude: 51.5061699, longitude: -0.0184998},
  E15: {latitude: 51.5402208, longitude: 0.0032141},
  E16: {latitude: 51.5105927, longitude: 0.0289721},
  E17: {latitude: 51.5869039, longitude: -0.0207805},
  E18: {latitude: 51.5927827, longitude: 0.0249672},
  E1W: {latitude: 51.5091122, longitude: -0.0589168},
  E2: {latitude: 51.5296098, longitude: -0.062627},
  E20: {latitude: 51.5465858, longitude: -0.0100095},
  E3: {latitude: 51.527941, longitude: -0.0252696},
  E4: {latitude: 51.6218323, longitude: -0.0057248},
  E5: {latitude: 51.5588861, longitude: -0.0537874},
  E6: {latitude: 51.5264995, longitude: 0.053874},
  E7: {latitude: 51.5471369, longitude: 0.027572},
  E8: {latitude: 51.5436904, longitude: -0.0661452},
  E9: {latitude: 51.5440387, longitude: -0.0430441},
  E98: {latitude: 51.5080232, longitude: -0.0644425},
  EC1A: {latitude: 51.5203315, longitude: -0.1039346},
  EC1M: {latitude: 51.5213505, longitude: -0.1023129},
  EC1N: {latitude: 51.5198912, longitude: -0.1087995},
  EC1P: {latitude: 51.524516, longitude: -0.1120727},
  EC1R: {latitude: 51.5249491, longitude: -0.1083725},
  EC1V: {latitude: 51.5268168, longitude: -0.0978016},
  EC1Y: {latitude: 51.5230455, longitude: -0.0924717},
  EC2A: {latitude: 51.5237066, longitude: -0.0855916},
  EC2M: {latitude: 51.5185932, longitude: -0.0862326},
  EC2N: {latitude: 51.5157712, longitude: -0.0855193},
  EC2P: {latitude: 51.5241889, longitude: -0.1110467},
  EC2R: {latitude: 51.5160606, longitude: -0.0909709},
  EC2V: {latitude: 51.5155673, longitude: -0.0937819},
  EC2Y: {latitude: 51.5194073, longitude: -0.0935545},
  EC3A: {latitude: 51.5147892, longitude: -0.0802178},
  EC3M: {latitude: 51.5118135, longitude: -0.0821665},
  EC3N: {latitude: 51.5119304, longitude: -0.0770379},
  EC3P: {latitude: 51.523986, longitude: -0.1104578},
  EC3R: {latitude: 51.5104555, longitude: -0.0835753},
  EC3V: {latitude: 51.5129745, longitude: -0.0858623},
  EC4A: {latitude: 51.5157778, longitude: -0.1082509},
  EC4M: {latitude: 51.5142792, longitude: -0.0993846},
  EC4N: {latitude: 51.5128988, longitude: -0.0914843},
  EC4P: {latitude: 51.5245399, longitude: -0.1120477},
  EC4R: {latitude: 51.5108121, longitude: -0.0904232},
  EC4V: {latitude: 51.5124476, longitude: -0.099878},
  EC4Y: {latitude: 51.512938, longitude: -0.1088079},
  EH1: {latitude: 55.9506608, longitude: -3.192931},
  EH10: {latitude: 55.9198652, longitude: -3.2111151},
  EH11: {latitude: 55.932686, longitude: -3.2518031},
  EH12: {latitude: 55.9418955, longitude: -3.279118},
  EH13: {latitude: 55.9067795, longitude: -3.2429491},
  EH14: {latitude: 55.9088677, longitude: -3.2859923},
  EH15: {latitude: 55.9462301, longitude: -3.1125696},
  EH16: {latitude: 55.922607, longitude: -3.1528183},
  EH17: {latitude: 55.9054568, longitude: -3.1436333},
  EH18: {latitude: 55.8768124, longitude: -3.122531},
  EH19: {latitude: 55.8724184, longitude: -3.105045},
  EH2: {latitude: 55.9522871, longitude: -3.2022387},
  EH20: {latitude: 55.8788332, longitude: -3.156757},
  EH21: {latitude: 55.9385173, longitude: -3.0462249},
  EH22: {latitude: 55.8850462, longitude: -3.0607492},
  EH23: {latitude: 55.8394658, longitude: -3.0509226},
  EH24: {latitude: 55.8496545, longitude: -3.1370136},
  EH25: {latitude: 55.8616321, longitude: -3.1749932},
  EH26: {latitude: 55.8334533, longitude: -3.2242391},
  EH27: {latitude: 55.8907993, longitude: -3.416388},
  EH28: {latitude: 55.9298906, longitude: -3.3887501},
  EH29: {latitude: 55.9568445, longitude: -3.4034273},
  EH3: {latitude: 55.9519117, longitude: -3.2070932},
  EH30: {latitude: 55.9856246, longitude: -3.3939638},
  EH31: {latitude: 56.0365209, longitude: -2.8267129},
  EH32: {latitude: 55.9674629, longitude: -2.9509183},
  EH33: {latitude: 55.9415591, longitude: -2.9458801},
  EH34: {latitude: 55.9082618, longitude: -2.8808453},
  EH35: {latitude: 55.9108636, longitude: -2.9447636},
  EH36: {latitude: 55.8555977, longitude: -2.8533193},
  EH37: {latitude: 55.8613517, longitude: -2.9598479},
  EH38: {latitude: 55.7773566, longitude: -2.9528897},
  EH39: {latitude: 56.0470676, longitude: -2.734215},
  EH4: {latitude: 55.9624129, longitude: -3.2608608},
  EH40: {latitude: 55.9907365, longitude: -2.6620483},
  EH41: {latitude: 55.9483721, longitude: -2.7767292},
  EH42: {latitude: 55.9935934, longitude: -2.5254885},
  EH43: {latitude: 55.6238505, longitude: -3.0113991},
  EH44: {latitude: 55.6191253, longitude: -3.0635531},
  EH45: {latitude: 55.6544414, longitude: -3.1908306},
  EH46: {latitude: 55.7404828, longitude: -3.3566775},
  EH47: {latitude: 55.8586358, longitude: -3.6661035},
  EH48: {latitude: 55.8989296, longitude: -3.6648047},
  EH49: {latitude: 55.9759491, longitude: -3.5978664},
  EH5: {latitude: 55.9760767, longitude: -3.2223197},
  EH51: {latitude: 56.0110331, longitude: -3.6055066},
  EH52: {latitude: 55.9383479, longitude: -3.485057},
  EH53: {latitude: 55.8947721, longitude: -3.4727519},
  EH54: {latitude: 55.8923064, longitude: -3.5243492},
  EH55: {latitude: 55.8464431, longitude: -3.5752962},
  EH6: {latitude: 55.9725098, longitude: -3.1753754},
  EH7: {latitude: 55.9602104, longitude: -3.1643887},
  EH8: {latitude: 55.9487133, longitude: -3.1641837},
  EH9: {latitude: 55.9330122, longitude: -3.1853241},
  EH91: {latitude: 55.9249779, longitude: -3.2986006},
  EH95: {latitude: 55.9786198, longitude: -3.2535203},
  EH99: {latitude: 55.947641, longitude: -3.2037715},
  EN1: {latitude: 51.6542098, longitude: -0.0680823},
  EN10: {latitude: 51.7381929, longitude: -0.023162},
  EN11: {latitude: 51.7655817, longitude: -0.0091349},
  EN2: {latitude: 51.6599921, longitude: -0.0941879},
  EN3: {latitude: 51.6604157, longitude: -0.0366574},
  EN4: {latitude: 51.6491899, longitude: -0.1605104},
  EN5: {latitude: 51.649944, longitude: -0.1975625},
  EN6: {latitude: 51.699489, longitude: -0.176714},
  EN7: {latitude: 51.7123101, longitude: -0.0696748},
  EN8: {latitude: 51.6992728, longitude: -0.0338619},
  EN9: {latitude: 51.6961713, longitude: 0.0149921},
  EX1: {latitude: 50.7280574, longitude: -3.5003048},
  EX10: {latitude: 50.6931776, longitude: -3.2466004},
  EX11: {latitude: 50.7468054, longitude: -3.2895514},
  EX12: {latitude: 50.7068721, longitude: -3.0818842},
  EX13: {latitude: 50.7871097, longitude: -3.0071442},
  EX14: {latitude: 50.8140317, longitude: -3.1914327},
  EX15: {latitude: 50.8776038, longitude: -3.3405027},
  EX16: {latitude: 50.9226683, longitude: -3.4916806},
  EX17: {latitude: 50.8116834, longitude: -3.7053311},
  EX18: {latitude: 50.9020189, longitude: -3.8876032},
  EX19: {latitude: 50.8780171, longitude: -4.005588},
  EX2: {latitude: 50.7095079, longitude: -3.5143056},
  EX20: {latitude: 50.7519249, longitude: -4.019293},
  EX21: {latitude: 50.8057129, longitude: -4.2086933},
  EX22: {latitude: 50.8277967, longitude: -4.3680718},
  EX23: {latitude: 50.8243103, longitude: -4.5328043},
  EX24: {latitude: 50.7404493, longitude: -3.0893775},
  EX3: {latitude: 50.6868408, longitude: -3.4596319},
  EX31: {latitude: 51.0857144, longitude: -4.068489},
  EX32: {latitude: 51.0718819, longitude: -4.020197},
  EX33: {latitude: 51.1152054, longitude: -4.1742651},
  EX34: {latitude: 51.1983243, longitude: -4.1058651},
  EX35: {latitude: 51.2239866, longitude: -3.8274296},
  EX36: {latitude: 51.0166843, longitude: -3.796052},
  EX37: {latitude: 50.9786853, longitude: -3.9538059},
  EX38: {latitude: 50.9439211, longitude: -4.1521992},
  EX39: {latitude: 51.015257, longitude: -4.2457737},
  EX4: {latitude: 50.7313128, longitude: -3.526701},
  EX5: {latitude: 50.7561717, longitude: -3.4348553},
  EX6: {latitude: 50.6765895, longitude: -3.5972315},
  EX7: {latitude: 50.5843718, longitude: -3.4706752},
  EX8: {latitude: 50.6297299, longitude: -3.4017306},
  EX9: {latitude: 50.6394596, longitude: -3.3240203},
  FK1: {latitude: 55.9851464, longitude: -3.7946922},
  FK10: {latitude: 56.1158189, longitude: -3.7831309},
  FK11: {latitude: 56.149895, longitude: -3.8517203},
  FK12: {latitude: 56.1525705, longitude: -3.8017465},
  FK13: {latitude: 56.1519068, longitude: -3.7398856},
  FK14: {latitude: 56.1671323, longitude: -3.6556229},
  FK15: {latitude: 56.2030762, longitude: -3.950473},
  FK16: {latitude: 56.1911637, longitude: -4.0610009},
  FK17: {latitude: 56.2399069, longitude: -4.219863},
  FK18: {latitude: 56.3246007, longitude: -4.3291315},
  FK19: {latitude: 56.3715398, longitude: -4.3126836},
  FK2: {latitude: 56.0050252, longitude: -3.7562534},
  FK20: {latitude: 56.4054262, longitude: -4.6401017},
  FK21: {latitude: 56.4659591, longitude: -4.3209044},
  FK3: {latitude: 56.0107515, longitude: -3.7207793},
  FK4: {latitude: 55.9964986, longitude: -3.9074569},
  FK5: {latitude: 56.0272594, longitude: -3.8224587},
  FK6: {latitude: 56.0212698, longitude: -3.9154287},
  FK7: {latitude: 56.0964876, longitude: -3.9179582},
  FK8: {latitude: 56.131702, longitude: -4.0593036},
  FK9: {latitude: 56.1448526, longitude: -3.9433641},
  FY1: {latitude: 53.8152768, longitude: -3.0470272},
  FY2: {latitude: 53.8459338, longitude: -3.0396623},
  FY3: {latitude: 53.8212841, longitude: -3.0204371},
  FY4: {latitude: 53.7909588, longitude: -3.0275782},
  FY5: {latitude: 53.8752307, longitude: -3.0218705},
  FY6: {latitude: 53.8680398, longitude: -2.981457},
  FY7: {latitude: 53.9159897, longitude: -3.0273891},
  FY8: {latitude: 53.7508559, longitude: -3.0027549},
  G1: {latitude: 55.8588265, longitude: -4.2488914},
  G11: {latitude: 55.8733357, longitude: -4.3129733},
  G12: {latitude: 55.8805484, longitude: -4.3006568},
  G13: {latitude: 55.893611, longitude: -4.3477509},
  G14: {latitude: 55.8804359, longitude: -4.350756},
  G15: {latitude: 55.9092917, longitude: -4.3662176},
  G2: {latitude: 55.862907, longitude: -4.2561591},
  G20: {latitude: 55.8858609, longitude: -4.2826493},
  G21: {latitude: 55.8822282, longitude: -4.2201317},
  G22: {latitude: 55.8907103, longitude: -4.2520148},
  G23: {latitude: 55.9024808, longitude: -4.2851022},
  G3: {latitude: 55.8658506, longitude: -4.2778116},
  G31: {latitude: 55.8566242, longitude: -4.2081326},
  G32: {latitude: 55.8488374, longitude: -4.1655409},
  G33: {latitude: 55.8741808, longitude: -4.1653486},
  G34: {latitude: 55.8679239, longitude: -4.1123443},
  G4: {latitude: 55.8676044, longitude: -4.2523731},
  G40: {latitude: 55.8474967, longitude: -4.2211184},
  G41: {latitude: 55.8376134, longitude: -4.2844564},
  G42: {latitude: 55.8321344, longitude: -4.2574366},
  G43: {latitude: 55.8184976, longitude: -4.2918152},
  G44: {latitude: 55.8141896, longitude: -4.2556442},
  G45: {latitude: 55.8049645, longitude: -4.2327269},
  G46: {latitude: 55.8033439, longitude: -4.3078361},
  G5: {latitude: 55.8479394, longitude: -4.252235},
  G51: {latitude: 55.8577477, longitude: -4.3165267},
  G52: {latitude: 55.8478068, longitude: -4.3502252},
  G53: {latitude: 55.8211417, longitude: -4.3526677},
  G58: {latitude: 55.8423713, longitude: -4.2906685},
  G60: {latitude: 55.9225474, longitude: -4.4557485},
  G61: {latitude: 55.9191422, longitude: -4.3315668},
  G62: {latitude: 55.9426842, longitude: -4.3208961},
  G63: {latitude: 56.0430198, longitude: -4.3655688},
  G64: {latitude: 55.9114153, longitude: -4.2170017},
  G65: {latitude: 55.9734685, longitude: -4.0575613},
  G66: {latitude: 55.9404977, longitude: -4.153923},
  G67: {latitude: 55.9466652, longitude: -3.9871989},
  G68: {latitude: 55.9529877, longitude: -4.0160663},
  G69: {latitude: 55.8756055, longitude: -4.1009988},
  G70: {latitude: 55.949877, longitude: -3.9879809},
  G71: {latitude: 55.8223628, longitude: -4.0748284},
  G72: {latitude: 55.8041894, longitude: -4.1294723},
  G73: {latitude: 55.8195192, longitude: -4.2065974},
  G74: {latitude: 55.7689037, longitude: -4.1752217},
  G75: {latitude: 55.7507329, longitude: -4.1985241},
  G76: {latitude: 55.7770362, longitude: -4.2730765},
  G77: {latitude: 55.7739434, longitude: -4.3319996},
  G78: {latitude: 55.7929059, longitude: -4.4098882},
  G79: {latitude: 55.7710036, longitude: -4.2230758},
  G81: {latitude: 55.9138295, longitude: -4.4077065},
  G82: {latitude: 55.9517278, longitude: -4.5740174},
  G83: {latitude: 56.0121497, longitude: -4.5869607},
  G84: {latitude: 56.0141483, longitude: -4.7557604},
  G9: {latitude: 55.86874, longitude: -4.243491},
  G90: {latitude: 55.8689906, longitude: -4.2410555},
  GL1: {latitude: 51.8593662, longitude: -2.2437389},
  GL10: {latitude: 51.7436973, longitude: -2.2870616},
  GL11: {latitude: 51.6901084, longitude: -2.357213},
  GL12: {latitude: 51.6242009, longitude: -2.3889711},
  GL13: {latitude: 51.692474, longitude: -2.4613325},
  GL14: {latitude: 51.8176681, longitude: -2.4811369},
  GL15: {latitude: 51.7369523, longitude: -2.551235},
  GL16: {latitude: 51.795578, longitude: -2.6128048},
  GL17: {latitude: 51.8552806, longitude: -2.5103348},
  GL18: {latitude: 51.9416934, longitude: -2.4150411},
  GL19: {latitude: 51.9461577, longitude: -2.2909682},
  GL2: {latitude: 51.8431569, longitude: -2.2702834},
  GL20: {latitude: 52.0022332, longitude: -2.132268},
  GL3: {latitude: 51.8619393, longitude: -2.1760821},
  GL4: {latitude: 51.8406968, longitude: -2.2188091},
  GL5: {latitude: 51.7381408, longitude: -2.2210178},
  GL50: {latitude: 51.900632, longitude: -2.0818521},
  GL51: {latitude: 51.8990355, longitude: -2.110465},
  GL52: {latitude: 51.9190904, longitude: -2.0581561},
  GL53: {latitude: 51.8795927, longitude: -2.0676025},
  GL54: {latitude: 51.8965086, longitude: -1.8457414},
  GL55: {latitude: 52.0639021, longitude: -1.7695409},
  GL56: {latitude: 51.9895485, longitude: -1.7034227},
  GL6: {latitude: 51.7343681, longitude: -2.1938197},
  GL7: {latitude: 51.7113826, longitude: -1.8967753},
  GL8: {latitude: 51.6425527, longitude: -2.1709169},
  GL9: {latitude: 51.5555981, longitude: -2.3033165},
  GU1: {latitude: 51.2430276, longitude: -0.564939},
  GU10: {latitude: 51.1965791, longitude: -0.7979139},
  GU11: {latitude: 51.2489707, longitude: -0.7634252},
  GU12: {latitude: 51.2517147, longitude: -0.7297556},
  GU14: {latitude: 51.2939331, longitude: -0.763558},
  GU15: {latitude: 51.3355019, longitude: -0.7376588},
  GU16: {latitude: 51.3095532, longitude: -0.7260287},
  GU17: {latitude: 51.3288028, longitude: -0.7891564},
  GU18: {latitude: 51.3483009, longitude: -0.6692481},
  GU19: {latitude: 51.3599273, longitude: -0.6919847},
  GU2: {latitude: 51.2457661, longitude: -0.5942024},
  GU20: {latitude: 51.3687408, longitude: -0.6579475},
  GU21: {latitude: 51.3210516, longitude: -0.5804072},
  GU22: {latitude: 51.3121626, longitude: -0.5517403},
  GU23: {latitude: 51.2940938, longitude: -0.5060248},
  GU24: {latitude: 51.3303573, longitude: -0.6282203},
  GU25: {latitude: 51.4011369, longitude: -0.5718272},
  GU26: {latitude: 51.1142993, longitude: -0.75038},
  GU27: {latitude: 51.0813045, longitude: -0.7216203},
  GU28: {latitude: 50.9910457, longitude: -0.6327655},
  GU29: {latitude: 50.9846389, longitude: -0.7477247},
  GU3: {latitude: 51.2467422, longitude: -0.6286183},
  GU30: {latitude: 51.0754992, longitude: -0.8042741},
  GU31: {latitude: 50.9969882, longitude: -0.90349},
  GU32: {latitude: 51.0090053, longitude: -0.9681798},
  GU33: {latitude: 51.0517463, longitude: -0.8903635},
  GU34: {latitude: 51.138975, longitude: -0.9871214},
  GU35: {latitude: 51.1167316, longitude: -0.8490969},
  GU4: {latitude: 51.2432497, longitude: -0.5403949},
  GU46: {latitude: 51.3385812, longitude: -0.8320474},
  GU47: {latitude: 51.3494201, longitude: -0.7920355},
  GU5: {latitude: 51.198914, longitude: -0.5097292},
  GU51: {latitude: 51.2843531, longitude: -0.8424509},
  GU52: {latitude: 51.2636841, longitude: -0.8386174},
  GU6: {latitude: 51.1405502, longitude: -0.4841941},
  GU7: {latitude: 51.1896186, longitude: -0.6121645},
  GU8: {latitude: 51.1486935, longitude: -0.6446799},
  GU9: {latitude: 51.219137, longitude: -0.7942479},
  HA0: {latitude: 51.5513241, longitude: -0.3056919},
  HA1: {latitude: 51.5799962, longitude: -0.3383049},
  HA2: {latitude: 51.5736982, longitude: -0.3612317},
  HA3: {latitude: 51.5937695, longitude: -0.3209409},
  HA4: {latitude: 51.5704138, longitude: -0.4107522},
  HA5: {latitude: 51.5949876, longitude: -0.3862778},
  HA6: {latitude: 51.6118666, longitude: -0.4224386},
  HA7: {latitude: 51.6113081, longitude: -0.3106331},
  HA8: {latitude: 51.6113532, longitude: -0.2739101},
  HA9: {latitude: 51.5607305, longitude: -0.2857817},
  HD1: {latitude: 53.6468691, longitude: -1.788934},
  HD2: {latitude: 53.668833, longitude: -1.7767268},
  HD3: {latitude: 53.6536196, longitude: -1.8320544},
  HD4: {latitude: 53.6256253, longitude: -1.797853},
  HD5: {latitude: 53.6474167, longitude: -1.7462168},
  HD6: {latitude: 53.7024215, longitude: -1.7843814},
  HD7: {latitude: 53.6239529, longitude: -1.8779019},
  HD8: {latitude: 53.5995424, longitude: -1.6750146},
  HD9: {latitude: 53.5804475, longitude: -1.7973107},
  HG1: {latitude: 53.9999818, longitude: -1.5353201},
  HG2: {latitude: 53.9855934, longitude: -1.5286679},
  HG3: {latitude: 54.0300146, longitude: -1.6178422},
  HG4: {latitude: 54.1569575, longitude: -1.5666498},
  HG5: {latitude: 54.013486, longitude: -1.4579043},
  HP1: {latitude: 51.7566422, longitude: -0.4869619},
  HP10: {latitude: 51.6083649, longitude: -0.6974711},
  HP11: {latitude: 51.6239518, longitude: -0.7453006},
  HP12: {latitude: 51.6259591, longitude: -0.7795608},
  HP13: {latitude: 51.6344818, longitude: -0.7404825},
  HP14: {latitude: 51.6524063, longitude: -0.8387317},
  HP15: {latitude: 51.6585214, longitude: -0.7117144},
  HP16: {latitude: 51.7022351, longitude: -0.7196191},
  HP17: {latitude: 51.7768478, longitude: -0.8843057},
  HP18: {latitude: 51.8202707, longitude: -0.9688388},
  HP19: {latitude: 51.8236624, longitude: -0.8280878},
  HP2: {latitude: 51.7643313, longitude: -0.4522784},
  HP20: {latitude: 51.8200483, longitude: -0.8054056},
  HP21: {latitude: 51.8052172, longitude: -0.8058581},
  HP22: {latitude: 51.8076076, longitude: -0.7693074},
  HP23: {latitude: 51.7954966, longitude: -0.6612615},
  HP27: {latitude: 51.7206955, longitude: -0.8325872},
  HP3: {latitude: 51.7359452, longitude: -0.4707053},
  HP4: {latitude: 51.7678331, longitude: -0.5685998},
  HP5: {latitude: 51.7128444, longitude: -0.6085614},
  HP6: {latitude: 51.6783912, longitude: -0.5991444},
  HP7: {latitude: 51.6644833, longitude: -0.6102425},
  HP8: {latitude: 51.6384149, longitude: -0.5700237},
  HP9: {latitude: 51.6103131, longitude: -0.6407522},
  HR1: {latitude: 52.0590736, longitude: -2.6797236},
  HR2: {latitude: 52.0098796, longitude: -2.7854912},
  HR3: {latitude: 52.0939594, longitude: -3.0850031},
  HR4: {latitude: 52.0905547, longitude: -2.7712966},
  HR5: {latitude: 52.196357, longitude: -3.0367417},
  HR6: {latitude: 52.2333219, longitude: -2.7731407},
  HR7: {latitude: 52.1855201, longitude: -2.5236492},
  HR8: {latitude: 52.0447156, longitude: -2.4453658},
  HR9: {latitude: 51.9077349, longitude: -2.5827297},
  HS1: {latitude: 58.2126144, longitude: -6.3814786},
  HS2: {latitude: 58.2483484, longitude: -6.4631996},
  HS3: {latitude: 57.8774467, longitude: -6.8512421},
  HS4: {latitude: 57.87087, longitude: -6.6963068},
  HS5: {latitude: 57.7653976, longitude: -7.0112702},
  HS6: {latitude: 57.601656, longitude: -7.3011311},
  HS7: {latitude: 57.4472485, longitude: -7.340699},
  HS8: {latitude: 57.2352236, longitude: -7.3470515},
  HS9: {latitude: 56.9730005, longitude: -7.4722587},
  HU1: {latitude: 53.7428033, longitude: -0.3379367},
  HU10: {latitude: 53.7515019, longitude: -0.4418264},
  HU11: {latitude: 53.8275962, longitude: -0.2216762},
  HU12: {latitude: 53.7238645, longitude: -0.1267684},
  HU13: {latitude: 53.725529, longitude: -0.4386443},
  HU14: {latitude: 53.728421, longitude: -0.4993848},
  HU15: {latitude: 53.7485753, longitude: -0.6207806},
  HU16: {latitude: 53.7815431, longitude: -0.4222631},
  HU17: {latitude: 53.8467937, longitude: -0.4287013},
  HU18: {latitude: 53.9099131, longitude: -0.1689549},
  HU19: {latitude: 53.7233393, longitude: 0.0344319},
  HU2: {latitude: 53.7507551, longitude: -0.3406848},
  HU20: {latitude: 53.787867, longitude: -0.5117995},
  HU3: {latitude: 53.7423203, longitude: -0.3676664},
  HU4: {latitude: 53.7362344, longitude: -0.4040642},
  HU5: {latitude: 53.7599562, longitude: -0.3761886},
  HU6: {latitude: 53.781012, longitude: -0.3713507},
  HU7: {latitude: 53.7909078, longitude: -0.3292706},
  HU8: {latitude: 53.7694364, longitude: -0.2996667},
  HU9: {latitude: 53.7560073, longitude: -0.289433},
  HX1: {latitude: 53.7210243, longitude: -1.8716182},
  HX2: {latitude: 53.7385491, longitude: -1.9066236},
  HX3: {latitude: 53.7267217, longitude: -1.844259},
  HX4: {latitude: 53.6770659, longitude: -1.8826642},
  HX5: {latitude: 53.6845992, longitude: -1.8352938},
  HX6: {latitude: 53.6968778, longitude: -1.927434},
  HX7: {latitude: 53.7392443, longitude: -2.0085802},
  IG1: {latitude: 51.5594197, longitude: 0.0733642},
  IG10: {latitude: 51.6484187, longitude: 0.0659951},
  IG11: {latitude: 51.5350133, longitude: 0.0932901},
  IG2: {latitude: 51.5760405, longitude: 0.0815331},
  IG3: {latitude: 51.5631159, longitude: 0.1029088},
  IG4: {latitude: 51.5800576, longitude: 0.0512052},
  IG5: {latitude: 51.5911739, longitude: 0.063456},
  IG6: {latitude: 51.5960763, longitude: 0.0877543},
  IG7: {latitude: 51.6143123, longitude: 0.0956944},
  IG8: {latitude: 51.6100214, longitude: 0.0381164},
  IG9: {latitude: 51.6258577, longitude: 0.0402651},
  IP1: {latitude: 52.0668563, longitude: 1.13956},
  IP10: {latitude: 52.0189774, longitude: 1.2699895},
  IP11: {latitude: 51.9675191, longitude: 1.3411933},
  IP12: {latitude: 52.0933236, longitude: 1.3698157},
  IP13: {latitude: 52.18917, longitude: 1.3206039},
  IP14: {latitude: 52.206002, longitude: 1.0312375},
  IP15: {latitude: 52.1562567, longitude: 1.595477},
  IP16: {latitude: 52.2041101, longitude: 1.5840513},
  IP17: {latitude: 52.2304463, longitude: 1.5018473},
  IP18: {latitude: 52.3304822, longitude: 1.6707696},
  IP19: {latitude: 52.3402509, longitude: 1.4942442},
  IP2: {latitude: 52.0452602, longitude: 1.1338136},
  IP20: {latitude: 52.4065354, longitude: 1.3191966},
  IP21: {latitude: 52.3648604, longitude: 1.2367254},
  IP22: {latitude: 52.3759592, longitude: 1.0527441},
  IP23: {latitude: 52.3073907, longitude: 1.1200031},
  IP24: {latitude: 52.419832, longitude: 0.757916},
  IP25: {latitude: 52.5865973, longitude: 0.8391576},
  IP26: {latitude: 52.5074578, longitude: 0.5727044},
  IP27: {latitude: 52.4302192, longitude: 0.5819065},
  IP28: {latitude: 52.3308885, longitude: 0.5278417},
  IP29: {latitude: 52.190897, longitude: 0.6587294},
  IP3: {latitude: 52.04135, longitude: 1.18801},
  IP30: {latitude: 52.209224, longitude: 0.8464525},
  IP31: {latitude: 52.2925866, longitude: 0.8356002},
  IP32: {latitude: 52.2546724, longitude: 0.7191907},
  IP33: {latitude: 52.2429658, longitude: 0.7086249},
  IP4: {latitude: 52.0604324, longitude: 1.1802287},
  IP5: {latitude: 52.0619388, longitude: 1.245372},
  IP6: {latitude: 52.1326541, longitude: 1.110843},
  IP7: {latitude: 52.0687092, longitude: 0.9424582},
  IP8: {latitude: 52.0630417, longitude: 1.0792503},
  IP9: {latitude: 51.9891921, longitude: 1.1472122},
  IP98: {latitude: 52.3765933, longitude: 1.1109271},
  IV1: {latitude: 57.4840542, longitude: -4.2347448},
  IV10: {latitude: 57.5845661, longitude: -4.1264965},
  IV11: {latitude: 57.677224, longitude: -4.0390588},
  IV12: {latitude: 57.5743529, longitude: -3.8644897},
  IV13: {latitude: 57.3421909, longitude: -4.0206217},
  IV14: {latitude: 57.5857945, longitude: -4.5489794},
  IV15: {latitude: 57.5993429, longitude: -4.4314883},
  IV16: {latitude: 57.6647729, longitude: -4.3379167},
  IV17: {latitude: 57.6989377, longitude: -4.2594791},
  IV18: {latitude: 57.7024425, longitude: -4.1548212},
  IV19: {latitude: 57.8039848, longitude: -4.0627885},
  IV2: {latitude: 57.4680582, longitude: -4.1860306},
  IV20: {latitude: 57.7885407, longitude: -3.9034344},
  IV21: {latitude: 57.7243122, longitude: -5.7211462},
  IV22: {latitude: 57.7387245, longitude: -5.5136528},
  IV23: {latitude: 57.7675158, longitude: -5.0094949},
  IV24: {latitude: 57.8912204, longitude: -4.3559987},
  IV25: {latitude: 57.8890332, longitude: -4.0419737},
  IV26: {latitude: 57.9267694, longitude: -5.193821},
  IV27: {latitude: 58.2764191, longitude: -4.7971051},
  IV28: {latitude: 58.0097064, longitude: -4.1581729},
  IV3: {latitude: 57.4764724, longitude: -4.2479131},
  IV30: {latitude: 57.6524753, longitude: -3.3254479},
  IV31: {latitude: 57.7169577, longitude: -3.2907466},
  IV32: {latitude: 57.630793, longitude: -3.1048715},
  IV36: {latitude: 57.6097384, longitude: -3.6074174},
  IV4: {latitude: 57.4508097, longitude: -4.5241263},
  IV40: {latitude: 57.2743006, longitude: -5.6473471},
  IV41: {latitude: 57.2728062, longitude: -5.7361569},
  IV42: {latitude: 57.2390335, longitude: -5.8330149},
  IV43: {latitude: 57.1555527, longitude: -5.8106214},
  IV44: {latitude: 57.1087675, longitude: -5.8827494},
  IV45: {latitude: 57.0717262, longitude: -5.9065595},
  IV46: {latitude: 57.111871, longitude: -5.9840485},
  IV47: {latitude: 57.2952228, longitude: -6.3443887},
  IV48: {latitude: 57.3130105, longitude: -6.1104379},
  IV49: {latitude: 57.2290084, longitude: -5.9436275},
  IV5: {latitude: 57.4684807, longitude: -4.410852},
  IV51: {latitude: 57.4741873, longitude: -6.2434474},
  IV52: {latitude: 57.3365804, longitude: -5.6530794},
  IV53: {latitude: 57.3443757, longitude: -5.554202},
  IV54: {latitude: 57.4304314, longitude: -5.6198002},
  IV55: {latitude: 57.4561945, longitude: -6.6097781},
  IV56: {latitude: 57.3655388, longitude: -6.4303864},
  IV6: {latitude: 57.5251331, longitude: -4.4589452},
  IV63: {latitude: 57.3047579, longitude: -4.5326314},
  IV7: {latitude: 57.5832458, longitude: -4.3867307},
  IV8: {latitude: 57.5541728, longitude: -4.2656627},
  IV9: {latitude: 57.5690237, longitude: -4.1786419},
  IV99: {latitude: 57.481332, longitude: -4.2239504},
  KA1: {latitude: 55.595248, longitude: -4.4975073},
  KA10: {latitude: 55.550437, longitude: -4.6476679},
  KA11: {latitude: 55.6186396, longitude: -4.6276773},
  KA12: {latitude: 55.6191336, longitude: -4.6651904},
  KA13: {latitude: 55.6556626, longitude: -4.7001607},
  KA14: {latitude: 55.7401813, longitude: -4.6733417},
  KA15: {latitude: 55.7484284, longitude: -4.6263497},
  KA16: {latitude: 55.6075033, longitude: -4.3282433},
  KA17: {latitude: 55.6106607, longitude: -4.2791346},
  KA18: {latitude: 55.4514123, longitude: -4.2427574},
  KA19: {latitude: 55.3460742, longitude: -4.6679946},
  KA2: {latitude: 55.5956268, longitude: -4.566525},
  KA20: {latitude: 55.6413789, longitude: -4.7511586},
  KA21: {latitude: 55.6421009, longitude: -4.7844006},
  KA22: {latitude: 55.6499957, longitude: -4.8088415},
  KA23: {latitude: 55.6934667, longitude: -4.8575881},
  KA24: {latitude: 55.7094358, longitude: -4.7157711},
  KA25: {latitude: 55.7533969, longitude: -4.6885437},
  KA26: {latitude: 55.2170854, longitude: -4.8357773},
  KA27: {latitude: 55.5386053, longitude: -5.174569},
  KA28: {latitude: 55.7540267, longitude: -4.925425},
  KA29: {latitude: 55.755735, longitude: -4.854085},
  KA3: {latitude: 55.6454507, longitude: -4.496797},
  KA30: {latitude: 55.7972875, longitude: -4.8634584},
  KA4: {latitude: 55.5991418, longitude: -4.3816208},
  KA5: {latitude: 55.5104356, longitude: -4.3878367},
  KA6: {latitude: 55.416235, longitude: -4.504737},
  KA7: {latitude: 55.4471342, longitude: -4.6304833},
  KA8: {latitude: 55.4717538, longitude: -4.612459},
  KA9: {latitude: 55.4972272, longitude: -4.6053308},
  KT1: {latitude: 51.4074987, longitude: -0.2982129},
  KT10: {latitude: 51.3695018, longitude: -0.3543868},
  KT11: {latitude: 51.3281995, longitude: -0.4028817},
  KT12: {latitude: 51.3773192, longitude: -0.4083965},
  KT13: {latitude: 51.368034, longitude: -0.4493546},
  KT14: {latitude: 51.3384121, longitude: -0.4882369},
  KT15: {latitude: 51.3637699, longitude: -0.4958004},
  KT16: {latitude: 51.3825678, longitude: -0.516428},
  KT17: {latitude: 51.3412, longitude: -0.2495666},
  KT18: {latitude: 51.3160216, longitude: -0.2633727},
  KT19: {latitude: 51.3525254, longitude: -0.2707598},
  KT2: {latitude: 51.4189252, longitude: -0.2906684},
  KT20: {latitude: 51.2864936, longitude: -0.2311279},
  KT21: {latitude: 51.3111901, longitude: -0.3035835},
  KT22: {latitude: 51.3015607, longitude: -0.3393496},
  KT23: {latitude: 51.2801634, longitude: -0.3756767},
  KT24: {latitude: 51.2701574, longitude: -0.4298101},
  KT3: {latitude: 51.3995791, longitude: -0.2574604},
  KT4: {latitude: 51.3784115, longitude: -0.243017},
  KT5: {latitude: 51.3906807, longitude: -0.2867503},
  KT6: {latitude: 51.38741, longitude: -0.3026903},
  KT7: {latitude: 51.3881177, longitude: -0.3337295},
  KT8: {latitude: 51.4015316, longitude: -0.3631647},
  KT9: {latitude: 51.3639202, longitude: -0.3032309},
  KW1: {latitude: 58.4566982, longitude: -3.1224058},
  KW10: {latitude: 57.9740723, longitude: -3.9787883},
  KW11: {latitude: 58.3080468, longitude: -4.1362061},
  KW12: {latitude: 58.5057403, longitude: -3.4926733},
  KW13: {latitude: 58.478332, longitude: -3.8949963},
  KW14: {latitude: 58.588615, longitude: -3.5547823},
  KW15: {latitude: 58.9800047, longitude: -2.9597106},
  KW16: {latitude: 58.9608956, longitude: -3.2768723},
  KW17: {latitude: 59.0364329, longitude: -3.0093093},
  KW2: {latitude: 58.3483934, longitude: -3.1636573},
  KW3: {latitude: 58.3064884, longitude: -3.2804565},
  KW5: {latitude: 58.2871721, longitude: -3.3827428},
  KW6: {latitude: 58.250139, longitude: -3.4446253},
  KW7: {latitude: 58.1867247, longitude: -3.5017376},
  KW8: {latitude: 58.1152848, longitude: -3.6650988},
  KW9: {latitude: 58.0136902, longitude: -3.8588509},
  KY1: {latitude: 56.1288777, longitude: -3.1375619},
  KY10: {latitude: 56.2307947, longitude: -2.700065},
  KY11: {latitude: 56.0485491, longitude: -3.4139256},
  KY12: {latitude: 56.0770695, longitude: -3.4965561},
  KY13: {latitude: 56.2084615, longitude: -3.4334289},
  KY14: {latitude: 56.3108245, longitude: -3.2419856},
  KY15: {latitude: 56.2993375, longitude: -3.05442},
  KY16: {latitude: 56.3425731, longitude: -2.8225656},
  KY2: {latitude: 56.1240311, longitude: -3.1846279},
  KY3: {latitude: 56.0637385, longitude: -3.2305775},
  KY4: {latitude: 56.1140341, longitude: -3.3630354},
  KY5: {latitude: 56.145365, longitude: -3.2948408},
  KY6: {latitude: 56.1974394, longitude: -3.200491},
  KY7: {latitude: 56.1977936, longitude: -3.1580986},
  KY8: {latitude: 56.1972496, longitude: -3.0126117},
  KY9: {latitude: 56.2091528, longitude: -2.8357263},
  KY99: {latitude: 56.0529028, longitude: -3.4360203},
  L1: {latitude: 53.4023772, longitude: -2.9804999},
  L10: {latitude: 53.4744835, longitude: -2.9266207},
  L11: {latitude: 53.4478258, longitude: -2.9154238},
  L12: {latitude: 53.4349803, longitude: -2.8958012},
  L13: {latitude: 53.4184709, longitude: -2.9204372},
  L14: {latitude: 53.4179489, longitude: -2.8808404},
  L15: {latitude: 53.3975793, longitude: -2.9205924},
  L16: {latitude: 53.3987049, longitude: -2.8874699},
  L17: {latitude: 53.3775853, longitude: -2.9406564},
  L18: {latitude: 53.3805747, longitude: -2.9083261},
  L19: {latitude: 53.3589357, longitude: -2.9033178},
  L2: {latitude: 53.4068628, longitude: -2.9899412},
  L20: {latitude: 53.4530856, longitude: -2.9890292},
  L21: {latitude: 53.4713811, longitude: -3.0003559},
  L22: {latitude: 53.4772218, longitude: -3.0279256},
  L23: {latitude: 53.4909653, longitude: -3.023793},
  L24: {latitude: 53.3434469, longitude: -2.8391389},
  L25: {latitude: 53.3788522, longitude: -2.8636656},
  L26: {latitude: 53.3645787, longitude: -2.8330565},
  L27: {latitude: 53.3877426, longitude: -2.838985},
  L28: {latitude: 53.4353243, longitude: -2.8656215},
  L29: {latitude: 53.5075951, longitude: -2.9855216},
  L3: {latitude: 53.4084083, longitude: -2.984451},
  L30: {latitude: 53.4845057, longitude: -2.9725553},
  L31: {latitude: 53.5134057, longitude: -2.9378113},
  L32: {latitude: 53.4783273, longitude: -2.889272},
  L33: {latitude: 53.4900539, longitude: -2.8768007},
  L34: {latitude: 53.435385, longitude: -2.8154652},
  L35: {latitude: 53.4151247, longitude: -2.7828814},
  L36: {latitude: 53.4144065, longitude: -2.841731},
  L37: {latitude: 53.5571245, longitude: -3.0636989},
  L38: {latitude: 53.5244465, longitude: -3.0511596},
  L39: {latitude: 53.5617461, longitude: -2.8964099},
  L4: {latitude: 53.437841, longitude: -2.9612931},
  L40: {latitude: 53.6031134, longitude: -2.8417029},
  L5: {latitude: 53.4248813, longitude: -2.9771396},
  L6: {latitude: 53.4189254, longitude: -2.9515685},
  L67: {latitude: 53.4499811, longitude: -2.9424012},
  L68: {latitude: 53.4730536, longitude: -2.9606906},
  L69: {latitude: 53.3874418, longitude: -2.9746703},
  L7: {latitude: 53.4057417, longitude: -2.9499885},
  L70: {latitude: 53.4040997, longitude: -2.9567513},
  L71: {latitude: 53.4346302, longitude: -2.9747137},
  L72: {latitude: 53.4772447, longitude: -2.9780099},
  L74: {latitude: 53.3930523, longitude: -2.9882833},
  L75: {latitude: 53.4377607, longitude: -2.9862275},
  L8: {latitude: 53.3898761, longitude: -2.9636387},
  L80: {latitude: 53.4692073, longitude: -2.9690856},
  L9: {latitude: 53.4613892, longitude: -2.9536021},
  LA1: {latitude: 54.0467054, longitude: -2.7994612},
  LA10: {latitude: 54.3138033, longitude: -2.4939771},
  LA11: {latitude: 54.199939, longitude: -2.9260474},
  LA12: {latitude: 54.2031951, longitude: -3.0836203},
  LA13: {latitude: 54.1182576, longitude: -3.1983726},
  LA14: {latitude: 54.1182959, longitude: -3.2311912},
  LA15: {latitude: 54.1558463, longitude: -3.1796666},
  LA16: {latitude: 54.187593, longitude: -3.2030115},
  LA17: {latitude: 54.2395573, longitude: -3.1758678},
  LA18: {latitude: 54.2154222, longitude: -3.2760572},
  LA19: {latitude: 54.2966419, longitude: -3.3802097},
  LA2: {latitude: 54.0661829, longitude: -2.6713879},
  LA20: {latitude: 54.2942675, longitude: -3.2062137},
  LA21: {latitude: 54.3628108, longitude: -3.0785695},
  LA22: {latitude: 54.4229898, longitude: -2.9912561},
  LA23: {latitude: 54.3713964, longitude: -2.9129454},
  LA3: {latitude: 54.0498853, longitude: -2.8793403},
  LA4: {latitude: 54.0702298, longitude: -2.8525004},
  LA5: {latitude: 54.1438808, longitude: -2.7918796},
  LA6: {latitude: 54.1754174, longitude: -2.6103862},
  LA7: {latitude: 54.2257341, longitude: -2.7730264},
  LA8: {latitude: 54.3238097, longitude: -2.7619094},
  LA9: {latitude: 54.3254145, longitude: -2.743368},
  LD1: {latitude: 52.2607456, longitude: -3.3662735},
  LD2: {latitude: 52.1422615, longitude: -3.3937041},
  LD3: {latitude: 51.9607697, longitude: -3.369993},
  LD4: {latitude: 52.1178244, longitude: -3.5568359},
  LD5: {latitude: 52.1264542, longitude: -3.6225562},
  LD6: {latitude: 52.3100474, longitude: -3.5092516},
  LD7: {latitude: 52.351601, longitude: -3.0907216},
  LD8: {latitude: 52.2645156, longitude: -3.0484652},
  LE1: {latitude: 52.6339706, longitude: -1.1326155},
  LE10: {latitude: 52.5368832, longitude: -1.3698567},
  LE11: {latitude: 52.7680459, longitude: -1.2191752},
  LE12: {latitude: 52.7677846, longitude: -1.191655},
  LE13: {latitude: 52.7660063, longitude: -0.8870665},
  LE14: {latitude: 52.7843462, longitude: -0.8971578},
  LE15: {latitude: 52.6564368, longitude: -0.7019964},
  LE16: {latitude: 52.4861071, longitude: -0.8959935},
  LE17: {latitude: 52.4675874, longitude: -1.1778293},
  LE18: {latitude: 52.5832335, longitude: -1.111972},
  LE19: {latitude: 52.5844805, longitude: -1.2064606},
  LE2: {latitude: 52.6073868, longitude: -1.1169519},
  LE21: {latitude: 52.627845, longitude: -1.1405305},
  LE3: {latitude: 52.6315445, longitude: -1.1772298},
  LE4: {latitude: 52.6646001, longitude: -1.1247758},
  LE41: {latitude: 52.6129239, longitude: -1.1949066},
  LE5: {latitude: 52.6383444, longitude: -1.0850557},
  LE55: {latitude: 52.6327983, longitude: -1.1253367},
  LE6: {latitude: 52.6570218, longitude: -1.2331852},
  LE65: {latitude: 52.7486524, longitude: -1.4694618},
  LE67: {latitude: 52.7156016, longitude: -1.362308},
  LE7: {latitude: 52.6800581, longitude: -1.0709886},
  LE8: {latitude: 52.5550348, longitude: -1.094569},
  LE87: {latitude: 52.6277023, longitude: -1.1336672},
  LE9: {latitude: 52.5730928, longitude: -1.2811778},
  LE94: {latitude: 52.4836845, longitude: -0.9055232},
  LE95: {latitude: 52.6061749, longitude: -1.1905604},
  LL11: {latitude: 53.0634765, longitude: -3.0362413},
  LL12: {latitude: 53.0875778, longitude: -2.9891854},
  LL13: {latitude: 53.0344913, longitude: -2.9590322},
  LL14: {latitude: 52.9909507, longitude: -3.0533052},
  LL15: {latitude: 53.1031832, longitude: -3.3161613},
  LL16: {latitude: 53.185191, longitude: -3.4330517},
  LL17: {latitude: 53.2523853, longitude: -3.4370183},
  LL18: {latitude: 53.3102991, longitude: -3.4760171},
  LL19: {latitude: 53.3311383, longitude: -3.4106208},
  LL20: {latitude: 52.9588899, longitude: -3.1607087},
  LL21: {latitude: 52.9900548, longitude: -3.4102899},
  LL22: {latitude: 53.2679053, longitude: -3.5977386},
  LL23: {latitude: 52.9052232, longitude: -3.6018542},
  LL24: {latitude: 53.0577084, longitude: -3.7859794},
  LL25: {latitude: 53.0537805, longitude: -3.8808964},
  LL26: {latitude: 53.1395034, longitude: -3.7857607},
  LL27: {latitude: 53.1485258, longitude: -3.8275336},
  LL28: {latitude: 53.2878956, longitude: -3.7618075},
  LL29: {latitude: 53.2891437, longitude: -3.7084555},
  LL30: {latitude: 53.3180209, longitude: -3.8162186},
  LL31: {latitude: 53.2903448, longitude: -3.8104002},
  LL32: {latitude: 53.2580548, longitude: -3.8411359},
  LL33: {latitude: 53.2507498, longitude: -3.9789879},
  LL34: {latitude: 53.2705627, longitude: -3.9145251},
  LL35: {latitude: 52.5467868, longitude: -4.0413751},
  LL36: {latitude: 52.6042624, longitude: -4.0644733},
  LL37: {latitude: 52.6659968, longitude: -4.0837468},
  LL38: {latitude: 52.6953036, longitude: -4.0503008},
  LL39: {latitude: 52.7102009, longitude: -4.0123647},
  LL40: {latitude: 52.7567851, longitude: -3.8749667},
  LL41: {latitude: 52.9694465, longitude: -3.9393403},
  LL42: {latitude: 52.7257676, longitude: -4.0552734},
  LL43: {latitude: 52.774527, longitude: -4.0923764},
  LL44: {latitude: 52.7909039, longitude: -4.0972031},
  LL45: {latitude: 52.8220907, longitude: -4.0961914},
  LL46: {latitude: 52.8552904, longitude: -4.1072866},
  LL47: {latitude: 52.9020279, longitude: -4.0628852},
  LL48: {latitude: 52.9360472, longitude: -4.0696243},
  LL49: {latitude: 52.9290448, longitude: -4.1379154},
  LL51: {latitude: 52.9740004, longitude: -4.2389782},
  LL52: {latitude: 52.9248691, longitude: -4.2409055},
  LL53: {latitude: 52.8841626, longitude: -4.4927499},
  LL54: {latitude: 53.0580643, longitude: -4.2875015},
  LL55: {latitude: 53.1332669, longitude: -4.2035215},
  LL56: {latitude: 53.1843564, longitude: -4.2059205},
  LL57: {latitude: 53.2068931, longitude: -4.1118949},
  LL58: {latitude: 53.2820716, longitude: -4.0992684},
  LL59: {latitude: 53.2357839, longitude: -4.1631557},
  LL60: {latitude: 53.2154645, longitude: -4.274545},
  LL61: {latitude: 53.1959058, longitude: -4.262625},
  LL62: {latitude: 53.2108742, longitude: -4.3859556},
  LL63: {latitude: 53.2184987, longitude: -4.4722288},
  LL64: {latitude: 53.2287185, longitude: -4.5183068},
  LL65: {latitude: 53.3010223, longitude: -4.5703675},
  LL66: {latitude: 53.3797968, longitude: -4.4083964},
  LL67: {latitude: 53.4111466, longitude: -4.4576366},
  LL68: {latitude: 53.3977575, longitude: -4.3794888},
  LL69: {latitude: 53.3860502, longitude: -4.3192563},
  LL70: {latitude: 53.3638741, longitude: -4.2877619},
  LL71: {latitude: 53.3295165, longitude: -4.3709519},
  LL72: {latitude: 53.352291, longitude: -4.2400479},
  LL73: {latitude: 53.3352368, longitude: -4.2449087},
  LL74: {latitude: 53.3191598, longitude: -4.2293713},
  LL75: {latitude: 53.2849805, longitude: -4.2166075},
  LL76: {latitude: 53.3007473, longitude: -4.2397465},
  LL77: {latitude: 53.2605503, longitude: -4.3124692},
  LL78: {latitude: 53.3174138, longitude: -4.2630432},
  LN1: {latitude: 53.2609265, longitude: -0.5924173},
  LN10: {latitude: 53.1584629, longitude: -0.2171187},
  LN11: {latitude: 53.3730382, longitude: 0.0260752},
  LN12: {latitude: 53.3292696, longitude: 0.2640547},
  LN13: {latitude: 53.265048, longitude: 0.1836393},
  LN2: {latitude: 53.2571394, longitude: -0.5062171},
  LN3: {latitude: 53.2418341, longitude: -0.4171042},
  LN4: {latitude: 53.1484011, longitude: -0.3799049},
  LN5: {latitude: 53.1742178, longitude: -0.5568934},
  LN6: {latitude: 53.2002374, longitude: -0.6001511},
  LN7: {latitude: 53.493235, longitude: -0.3455524},
  LN8: {latitude: 53.374899, longitude: -0.3265738},
  LN9: {latitude: 53.2172832, longitude: -0.1120184},
  LS1: {latitude: 53.7975973, longitude: -1.5516427},
  LS10: {latitude: 53.7622905, longitude: -1.5325445},
  LS11: {latitude: 53.776223, longitude: -1.5573555},
  LS12: {latitude: 53.7912186, longitude: -1.5972635},
  LS13: {latitude: 53.8108069, longitude: -1.635379},
  LS14: {latitude: 53.8275342, longitude: -1.4585135},
  LS15: {latitude: 53.8055008, longitude: -1.4450938},
  LS16: {latitude: 53.852089, longitude: -1.6036383},
  LS17: {latitude: 53.8600575, longitude: -1.5277566},
  LS18: {latitude: 53.8386122, longitude: -1.6395178},
  LS19: {latitude: 53.859728, longitude: -1.6839678},
  LS2: {latitude: 53.8028065, longitude: -1.5463049},
  LS20: {latitude: 53.8744534, longitude: -1.7157506},
  LS21: {latitude: 53.9116086, longitude: -1.6804367},
  LS22: {latitude: 53.9317926, longitude: -1.3956826},
  LS23: {latitude: 53.9003968, longitude: -1.3484233},
  LS24: {latitude: 53.8687779, longitude: -1.2530036},
  LS25: {latitude: 53.7858344, longitude: -1.3250023},
  LS26: {latitude: 53.7518196, longitude: -1.4495543},
  LS27: {latitude: 53.7486959, longitude: -1.6035106},
  LS28: {latitude: 53.8023004, longitude: -1.6700027},
  LS29: {latitude: 53.9189109, longitude: -1.800672},
  LS3: {latitude: 53.8023697, longitude: -1.5634257},
  LS4: {latitude: 53.8105301, longitude: -1.5848257},
  LS5: {latitude: 53.8209598, longitude: -1.6072846},
  LS6: {latitude: 53.8200966, longitude: -1.5707608},
  LS7: {latitude: 53.8205711, longitude: -1.5396576},
  LS8: {latitude: 53.8247746, longitude: -1.5094795},
  LS88: {latitude: 53.7653158, longitude: -1.5014304},
  LS9: {latitude: 53.7995059, longitude: -1.510182},
  LS98: {latitude: 53.7852835, longitude: -1.538512},
  LS99: {latitude: 53.7758971, longitude: -1.5465407},
  LU1: {latitude: 51.8744779, longitude: -0.4270575},
  LU2: {latitude: 51.8932427, longitude: -0.3944578},
  LU3: {latitude: 51.9086465, longitude: -0.4426142},
  LU4: {latitude: 51.8983235, longitude: -0.4686662},
  LU5: {latitude: 51.910954, longitude: -0.5140444},
  LU6: {latitude: 51.8780425, longitude: -0.5377989},
  LU7: {latitude: 51.9072379, longitude: -0.6629591},
  M1: {latitude: 53.4774963, longitude: -2.2362343},
  M11: {latitude: 53.4788514, longitude: -2.1812356},
  M12: {latitude: 53.4643203, longitude: -2.202117},
  M13: {latitude: 53.4604456, longitude: -2.2154546},
  M14: {latitude: 53.4484029, longitude: -2.2258291},
  M15: {latitude: 53.4673852, longitude: -2.2514891},
  M16: {latitude: 53.4551078, longitude: -2.2645745},
  M17: {latitude: 53.4680132, longitude: -2.3205539},
  M18: {latitude: 53.4613132, longitude: -2.1703934},
  M19: {latitude: 53.4364131, longitude: -2.1963069},
  M2: {latitude: 53.4804426, longitude: -2.2444104},
  M20: {latitude: 53.4241784, longitude: -2.232693},
  M21: {latitude: 53.4380163, longitude: -2.2729543},
  M22: {latitude: 53.3858702, longitude: -2.2600788},
  M23: {latitude: 53.399557, longitude: -2.288912},
  M24: {latitude: 53.5514675, longitude: -2.1982858},
  M25: {latitude: 53.5283859, longitude: -2.2757491},
  M26: {latitude: 53.5623031, longitude: -2.3348733},
  M27: {latitude: 53.5121147, longitude: -2.3364528},
  M28: {latitude: 53.5147094, longitude: -2.3993412},
  M29: {latitude: 53.5084109, longitude: -2.4581696},
  M3: {latitude: 53.4836687, longitude: -2.2528623},
  M30: {latitude: 53.4843432, longitude: -2.3551494},
  M31: {latitude: 53.4194153, longitude: -2.4242176},
  M32: {latitude: 53.4508922, longitude: -2.3094048},
  M33: {latitude: 53.4209662, longitude: -2.3262749},
  M34: {latitude: 53.4565302, longitude: -2.1185355},
  M35: {latitude: 53.5072006, longitude: -2.1549109},
  M38: {latitude: 53.5324424, longitude: -2.4232927},
  M4: {latitude: 53.4848676, longitude: -2.2300315},
  M40: {latitude: 53.5041026, longitude: -2.1909788},
  M41: {latitude: 53.4509537, longitude: -2.3655029},
  M43: {latitude: 53.4836761, longitude: -2.1491575},
  M44: {latitude: 53.4407447, longitude: -2.4271805},
  M45: {latitude: 53.5473467, longitude: -2.2903765},
  M46: {latitude: 53.5258654, longitude: -2.4922988},
  M5: {latitude: 53.479221, longitude: -2.2837555},
  M50: {latitude: 53.4749848, longitude: -2.2944426},
  M6: {latitude: 53.4926929, longitude: -2.2990621},
  M60: {latitude: 53.4844452, longitude: -2.2348172},
  M61: {latitude: 53.4865107, longitude: -2.2290529},
  M7: {latitude: 53.5054293, longitude: -2.2625151},
  M8: {latitude: 53.5086893, longitude: -2.2401019},
  M9: {latitude: 53.5220075, longitude: -2.2139408},
  M90: {latitude: 53.3635148, longitude: -2.2780731},
  M99: {latitude: 53.4848048, longitude: -2.2310186},
  ME1: {latitude: 51.3715824, longitude: 0.4975849},
  ME10: {latitude: 51.3436099, longitude: 0.735349},
  ME11: {latitude: 51.4129865, longitude: 0.7466942},
  ME12: {latitude: 51.4223196, longitude: 0.8043021},
  ME13: {latitude: 51.3036496, longitude: 0.8945604},
  ME14: {latitude: 51.2787626, longitude: 0.5435955},
  ME15: {latitude: 51.2532135, longitude: 0.5335779},
  ME16: {latitude: 51.273831, longitude: 0.4960741},
  ME17: {latitude: 51.2331334, longitude: 0.6111241},
  ME18: {latitude: 51.2417887, longitude: 0.4154143},
  ME19: {latitude: 51.2904715, longitude: 0.407949},
  ME2: {latitude: 51.3915327, longitude: 0.4815053},
  ME20: {latitude: 51.3033514, longitude: 0.4598919},
  ME3: {latitude: 51.4354568, longitude: 0.5468331},
  ME4: {latitude: 51.3814348, longitude: 0.5288721},
  ME5: {latitude: 51.348554, longitude: 0.532612},
  ME6: {latitude: 51.3228393, longitude: 0.4347653},
  ME7: {latitude: 51.379774, longitude: 0.5557972},
  ME8: {latitude: 51.3613848, longitude: 0.5967776},
  ME9: {latitude: 51.3358666, longitude: 0.7219229},
  ME99: {latitude: 51.2783241, longitude: 0.5190996},
  MK1: {latitude: 52.0055233, longitude: -0.7243816},
  MK10: {latitude: 52.0410506, longitude: -0.6982522},
  MK11: {latitude: 52.0510771, longitude: -0.8404949},
  MK12: {latitude: 52.0583718, longitude: -0.8166917},
  MK13: {latitude: 52.0532824, longitude: -0.7825057},
  MK14: {latitude: 52.0632325, longitude: -0.7553798},
  MK15: {latitude: 52.0568594, longitude: -0.729772},
  MK16: {latitude: 52.0896113, longitude: -0.7217314},
  MK17: {latitude: 51.997579, longitude: -0.6993948},
  MK18: {latitude: 51.978349, longitude: -0.9695075},
  MK19: {latitude: 52.0751348, longitude: -0.8552011},
  MK2: {latitude: 51.990521, longitude: -0.7252031},
  MK3: {latitude: 51.9937256, longitude: -0.7517663},
  MK4: {latitude: 52.0040459, longitude: -0.7842687},
  MK40: {latitude: 52.1378368, longitude: -0.4764099},
  MK41: {latitude: 52.1526153, longitude: -0.4477354},
  MK42: {latitude: 52.1173913, longitude: -0.4724081},
  MK43: {latitude: 52.1119082, longitude: -0.5583834},
  MK44: {latitude: 52.1965903, longitude: -0.4242789},
  MK45: {latitude: 52.0216132, longitude: -0.4703173},
  MK46: {latitude: 52.1557959, longitude: -0.7020457},
  MK5: {latitude: 52.0209076, longitude: -0.7846548},
  MK6: {latitude: 52.0295557, longitude: -0.7429696},
  MK7: {latitude: 52.0190228, longitude: -0.6913147},
  MK77: {latitude: 52.041499, longitude: -0.8172717},
  MK8: {latitude: 52.0330526, longitude: -0.8047638},
  MK9: {latitude: 52.0404, longitude: -0.754928},
  ML1: {latitude: 55.7990265, longitude: -3.9750481},
  ML10: {latitude: 55.6801214, longitude: -4.0692342},
  ML11: {latitude: 55.6671734, longitude: -3.7891903},
  ML12: {latitude: 55.5680243, longitude: -3.5951775},
  ML2: {latitude: 55.7768458, longitude: -3.9138139},
  ML3: {latitude: 55.7699883, longitude: -4.0550162},
  ML4: {latitude: 55.8183531, longitude: -4.0213658},
  ML5: {latitude: 55.8597936, longitude: -4.0317112},
  ML6: {latitude: 55.8677284, longitude: -3.9613387},
  ML7: {latitude: 55.8299394, longitude: -3.7954225},
  ML8: {latitude: 55.7314933, longitude: -3.8429126},
  ML9: {latitude: 55.7245642, longitude: -3.9676426},
  N1: {latitude: 51.5377218, longitude: -0.0970473},
  N10: {latitude: 51.5948015, longitude: -0.1450221},
  N11: {latitude: 51.6137464, longitude: -0.1388912},
  N12: {latitude: 51.6149237, longitude: -0.1776502},
  N13: {latitude: 51.618112, longitude: -0.1042702},
  N14: {latitude: 51.6343428, longitude: -0.1308896},
  N15: {latitude: 51.5826261, longitude: -0.081173},
  N16: {latitude: 51.5625965, longitude: -0.0766528},
  N17: {latitude: 51.5980699, longitude: -0.0717424},
  N18: {latitude: 51.6138819, longitude: -0.0665839},
  N19: {latitude: 51.5652742, longitude: -0.1298808},
  N1C: {latitude: 51.5365569, longitude: -0.1258562},
  N1P: {latitude: 51.5389749, longitude: -0.1030615},
  N2: {latitude: 51.5900894, longitude: -0.1692626},
  N20: {latitude: 51.6292552, longitude: -0.1743686},
  N21: {latitude: 51.6366698, longitude: -0.0997398},
  N22: {latitude: 51.5998948, longitude: -0.1102841},
  N3: {latitude: 51.6002281, longitude: -0.193929},
  N4: {latitude: 51.5700217, longitude: -0.1043503},
  N5: {latitude: 51.5538671, longitude: -0.0986076},
  N6: {latitude: 51.5731718, longitude: -0.1460635},
  N7: {latitude: 51.5534256, longitude: -0.118356},
  N8: {latitude: 51.5829293, longitude: -0.1198918},
  N81: {latitude: 51.5663135, longitude: -0.0767356},
  N9: {latitude: 51.6285027, longitude: -0.0580156},
  NE1: {latitude: 54.972442, longitude: -1.6115224},
  NE10: {latitude: 54.9472035, longitude: -1.5540428},
  NE11: {latitude: 54.9399167, longitude: -1.6358329},
  NE12: {latitude: 55.0243325, longitude: -1.5705744},
  NE13: {latitude: 55.0437667, longitude: -1.6474838},
  NE15: {latitude: 54.9846077, longitude: -1.7244563},
  NE16: {latitude: 54.9312689, longitude: -1.6926762},
  NE17: {latitude: 54.9125064, longitude: -1.8171473},
  NE18: {latitude: 55.0378909, longitude: -1.8649114},
  NE19: {latitude: 55.1795745, longitude: -2.0990756},
  NE2: {latitude: 54.9870836, longitude: -1.6061088},
  NE20: {latitude: 55.0526955, longitude: -1.7874806},
  NE21: {latitude: 54.9575809, longitude: -1.7214224},
  NE22: {latitude: 55.1351381, longitude: -1.5871076},
  NE23: {latitude: 55.0800801, longitude: -1.582986},
  NE24: {latitude: 55.1218343, longitude: -1.5228902},
  NE25: {latitude: 55.0523507, longitude: -1.4893199},
  NE26: {latitude: 55.0527885, longitude: -1.4577261},
  NE27: {latitude: 55.0329496, longitude: -1.5149818},
  NE28: {latitude: 55.0001992, longitude: -1.5207301},
  NE29: {latitude: 55.01176, longitude: -1.4654419},
  NE3: {latitude: 55.0104241, longitude: -1.6354989},
  NE30: {latitude: 55.0213845, longitude: -1.4386877},
  NE31: {latitude: 54.9708203, longitude: -1.5132819},
  NE32: {latitude: 54.9677908, longitude: -1.4844933},
  NE33: {latitude: 54.9912555, longitude: -1.4295666},
  NE34: {latitude: 54.9717889, longitude: -1.422479},
  NE35: {latitude: 54.9510139, longitude: -1.460656},
  NE36: {latitude: 54.9454581, longitude: -1.4414688},
  NE37: {latitude: 54.9127512, longitude: -1.5279619},
  NE38: {latitude: 54.8934927, longitude: -1.5247917},
  NE39: {latitude: 54.9234877, longitude: -1.7611063},
  NE4: {latitude: 54.9739843, longitude: -1.6445129},
  NE40: {latitude: 54.9659302, longitude: -1.7743389},
  NE41: {latitude: 54.9760829, longitude: -1.8201262},
  NE42: {latitude: 54.9620117, longitude: -1.8548407},
  NE43: {latitude: 54.9480295, longitude: -1.9058067},
  NE44: {latitude: 54.9428778, longitude: -1.9779213},
  NE45: {latitude: 54.9766604, longitude: -2.0147337},
  NE46: {latitude: 54.9790665, longitude: -2.1076079},
  NE47: {latitude: 54.9286141, longitude: -2.2549406},
  NE48: {latitude: 55.1317811, longitude: -2.2582022},
  NE49: {latitude: 54.9672806, longitude: -2.4607532},
  NE5: {latitude: 54.9961368, longitude: -1.6888196},
  NE6: {latitude: 54.9774742, longitude: -1.5658577},
  NE61: {latitude: 55.1782661, longitude: -1.6872652},
  NE62: {latitude: 55.1614961, longitude: -1.593519},
  NE63: {latitude: 55.1782267, longitude: -1.5632732},
  NE64: {latitude: 55.1846583, longitude: -1.5154095},
  NE65: {latitude: 55.3149288, longitude: -1.7484073},
  NE66: {latitude: 55.4286568, longitude: -1.7296243},
  NE67: {latitude: 55.536534, longitude: -1.6919416},
  NE68: {latitude: 55.5798149, longitude: -1.6589189},
  NE69: {latitude: 55.6047765, longitude: -1.7187958},
  NE7: {latitude: 55.0001093, longitude: -1.5797332},
  NE70: {latitude: 55.593707, longitude: -1.8171698},
  NE71: {latitude: 55.5554219, longitude: -2.044318},
  NE8: {latitude: 54.9549915, longitude: -1.6065202},
  NE82: {latitude: 54.93464, longitude: -1.6151031},
  NE83: {latitude: 54.93464, longitude: -1.6151031},
  NE85: {latitude: 54.9319342, longitude: -1.5848013},
  NE88: {latitude: 54.9504939, longitude: -1.6102416},
  NE9: {latitude: 54.9313591, longitude: -1.5854323},
  NE92: {latitude: 54.9417753, longitude: -1.6149882},
  NE98: {latitude: 54.9722874, longitude: -1.598375},
  NE99: {latitude: 54.970433, longitude: -1.6139305},
  NG1: {latitude: 52.9547046, longitude: -1.1485826},
  NG10: {latitude: 52.9005705, longitude: -1.2841731},
  NG11: {latitude: 52.8991198, longitude: -1.1741527},
  NG12: {latitude: 52.9088921, longitude: -1.0522853},
  NG13: {latitude: 52.9486758, longitude: -0.9073222},
  NG14: {latitude: 53.0177831, longitude: -1.0390068},
  NG15: {latitude: 53.0446485, longitude: -1.2037243},
  NG16: {latitude: 53.0273823, longitude: -1.2949848},
  NG17: {latitude: 53.1160576, longitude: -1.2615156},
  NG18: {latitude: 53.1382628, longitude: -1.1840991},
  NG19: {latitude: 53.1605766, longitude: -1.1983361},
  NG2: {latitude: 52.9348691, longitude: -1.1344936},
  NG20: {latitude: 53.2100156, longitude: -1.1858804},
  NG21: {latitude: 53.1424089, longitude: -1.1039866},
  NG22: {latitude: 53.1820817, longitude: -0.9786955},
  NG23: {latitude: 53.1163408, longitude: -0.7998116},
  NG24: {latitude: 53.0696884, longitude: -0.7990824},
  NG25: {latitude: 53.0742802, longitude: -0.9627263},
  NG3: {latitude: 52.9695328, longitude: -1.1273629},
  NG31: {latitude: 52.9144482, longitude: -0.6420228},
  NG32: {latitude: 52.951308, longitude: -0.6513436},
  NG33: {latitude: 52.8165291, longitude: -0.5808488},
  NG34: {latitude: 52.9871563, longitude: -0.3938278},
  NG4: {latitude: 52.9710572, longitude: -1.0877171},
  NG5: {latitude: 52.9972496, longitude: -1.1442651},
  NG6: {latitude: 52.9985112, longitude: -1.1921785},
  NG7: {latitude: 52.9579006, longitude: -1.1725474},
  NG8: {latitude: 52.9649766, longitude: -1.2134133},
  NG80: {latitude: 52.9300984, longitude: -1.1917297},
  NG9: {latitude: 52.9258889, longitude: -1.2382797},
  NG90: {latitude: 52.9258962, longitude: -1.1906952},
  NN1: {latitude: 52.2416489, longitude: -0.8883002},
  NN10: {latitude: 52.2928622, longitude: -0.5977197},
  NN11: {latitude: 52.2417044, longitude: -1.1794055},
  NN12: {latitude: 52.1265265, longitude: -0.9999332},
  NN13: {latitude: 52.0340435, longitude: -1.1480035},
  NN14: {latitude: 52.4110165, longitude: -0.6955533},
  NN15: {latitude: 52.3822978, longitude: -0.7029196},
  NN16: {latitude: 52.4046781, longitude: -0.7057147},
  NN17: {latitude: 52.5010487, longitude: -0.6842686},
  NN18: {latitude: 52.4779167, longitude: -0.7130298},
  NN2: {latitude: 52.2625668, longitude: -0.8886515},
  NN29: {latitude: 52.2580421, longitude: -0.6648146},
  NN3: {latitude: 52.2639662, longitude: -0.8422004},
  NN4: {latitude: 52.2144778, longitude: -0.8994462},
  NN5: {latitude: 52.2467249, longitude: -0.9358726},
  NN6: {latitude: 52.3269298, longitude: -0.9458447},
  NN7: {latitude: 52.2082231, longitude: -0.9287786},
  NN8: {latitude: 52.3032613, longitude: -0.6996321},
  NN9: {latitude: 52.3345261, longitude: -0.5945016},
  NP10: {latitude: 51.5780227, longitude: -3.0477786},
  NP11: {latitude: 51.6438627, longitude: -3.1315958},
  NP12: {latitude: 51.6691612, longitude: -3.1979409},
  NP13: {latitude: 51.7353588, longitude: -3.1414332},
  NP15: {latitude: 51.7263322, longitude: -2.8867108},
  NP16: {latitude: 51.6504671, longitude: -2.6898185},
  NP18: {latitude: 51.6087786, longitude: -2.9423237},
  NP19: {latitude: 51.5882819, longitude: -2.963588},
  NP20: {latitude: 51.5904204, longitude: -3.0065286},
  NP22: {latitude: 51.7712366, longitude: -3.2581432},
  NP23: {latitude: 51.785403, longitude: -3.1974216},
  NP24: {latitude: 51.7189914, longitude: -3.2385423},
  NP25: {latitude: 51.8025304, longitude: -2.7242692},
  NP26: {latitude: 51.5909077, longitude: -2.7788809},
  NP4: {latitude: 51.7193671, longitude: -3.0470946},
  NP44: {latitude: 51.6512296, longitude: -3.0279524},
  NP7: {latitude: 51.8294388, longitude: -3.0112466},
  NP8: {latitude: 51.8618552, longitude: -3.1546668},
  NR1: {latitude: 52.6266317, longitude: 1.3068176},
  NR10: {latitude: 52.7359335, longitude: 1.2410548},
  NR11: {latitude: 52.8409073, longitude: 1.2737841},
  NR12: {latitude: 52.7597763, longitude: 1.4720163},
  NR13: {latitude: 52.6338547, longitude: 1.4697849},
  NR14: {latitude: 52.5626096, longitude: 1.3761424},
  NR15: {latitude: 52.5032686, longitude: 1.2663003},
  NR16: {latitude: 52.4735481, longitude: 1.0538628},
  NR17: {latitude: 52.5153469, longitude: 0.9944934},
  NR18: {latitude: 52.5706689, longitude: 1.1079084},
  NR19: {latitude: 52.6751626, longitude: 0.9300324},
  NR2: {latitude: 52.6291722, longitude: 1.2800286},
  NR20: {latitude: 52.7232899, longitude: 0.9810289},
  NR21: {latitude: 52.8414338, longitude: 0.8522567},
  NR22: {latitude: 52.8944462, longitude: 0.8651737},
  NR23: {latitude: 52.9487974, longitude: 0.8580662},
  NR24: {latitude: 52.85878, longitude: 1.0502847},
  NR25: {latitude: 52.9201145, longitude: 1.082767},
  NR26: {latitude: 52.9387975, longitude: 1.2088922},
  NR27: {latitude: 52.9242431, longitude: 1.2998419},
  NR28: {latitude: 52.8224263, longitude: 1.397492},
  NR29: {latitude: 52.6942516, longitude: 1.6362126},
  NR3: {latitude: 52.6432723, longitude: 1.2917283},
  NR30: {latitude: 52.6197388, longitude: 1.7277361},
  NR31: {latitude: 52.5749904, longitude: 1.708835},
  NR32: {latitude: 52.489723, longitude: 1.7315777},
  NR33: {latitude: 52.4540969, longitude: 1.7167978},
  NR34: {latitude: 52.4387601, longitude: 1.5835599},
  NR35: {latitude: 52.4618856, longitude: 1.4328948},
  NR4: {latitude: 52.612059, longitude: 1.256665},
  NR5: {latitude: 52.6407866, longitude: 1.2286953},
  NR6: {latitude: 52.6619269, longitude: 1.2803571},
  NR7: {latitude: 52.6444333, longitude: 1.3363787},
  NR8: {latitude: 52.6767458, longitude: 1.2047578},
  NR9: {latitude: 52.6336604, longitude: 1.1078046},
  NR99: {latitude: 52.6266507, longitude: 1.3092653},
  NW1: {latitude: 51.5332718, longitude: -0.1438882},
  NW10: {latitude: 51.5412842, longitude: -0.2480596},
  NW11: {latitude: 51.5783915, longitude: -0.1974603},
  NW1W: {latitude: 51.5307841, longitude: -0.1354264},
  NW2: {latitude: 51.5581501, longitude: -0.2202562},
  NW26: {latitude: 51.5340605, longitude: -0.2481317},
  NW3: {latitude: 51.5523422, longitude: -0.1725058},
  NW4: {latitude: 51.5873411, longitude: -0.2243033},
  NW5: {latitude: 51.551787, longitude: -0.1449996},
  NW6: {latitude: 51.542172, longitude: -0.1962878},
  NW7: {latitude: 51.6148052, longitude: -0.2348917},
  NW8: {latitude: 51.5322682, longitude: -0.1745786},
  NW9: {latitude: 51.5881194, longitude: -0.2552637},
  OL1: {latitude: 53.5497377, longitude: -2.1069922},
  OL10: {latitude: 53.5904693, longitude: -2.223154},
  OL11: {latitude: 53.6059003, longitude: -2.1767392},
  OL12: {latitude: 53.6364434, longitude: -2.1653237},
  OL13: {latitude: 53.700821, longitude: -2.2044339},
  OL14: {latitude: 53.7144173, longitude: -2.1009851},
  OL15: {latitude: 53.6448116, longitude: -2.0999458},
  OL16: {latitude: 53.6123706, longitude: -2.1313519},
  OL2: {latitude: 53.5732655, longitude: -2.1099662},
  OL3: {latitude: 53.5535469, longitude: -2.0115057},
  OL4: {latitude: 53.5424267, longitude: -2.0734838},
  OL5: {latitude: 53.5180411, longitude: -2.0385356},
  OL6: {latitude: 53.4943593, longitude: -2.0861171},
  OL7: {latitude: 53.4907107, longitude: -2.1072525},
  OL8: {latitude: 53.5258859, longitude: -2.1173031},
  OL9: {latitude: 53.5391534, longitude: -2.1442485},
  OL95: {latitude: 53.5563368, longitude: -2.1054013},
  OX1: {latitude: 51.7451905, longitude: -1.2614253},
  OX10: {latitude: 51.6073094, longitude: -1.1287254},
  OX11: {latitude: 51.5995807, longitude: -1.2522494},
  OX12: {latitude: 51.5964061, longitude: -1.425191},
  OX13: {latitude: 51.6758174, longitude: -1.3577318},
  OX14: {latitude: 51.667524, longitude: -1.2770907},
  OX15: {latitude: 52.0303387, longitude: -1.4113905},
  OX16: {latitude: 52.0625051, longitude: -1.3425431},
  OX17: {latitude: 52.07362, longitude: -1.2890522},
  OX18: {latitude: 51.7628074, longitude: -1.5916671},
  OX2: {latitude: 51.7659091, longitude: -1.2807181},
  OX20: {latitude: 51.8558919, longitude: -1.3577401},
  OX25: {latitude: 51.9002711, longitude: -1.2130366},
  OX26: {latitude: 51.901173, longitude: -1.1544766},
  OX27: {latitude: 51.9363464, longitude: -1.1505518},
  OX28: {latitude: 51.7869462, longitude: -1.4860576},
  OX29: {latitude: 51.7940797, longitude: -1.435656},
  OX3: {latitude: 51.7622825, longitude: -1.211732},
  OX33: {latitude: 51.7583288, longitude: -1.1399624},
  OX39: {latitude: 51.701667, longitude: -0.9158158},
  OX4: {latitude: 51.7312035, longitude: -1.2173945},
  OX44: {latitude: 51.6975079, longitude: -1.1223775},
  OX49: {latitude: 51.6506644, longitude: -1.0011957},
  OX5: {latitude: 51.8306381, longitude: -1.2818093},
  OX7: {latitude: 51.9104488, longitude: -1.5287932},
  OX9: {latitude: 51.7379966, longitude: -0.9839931},
  PA1: {latitude: 55.8446501, longitude: -4.4173443},
  PA10: {latitude: 55.8328892, longitude: -4.5514075},
  PA11: {latitude: 55.8570966, longitude: -4.5846807},
  PA12: {latitude: 55.7942177, longitude: -4.6265019},
  PA13: {latitude: 55.8934699, longitude: -4.6315923},
  PA14: {latitude: 55.92732, longitude: -4.6642031},
  PA15: {latitude: 55.9425234, longitude: -4.7476824},
  PA16: {latitude: 55.9425162, longitude: -4.8009273},
  PA17: {latitude: 55.8633832, longitude: -4.8851597},
  PA18: {latitude: 55.8884779, longitude: -4.8880972},
  PA19: {latitude: 55.9529227, longitude: -4.8261532},
  PA2: {latitude: 55.8287846, longitude: -4.4346865},
  PA20: {latitude: 55.8341544, longitude: -5.0572403},
  PA21: {latitude: 55.9022321, longitude: -5.2508811},
  PA22: {latitude: 55.9714333, longitude: -5.1344071},
  PA23: {latitude: 55.9537952, longitude: -4.9334508},
  PA24: {latitude: 56.1584351, longitude: -4.9044299},
  PA25: {latitude: 56.2143195, longitude: -5.0433625},
  PA26: {latitude: 56.2605328, longitude: -4.9351065},
  PA27: {latitude: 56.1553315, longitude: -5.0860009},
  PA28: {latitude: 55.4376036, longitude: -5.6038598},
  PA29: {latitude: 55.8065512, longitude: -5.4754053},
  PA3: {latitude: 55.8515026, longitude: -4.4456692},
  PA30: {latitude: 56.013332, longitude: -5.4494977},
  PA31: {latitude: 56.0525103, longitude: -5.4583508},
  PA32: {latitude: 56.197567, longitude: -5.1253583},
  PA33: {latitude: 56.3668062, longitude: -5.0642038},
  PA34: {latitude: 56.3937657, longitude: -5.4870915},
  PA35: {latitude: 56.4047653, longitude: -5.2274523},
  PA36: {latitude: 56.5241284, longitude: -4.7696606},
  PA37: {latitude: 56.4668384, longitude: -5.3919661},
  PA38: {latitude: 56.5953129, longitude: -5.3282856},
  PA4: {latitude: 55.874849, longitude: -4.3953267},
  PA41: {latitude: 55.6744664, longitude: -5.7425879},
  PA42: {latitude: 55.6368001, longitude: -6.1894539},
  PA43: {latitude: 55.7556052, longitude: -6.2841924},
  PA44: {latitude: 55.7994182, longitude: -6.2935908},
  PA45: {latitude: 55.8196554, longitude: -6.1668358},
  PA46: {latitude: 55.8626671, longitude: -6.120776},
  PA47: {latitude: 55.6820071, longitude: -6.5040794},
  PA48: {latitude: 55.7384868, longitude: -6.3848707},
  PA49: {latitude: 55.7822695, longitude: -6.3948363},
  PA5: {latitude: 55.8310416, longitude: -4.5097445},
  PA6: {latitude: 55.8658238, longitude: -4.5371164},
  PA60: {latitude: 55.8786751, longitude: -5.9157646},
  PA61: {latitude: 56.0716509, longitude: -6.2030067},
  PA62: {latitude: 56.3592566, longitude: -5.8515195},
  PA63: {latitude: 56.3817723, longitude: -5.7158719},
  PA64: {latitude: 56.437876, longitude: -5.6860385},
  PA65: {latitude: 56.4691539, longitude: -5.7255045},
  PA66: {latitude: 56.3287392, longitude: -6.3528986},
  PA67: {latitude: 56.3142224, longitude: -6.2313622},
  PA68: {latitude: 56.434551, longitude: -6.1426434},
  PA69: {latitude: 56.3796685, longitude: -6.0774753},
  PA7: {latitude: 55.9073289, longitude: -4.5040855},
  PA70: {latitude: 56.3649649, longitude: -6.0371982},
  PA71: {latitude: 56.4806916, longitude: -5.981512},
  PA72: {latitude: 56.5183484, longitude: -5.9661761},
  PA73: {latitude: 56.4966381, longitude: -6.1836106},
  PA74: {latitude: 56.5329478, longitude: -6.2297513},
  PA75: {latitude: 56.6125781, longitude: -6.1143844},
  PA76: {latitude: 56.3340203, longitude: -6.3943735},
  PA77: {latitude: 56.4953995, longitude: -6.8810683},
  PA78: {latitude: 56.6264192, longitude: -6.5458652},
  PA8: {latitude: 55.9007534, longitude: -4.453165},
  PA80: {latitude: 56.5659697, longitude: -5.786465},
  PA9: {latitude: 55.8072925, longitude: -4.5569521},
  PE1: {latitude: 52.5866097, longitude: -0.2380334},
  PE10: {latitude: 52.7746766, longitude: -0.377177},
  PE11: {latitude: 52.8055261, longitude: -0.1668409},
  PE12: {latitude: 52.7851801, longitude: 0.0279957},
  PE13: {latitude: 52.6700673, longitude: 0.1371284},
  PE14: {latitude: 52.6392767, longitude: 0.2075469},
  PE15: {latitude: 52.5375062, longitude: 0.0858982},
  PE16: {latitude: 52.4548843, longitude: 0.0493714},
  PE19: {latitude: 52.2359693, longitude: -0.2636521},
  PE2: {latitude: 52.5584209, longitude: -0.2605213},
  PE20: {latitude: 52.9312795, longitude: -0.1038179},
  PE21: {latitude: 52.9744837, longitude: -0.0238791},
  PE22: {latitude: 53.0501008, longitude: 0.0445584},
  PE23: {latitude: 53.1727258, longitude: 0.0887887},
  PE24: {latitude: 53.1644979, longitude: 0.2645359},
  PE25: {latitude: 53.1539916, longitude: 0.3342567},
  PE26: {latitude: 52.4532813, longitude: -0.116638},
  PE27: {latitude: 52.3315399, longitude: -0.0713853},
  PE28: {latitude: 52.3588328, longitude: -0.1906381},
  PE29: {latitude: 52.3323569, longitude: -0.1792855},
  PE3: {latitude: 52.5843494, longitude: -0.2752554},
  PE30: {latitude: 52.7597146, longitude: 0.4165056},
  PE31: {latitude: 52.8818331, longitude: 0.5723975},
  PE32: {latitude: 52.7278429, longitude: 0.6349892},
  PE33: {latitude: 52.6459805, longitude: 0.4658335},
  PE34: {latitude: 52.7249832, longitude: 0.3373637},
  PE35: {latitude: 52.8271575, longitude: 0.509056},
  PE36: {latitude: 52.9394294, longitude: 0.5087246},
  PE37: {latitude: 52.6410311, longitude: 0.6995141},
  PE38: {latitude: 52.5881901, longitude: 0.3752984},
  PE4: {latitude: 52.6119535, longitude: -0.2626267},
  PE5: {latitude: 52.5748693, longitude: -0.3505212},
  PE6: {latitude: 52.6575152, longitude: -0.2526423},
  PE7: {latitude: 52.5371201, longitude: -0.2061648},
  PE8: {latitude: 52.5217429, longitude: -0.4539945},
  PE9: {latitude: 52.6545544, longitude: -0.4804678},
  PH1: {latitude: 56.4224093, longitude: -3.4793955},
  PH10: {latitude: 56.6069517, longitude: -3.3593082},
  PH11: {latitude: 56.6381789, longitude: -3.2349256},
  PH12: {latitude: 56.575892, longitude: -3.1549046},
  PH13: {latitude: 56.5371048, longitude: -3.2746989},
  PH14: {latitude: 56.4528883, longitude: -3.1808965},
  PH15: {latitude: 56.6097022, longitude: -3.9407898},
  PH16: {latitude: 56.7067956, longitude: -3.8062465},
  PH17: {latitude: 56.6864534, longitude: -4.3747262},
  PH18: {latitude: 56.7731976, longitude: -3.8901941},
  PH19: {latitude: 56.9262864, longitude: -4.2556793},
  PH2: {latitude: 56.387089, longitude: -3.4038513},
  PH20: {latitude: 57.056667, longitude: -4.147518},
  PH21: {latitude: 57.0898405, longitude: -4.0197579},
  PH22: {latitude: 57.1941031, longitude: -3.8202505},
  PH23: {latitude: 57.2837083, longitude: -3.8169255},
  PH24: {latitude: 57.2561205, longitude: -3.7449612},
  PH25: {latitude: 57.2615339, longitude: -3.6477254},
  PH26: {latitude: 57.3300387, longitude: -3.6062492},
  PH3: {latitude: 56.3019354, longitude: -3.7043969},
  PH30: {latitude: 56.788984, longitude: -4.599829},
  PH31: {latitude: 56.8922176, longitude: -4.8143283},
  PH32: {latitude: 57.1445763, longitude: -4.6835593},
  PH33: {latitude: 56.8218973, longitude: -5.1122203},
  PH34: {latitude: 56.9203102, longitude: -4.927653},
  PH35: {latitude: 57.0755394, longitude: -4.9027758},
  PH36: {latitude: 56.7221628, longitude: -5.8512969},
  PH37: {latitude: 56.8356654, longitude: -5.501676},
  PH38: {latitude: 56.8438021, longitude: -5.7438068},
  PH39: {latitude: 56.9123133, longitude: -5.841732},
  PH4: {latitude: 56.2613859, longitude: -3.7853249},
  PH40: {latitude: 56.9633163, longitude: -5.8017491},
  PH41: {latitude: 57.0035759, longitude: -5.832467},
  PH42: {latitude: 56.9018804, longitude: -6.1427489},
  PH43: {latitude: 57.0154066, longitude: -6.2814874},
  PH44: {latitude: 57.0567966, longitude: -6.503266},
  PH49: {latitude: 56.674888, longitude: -5.1153736},
  PH5: {latitude: 56.3282762, longitude: -3.8298735},
  PH50: {latitude: 56.7145473, longitude: -4.964924},
  PH6: {latitude: 56.3717976, longitude: -3.9999352},
  PH7: {latitude: 56.3730997, longitude: -3.8270302},
  PH8: {latitude: 56.5623822, longitude: -3.599212},
  PH9: {latitude: 56.6480509, longitude: -3.6899621},
  PL1: {latitude: 50.3705757, longitude: -4.154261},
  PL10: {latitude: 50.3452071, longitude: -4.2112874},
  PL11: {latitude: 50.372956, longitude: -4.2549194},
  PL12: {latitude: 50.4193974, longitude: -4.2502369},
  PL13: {latitude: 50.3587383, longitude: -4.4757544},
  PL14: {latitude: 50.4639492, longitude: -4.466271},
  PL15: {latitude: 50.6330692, longitude: -4.3969382},
  PL16: {latitude: 50.6464378, longitude: -4.2640338},
  PL17: {latitude: 50.5150098, longitude: -4.3103836},
  PL18: {latitude: 50.5154431, longitude: -4.2217893},
  PL19: {latitude: 50.5565609, longitude: -4.1547903},
  PL2: {latitude: 50.389557, longitude: -4.1630645},
  PL20: {latitude: 50.5001025, longitude: -4.100192},
  PL21: {latitude: 50.3852736, longitude: -3.9184514},
  PL22: {latitude: 50.403456, longitude: -4.6518896},
  PL23: {latitude: 50.3374532, longitude: -4.6368031},
  PL24: {latitude: 50.3552292, longitude: -4.7111784},
  PL25: {latitude: 50.3413052, longitude: -4.7782631},
  PL26: {latitude: 50.3449922, longitude: -4.827501},
  PL27: {latitude: 50.5237028, longitude: -4.875155},
  PL28: {latitude: 50.5327501, longitude: -4.9673308},
  PL29: {latitude: 50.5861971, longitude: -4.8301107},
  PL3: {latitude: 50.3882426, longitude: -4.1272702},
  PL30: {latitude: 50.5017989, longitude: -4.7283944},
  PL31: {latitude: 50.4691274, longitude: -4.7226505},
  PL32: {latitude: 50.6332624, longitude: -4.6619385},
  PL33: {latitude: 50.6218997, longitude: -4.7316297},
  PL34: {latitude: 50.6597186, longitude: -4.7443504},
  PL35: {latitude: 50.6847541, longitude: -4.6853135},
  PL4: {latitude: 50.3755331, longitude: -4.1280288},
  PL5: {latitude: 50.4110853, longitude: -4.1666681},
  PL6: {latitude: 50.418712, longitude: -4.1156868},
  PL7: {latitude: 50.3927332, longitude: -4.0456918},
  PL8: {latitude: 50.3354884, longitude: -4.0107277},
  PL9: {latitude: 50.3547404, longitude: -4.087228},
  PL95: {latitude: 50.3644065, longitude: -4.1044393},
  PO1: {latitude: 50.799499, longitude: -1.0896771},
  PO10: {latitude: 50.8522374, longitude: -0.9293902},
  PO11: {latitude: 50.7920495, longitude: -0.9756968},
  PO12: {latitude: 50.7979491, longitude: -1.1418001},
  PO13: {latitude: 50.8122549, longitude: -1.1810192},
  PO14: {latitude: 50.8387029, longitude: -1.2188991},
  PO15: {latitude: 50.8676994, longitude: -1.2281695},
  PO16: {latitude: 50.8508807, longitude: -1.1591621},
  PO17: {latitude: 50.889723, longitude: -1.17331},
  PO18: {latitude: 50.8649547, longitude: -0.81514},
  PO19: {latitude: 50.8382074, longitude: -0.7783183},
  PO2: {latitude: 50.8178415, longitude: -1.0774067},
  PO20: {latitude: 50.7837114, longitude: -0.7846263},
  PO21: {latitude: 50.7850953, longitude: -0.6986558},
  PO22: {latitude: 50.8001082, longitude: -0.6476773},
  PO3: {latitude: 50.8162998, longitude: -1.059158},
  PO30: {latitude: 50.6911019, longitude: -1.31348},
  PO31: {latitude: 50.7554074, longitude: -1.3073561},
  PO32: {latitude: 50.7511908, longitude: -1.2810514},
  PO33: {latitude: 50.7216598, longitude: -1.1700685},
  PO34: {latitude: 50.7159013, longitude: -1.1134555},
  PO35: {latitude: 50.6868571, longitude: -1.0855937},
  PO36: {latitude: 50.6585816, longitude: -1.163679},
  PO37: {latitude: 50.6314255, longitude: -1.1796299},
  PO38: {latitude: 50.6053631, longitude: -1.2432132},
  PO39: {latitude: 50.6803617, longitude: -1.5401345},
  PO4: {latitude: 50.7901751, longitude: -1.0620764},
  PO40: {latitude: 50.6824755, longitude: -1.5218166},
  PO41: {latitude: 50.7009701, longitude: -1.4750973},
  PO5: {latitude: 50.7886425, longitude: -1.0861972},
  PO6: {latitude: 50.846598, longitude: -1.0700466},
  PO7: {latitude: 50.8829409, longitude: -1.0406889},
  PO8: {latitude: 50.9135161, longitude: -1.0116749},
  PO9: {latitude: 50.8634319, longitude: -0.9839667},
  PR0: {latitude: 53.7588071, longitude: -2.6839072},
  PR1: {latitude: 53.7573394, longitude: -2.7017204},
  PR11: {latitude: 53.7945597, longitude: -2.6849868},
  PR2: {latitude: 53.7782025, longitude: -2.7072842},
  PR25: {latitude: 53.6945907, longitude: -2.6937368},
  PR26: {latitude: 53.6876888, longitude: -2.7410845},
  PR3: {latitude: 53.8688401, longitude: -2.7203057},
  PR4: {latitude: 53.7546364, longitude: -2.8341777},
  PR5: {latitude: 53.731555, longitude: -2.6577319},
  PR6: {latitude: 53.6677742, longitude: -2.6119293},
  PR7: {latitude: 53.6486409, longitude: -2.655302},
  PR8: {latitude: 53.6262751, longitude: -3.0097883},
  PR9: {latitude: 53.659666, longitude: -2.9686373},
  RG1: {latitude: 51.4512045, longitude: -0.9696684},
  RG10: {latitude: 51.4823983, longitude: -0.8532308},
  RG12: {latitude: 51.4067523, longitude: -0.7500218},
  RG14: {latitude: 51.3994972, longitude: -1.3231202},
  RG17: {latitude: 51.4435994, longitude: -1.5030377},
  RG18: {latitude: 51.4314131, longitude: -1.2602125},
  RG19: {latitude: 51.3912084, longitude: -1.2443747},
  RG2: {latitude: 51.4201494, longitude: -0.9517094},
  RG20: {latitude: 51.4036907, longitude: -1.3378722},
  RG21: {latitude: 51.2648843, longitude: -1.0886279},
  RG22: {latitude: 51.2481133, longitude: -1.1247687},
  RG23: {latitude: 51.2582357, longitude: -1.1500593},
  RG24: {latitude: 51.2807785, longitude: -1.0794987},
  RG25: {latitude: 51.2271784, longitude: -1.1624243},
  RG26: {latitude: 51.3401022, longitude: -1.1297305},
  RG27: {latitude: 51.3058876, longitude: -0.9469323},
  RG28: {latitude: 51.2341195, longitude: -1.3359686},
  RG29: {latitude: 51.2458368, longitude: -0.9459765},
  RG30: {latitude: 51.4511542, longitude: -1.0147746},
  RG31: {latitude: 51.4566563, longitude: -1.0456059},
  RG4: {latitude: 51.4827626, longitude: -0.9698039},
  RG40: {latitude: 51.4001248, longitude: -0.8360988},
  RG41: {latitude: 51.4168077, longitude: -0.8633653},
  RG42: {latitude: 51.4277905, longitude: -0.7570056},
  RG45: {latitude: 51.3715067, longitude: -0.7995721},
  RG5: {latitude: 51.4520535, longitude: -0.8996446},
  RG6: {latitude: 51.4378229, longitude: -0.9281585},
  RG7: {latitude: 51.3976703, longitude: -1.0774783},
  RG8: {latitude: 51.5062415, longitude: -1.1063426},
  RG9: {latitude: 51.5450342, longitude: -0.9260061},
  RH1: {latitude: 51.2373631, longitude: -0.1576051},
  RH10: {latitude: 51.1183435, longitude: -0.1547527},
  RH11: {latitude: 51.1106463, longitude: -0.2081205},
  RH12: {latitude: 51.0771886, longitude: -0.332156},
  RH13: {latitude: 51.0337894, longitude: -0.3279851},
  RH14: {latitude: 51.0330425, longitude: -0.4847114},
  RH15: {latitude: 50.9574814, longitude: -0.1309943},
  RH16: {latitude: 51.0014151, longitude: -0.0983341},
  RH17: {latitude: 51.0223327, longitude: -0.1194834},
  RH18: {latitude: 51.0932269, longitude: 0.035663},
  RH19: {latitude: 51.1256226, longitude: -0.0142356},
  RH2: {latitude: 51.2351176, longitude: -0.2030862},
  RH20: {latitude: 50.9374494, longitude: -0.4705572},
  RH3: {latitude: 51.2326558, longitude: -0.2778643},
  RH4: {latitude: 51.2299509, longitude: -0.3347519},
  RH5: {latitude: 51.1903735, longitude: -0.343837},
  RH6: {latitude: 51.1730206, longitude: -0.1641717},
  RH7: {latitude: 51.1746946, longitude: -0.0182314},
  RH77: {latitude: 51.1387737, longitude: -0.1697793},
  RH8: {latitude: 51.2508257, longitude: 0.0023834},
  RH9: {latitude: 51.2363052, longitude: -0.0630331},
  RM1: {latitude: 51.582909, longitude: 0.1835712},
  RM10: {latitude: 51.5448684, longitude: 0.1578473},
  RM11: {latitude: 51.5710765, longitude: 0.2185278},
  RM12: {latitude: 51.5529171, longitude: 0.207438},
  RM13: {latitude: 51.5252467, longitude: 0.1931007},
  RM14: {latitude: 51.5569004, longitude: 0.264491},
  RM15: {latitude: 51.5087484, longitude: 0.2762291},
  RM16: {latitude: 51.4929827, longitude: 0.3410404},
  RM17: {latitude: 51.479725, longitude: 0.3283265},
  RM18: {latitude: 51.4674524, longitude: 0.37594},
  RM19: {latitude: 51.4828338, longitude: 0.2443696},
  RM2: {latitude: 51.5843336, longitude: 0.2033607},
  RM20: {latitude: 51.4784335, longitude: 0.2847884},
  RM3: {latitude: 51.6019384, longitude: 0.2244542},
  RM4: {latitude: 51.6410737, longitude: 0.1587939},
  RM5: {latitude: 51.6013387, longitude: 0.1647727},
  RM6: {latitude: 51.5757994, longitude: 0.1295444},
  RM7: {latitude: 51.5748451, longitude: 0.1687782},
  RM8: {latitude: 51.5572096, longitude: 0.1293935},
  RM9: {latitude: 51.5409021, longitude: 0.1338079},
  S1: {latitude: 53.3800229, longitude: -1.4710499},
  S10: {latitude: 53.3767062, longitude: -1.5185445},
  S11: {latitude: 53.3607754, longitude: -1.5078903},
  S12: {latitude: 53.3482005, longitude: -1.4064871},
  S13: {latitude: 53.3646431, longitude: -1.3836802},
  S14: {latitude: 53.3460139, longitude: -1.4444011},
  S17: {latitude: 53.3213081, longitude: -1.5289135},
  S18: {latitude: 53.299467, longitude: -1.4743449},
  S2: {latitude: 53.369613, longitude: -1.4480046},
  S20: {latitude: 53.3345997, longitude: -1.3520598},
  S21: {latitude: 53.3120546, longitude: -1.3396584},
  S25: {latitude: 53.3658458, longitude: -1.2168611},
  S26: {latitude: 53.3526108, longitude: -1.2915543},
  S3: {latitude: 53.3874982, longitude: -1.4740209},
  S32: {latitude: 53.2945357, longitude: -1.6515465},
  S33: {latitude: 53.3438997, longitude: -1.7396963},
  S35: {latitude: 53.4586541, longitude: -1.4979375},
  S36: {latitude: 53.5054492, longitude: -1.616598},
  S4: {latitude: 53.4009143, longitude: -1.4496573},
  S40: {latitude: 53.2341072, longitude: -1.4461714},
  S41: {latitude: 53.2472723, longitude: -1.428409},
  S42: {latitude: 53.1996406, longitude: -1.4217945},
  S43: {latitude: 53.2676283, longitude: -1.3399055},
  S44: {latitude: 53.2252186, longitude: -1.3139748},
  S45: {latitude: 53.1656275, longitude: -1.4213229},
  S49: {latitude: 53.2350543, longitude: -1.434735},
  S5: {latitude: 53.4222438, longitude: -1.4632305},
  S6: {latitude: 53.4028113, longitude: -1.5130984},
  S60: {latitude: 53.4123073, longitude: -1.3507801},
  S61: {latitude: 53.4441131, longitude: -1.3949172},
  S62: {latitude: 53.465419, longitude: -1.3479048},
  S63: {latitude: 53.5185718, longitude: -1.3305698},
  S64: {latitude: 53.4907312, longitude: -1.2988429},
  S65: {latitude: 53.436171, longitude: -1.3185879},
  S66: {latitude: 53.4201548, longitude: -1.2439946},
  S7: {latitude: 53.3551559, longitude: -1.4910563},
  S70: {latitude: 53.5411537, longitude: -1.4749041},
  S71: {latitude: 53.5744126, longitude: -1.4561067},
  S72: {latitude: 53.5786497, longitude: -1.3911586},
  S73: {latitude: 53.5244965, longitude: -1.3950715},
  S74: {latitude: 53.5009685, longitude: -1.4411464},
  S75: {latitude: 53.5627102, longitude: -1.5215009},
  S8: {latitude: 53.3398982, longitude: -1.4776091},
  S80: {latitude: 53.2925801, longitude: -1.1521193},
  S81: {latitude: 53.3386575, longitude: -1.1239571},
  S9: {latitude: 53.3981645, longitude: -1.4178388},
  S95: {latitude: 53.4184381, longitude: -1.403692},
  S96: {latitude: 53.4023591, longitude: -1.4250619},
  S97: {latitude: 53.5032475, longitude: -1.3379727},
  S98: {latitude: 53.4041516, longitude: -1.4311097},
  S99: {latitude: 53.404241, longitude: -1.4310272},
  SA1: {latitude: 51.6266504, longitude: -3.9402316},
  SA10: {latitude: 51.6875078, longitude: -3.8007881},
  SA11: {latitude: 51.6748529, longitude: -3.7614044},
  SA12: {latitude: 51.6082605, longitude: -3.7957976},
  SA13: {latitude: 51.6057851, longitude: -3.7258236},
  SA14: {latitude: 51.735052, longitude: -4.1062507},
  SA15: {latitude: 51.6995488, longitude: -4.1678401},
  SA16: {latitude: 51.6893287, longitude: -4.2569858},
  SA17: {latitude: 51.7568602, longitude: -4.2854106},
  SA18: {latitude: 51.7977271, longitude: -3.9609347},
  SA19: {latitude: 51.9545649, longitude: -3.9481925},
  SA2: {latitude: 51.6191141, longitude: -3.9979674},
  SA20: {latitude: 52.0119374, longitude: -3.78776},
  SA3: {latitude: 51.5817133, longitude: -4.0513777},
  SA31: {latitude: 51.8567444, longitude: -4.3082937},
  SA32: {latitude: 51.8878923, longitude: -4.1696166},
  SA33: {latitude: 51.8495123, longitude: -4.4408804},
  SA34: {latitude: 51.8521658, longitude: -4.6189874},
  SA35: {latitude: 51.9710664, longitude: -4.5582429},
  SA36: {latitude: 51.9577914, longitude: -4.6087195},
  SA37: {latitude: 52.0159313, longitude: -4.5927184},
  SA38: {latitude: 52.0402001, longitude: -4.476398},
  SA39: {latitude: 52.0188701, longitude: -4.2435846},
  SA4: {latitude: 51.6732535, longitude: -4.0486716},
  SA40: {latitude: 52.0842938, longitude: -4.1755517},
  SA41: {latitude: 51.9952157, longitude: -4.7058717},
  SA42: {latitude: 52.0154537, longitude: -4.8524793},
  SA43: {latitude: 52.0872908, longitude: -4.6280484},
  SA44: {latitude: 52.0874643, longitude: -4.3732402},
  SA45: {latitude: 52.2081814, longitude: -4.3582137},
  SA46: {latitude: 52.2377669, longitude: -4.2574871},
  SA47: {latitude: 52.1922116, longitude: -4.2996604},
  SA48: {latitude: 52.1449088, longitude: -4.11325},
  SA5: {latitude: 51.6489448, longitude: -3.9712026},
  SA6: {latitude: 51.6761659, longitude: -3.9226054},
  SA61: {latitude: 51.8001658, longitude: -4.9741219},
  SA62: {latitude: 51.841175, longitude: -5.0642757},
  SA63: {latitude: 51.8742755, longitude: -4.8563094},
  SA64: {latitude: 52.002105, longitude: -5.0124731},
  SA65: {latitude: 51.9881184, longitude: -4.9697965},
  SA66: {latitude: 51.8836245, longitude: -4.7449465},
  SA67: {latitude: 51.783184, longitude: -4.7328423},
  SA68: {latitude: 51.7295615, longitude: -4.7650739},
  SA69: {latitude: 51.710974, longitude: -4.706798},
  SA7: {latitude: 51.6647175, longitude: -3.8881517},
  SA70: {latitude: 51.6725248, longitude: -4.7416638},
  SA71: {latitude: 51.6679926, longitude: -4.9293245},
  SA72: {latitude: 51.6917901, longitude: -4.9355542},
  SA73: {latitude: 51.7174251, longitude: -5.0122032},
  SA8: {latitude: 51.7217976, longitude: -3.8477059},
  SA80: {latitude: 51.6479391, longitude: -3.9242947},
  SA9: {latitude: 51.7812869, longitude: -3.7689001},
  SA99: {latitude: 51.6699957, longitude: -3.9454456},
  SE1: {latitude: 51.4991997, longitude: -0.0916245},
  SE10: {latitude: 51.4846226, longitude: 0.0003716},
  SE11: {latitude: 51.4898569, longitude: -0.1115597},
  SE12: {latitude: 51.4446759, longitude: 0.0200181},
  SE13: {latitude: 51.4594042, longitude: -0.0095672},
  SE14: {latitude: 51.4758845, longitude: -0.0424768},
  SE15: {latitude: 51.4727365, longitude: -0.0656967},
  SE16: {latitude: 51.4965989, longitude: -0.053091},
  SE17: {latitude: 51.4882787, longitude: -0.0933945},
  SE18: {latitude: 51.4843462, longitude: 0.0726765},
  SE19: {latitude: 51.4179954, longitude: -0.0861287},
  SE1P: {latitude: 51.4927767, longitude: -0.0801528},
  SE2: {latitude: 51.4896972, longitude: 0.1159327},
  SE20: {latitude: 51.4123248, longitude: -0.0594187},
  SE21: {latitude: 51.438989, longitude: -0.0887527},
  SE22: {latitude: 51.4544389, longitude: -0.0724071},
  SE23: {latitude: 51.4414858, longitude: -0.0491513},
  SE24: {latitude: 51.4563048, longitude: -0.1002302},
  SE25: {latitude: 51.3977747, longitude: -0.0767868},
  SE26: {latitude: 51.4279399, longitude: -0.0547761},
  SE27: {latitude: 51.4305427, longitude: -0.1023126},
  SE28: {latitude: 51.5023617, longitude: 0.104435},
  SE3: {latitude: 51.4694787, longitude: 0.0196345},
  SE4: {latitude: 51.4610268, longitude: -0.0352253},
  SE5: {latitude: 51.4738341, longitude: -0.0914963},
  SE6: {latitude: 51.438559, longitude: -0.0166543},
  SE7: {latitude: 51.4842259, longitude: 0.0340854},
  SE8: {latitude: 51.4819486, longitude: -0.0294902},
  SE9: {latitude: 51.4451387, longitude: 0.0548051},
  SG1: {latitude: 51.913148, longitude: -0.1949772},
  SG10: {latitude: 51.8467689, longitude: 0.0754693},
  SG11: {latitude: 51.8860481, longitude: 0.0334702},
  SG12: {latitude: 51.8143338, longitude: -0.0169035},
  SG13: {latitude: 51.7877234, longitude: -0.0715474},
  SG14: {latitude: 51.8081282, longitude: -0.0940096},
  SG15: {latitude: 52.013322, longitude: -0.2637871},
  SG16: {latitude: 52.0142001, longitude: -0.298799},
  SG17: {latitude: 52.0345727, longitude: -0.3353918},
  SG18: {latitude: 52.0825989, longitude: -0.2645551},
  SG19: {latitude: 52.1394738, longitude: -0.2395501},
  SG2: {latitude: 51.8965414, longitude: -0.1640911},
  SG3: {latitude: 51.8604038, longitude: -0.1822612},
  SG4: {latitude: 51.9206087, longitude: -0.2595399},
  SG5: {latitude: 51.9713173, longitude: -0.2810918},
  SG6: {latitude: 51.9790227, longitude: -0.2227304},
  SG7: {latitude: 52.0045147, longitude: -0.1754105},
  SG8: {latitude: 52.0643705, longitude: -0.0147945},
  SG9: {latitude: 51.9507491, longitude: -0.0091601},
  SK1: {latitude: 53.4075932, longitude: -2.1515586},
  SK10: {latitude: 53.2756794, longitude: -2.1312485},
  SK11: {latitude: 53.245315, longitude: -2.1463212},
  SK12: {latitude: 53.3514172, longitude: -2.0924709},
  SK13: {latitude: 53.4486314, longitude: -1.9643687},
  SK14: {latitude: 53.4520427, longitude: -2.0566162},
  SK15: {latitude: 53.4870446, longitude: -2.0469859},
  SK16: {latitude: 53.4746223, longitude: -2.0827362},
  SK17: {latitude: 53.2445366, longitude: -1.8815141},
  SK2: {latitude: 53.3943065, longitude: -2.1323676},
  SK22: {latitude: 53.3725343, longitude: -1.9846946},
  SK23: {latitude: 53.3277544, longitude: -1.9485093},
  SK3: {latitude: 53.3982575, longitude: -2.172193},
  SK4: {latitude: 53.4194666, longitude: -2.1817251},
  SK5: {latitude: 53.4351388, longitude: -2.1525459},
  SK6: {latitude: 53.4051341, longitude: -2.080279},
  SK7: {latitude: 53.3695112, longitude: -2.1434037},
  SK8: {latitude: 53.3796923, longitude: -2.2090903},
  SK9: {latitude: 53.3278962, longitude: -2.2304439},
  SL0: {latitude: 51.5259965, longitude: -0.5171775},
  SL1: {latitude: 51.5178471, longitude: -0.6222163},
  SL2: {latitude: 51.5356977, longitude: -0.6058076},
  SL3: {latitude: 51.4987413, longitude: -0.5516413},
  SL4: {latitude: 51.4752709, longitude: -0.6274221},
  SL5: {latitude: 51.4056392, longitude: -0.6638405},
  SL6: {latitude: 51.5239786, longitude: -0.7292167},
  SL60: {latitude: 51.518549, longitude: -0.7147822},
  SL7: {latitude: 51.5753276, longitude: -0.777869},
  SL8: {latitude: 51.5787364, longitude: -0.7087112},
  SL9: {latitude: 51.5978678, longitude: -0.5557695},
  SL95: {latitude: 51.4991652, longitude: -0.5390536},
  SM1: {latitude: 51.3669805, longitude: -0.1928536},
  SM2: {latitude: 51.3518298, longitude: -0.1987871},
  SM3: {latitude: 51.3712541, longitude: -0.2162485},
  SM4: {latitude: 51.393147, longitude: -0.1996608},
  SM5: {latitude: 51.3686674, longitude: -0.168793},
  SM6: {latitude: 51.3614689, longitude: -0.1445371},
  SM7: {latitude: 51.3229202, longitude: -0.2014229},
  SN1: {latitude: 51.5565291, longitude: -1.783169},
  SN10: {latitude: 51.3370397, longitude: -1.9869176},
  SN11: {latitude: 51.4393874, longitude: -1.9990879},
  SN12: {latitude: 51.3722003, longitude: -2.1366155},
  SN13: {latitude: 51.4245832, longitude: -2.2124861},
  SN14: {latitude: 51.4755423, longitude: -2.1991424},
  SN15: {latitude: 51.4723, longitude: -2.0830579},
  SN16: {latitude: 51.5920459, longitude: -2.084858},
  SN2: {latitude: 51.5777424, longitude: -1.7829919},
  SN25: {latitude: 51.5980434, longitude: -1.8088878},
  SN26: {latitude: 51.613983, longitude: -1.7881065},
  SN3: {latitude: 51.5616826, longitude: -1.7456549},
  SN38: {latitude: 51.5627924, longitude: -1.806599},
  SN4: {latitude: 51.530429, longitude: -1.8406454},
  SN5: {latitude: 51.5668285, longitude: -1.8397596},
  SN6: {latitude: 51.6215185, longitude: -1.7409572},
  SN7: {latitude: 51.6484265, longitude: -1.5662623},
  SN8: {latitude: 51.4063157, longitude: -1.6857426},
  SN9: {latitude: 51.3242371, longitude: -1.7880126},
  SN99: {latitude: 51.5519943, longitude: -1.7225477},
  SO14: {latitude: 50.9071878, longitude: -1.3973862},
  SO15: {latitude: 50.9170655, longitude: -1.4245244},
  SO16: {latitude: 50.936668, longitude: -1.433299},
  SO17: {latitude: 50.927271, longitude: -1.3926392},
  SO18: {latitude: 50.9241213, longitude: -1.3620137},
  SO19: {latitude: 50.9019834, longitude: -1.354918},
  SO20: {latitude: 51.1166333, longitude: -1.5167063},
  SO21: {latitude: 51.0753776, longitude: -1.3162444},
  SO22: {latitude: 51.0665077, longitude: -1.3356583},
  SO23: {latitude: 51.0685878, longitude: -1.3082473},
  SO24: {latitude: 51.0844741, longitude: -1.1471161},
  SO25: {latitude: 51.0675552, longitude: -1.2973027},
  SO30: {latitude: 50.9198664, longitude: -1.3069752},
  SO31: {latitude: 50.8700098, longitude: -1.2998114},
  SO32: {latitude: 50.9493624, longitude: -1.2031646},
  SO40: {latitude: 50.9129875, longitude: -1.5038949},
  SO41: {latitude: 50.7554651, longitude: -1.5665136},
  SO42: {latitude: 50.8151761, longitude: -1.5366074},
  SO43: {latitude: 50.8862421, longitude: -1.5893747},
  SO45: {latitude: 50.8468498, longitude: -1.394766},
  SO50: {latitude: 50.9693035, longitude: -1.3404267},
  SO51: {latitude: 50.9959687, longitude: -1.5037602},
  SO52: {latitude: 50.9775491, longitude: -1.4438927},
  SO53: {latitude: 50.9860424, longitude: -1.383629},
  SO97: {latitude: 50.9484861, longitude: -1.3619614},
  SP1: {latitude: 51.075221, longitude: -1.7887748},
  SP10: {latitude: 51.211413, longitude: -1.4845424},
  SP11: {latitude: 51.2275811, longitude: -1.5120802},
  SP2: {latitude: 51.0750553, longitude: -1.8258872},
  SP3: {latitude: 51.1021334, longitude: -2.0158963},
  SP4: {latitude: 51.1660243, longitude: -1.7660031},
  SP5: {latitude: 51.021579, longitude: -1.770351},
  SP6: {latitude: 50.9365589, longitude: -1.8023782},
  SP7: {latitude: 51.0050805, longitude: -2.1843108},
  SP8: {latitude: 51.0373048, longitude: -2.2910983},
  SP9: {latitude: 51.233459, longitude: -1.6649674},
  SR1: {latitude: 54.9061193, longitude: -1.3782118},
  SR2: {latitude: 54.8860669, longitude: -1.3765988},
  SR3: {latitude: 54.8766731, longitude: -1.4168469},
  SR4: {latitude: 54.9003709, longitude: -1.4255904},
  SR5: {latitude: 54.9226017, longitude: -1.4241884},
  SR6: {latitude: 54.9355496, longitude: -1.379168},
  SR7: {latitude: 54.8304225, longitude: -1.3630969},
  SR8: {latitude: 54.7667388, longitude: -1.3365695},
  SS0: {latitude: 51.546671, longitude: 0.6877161},
  SS1: {latitude: 51.5376959, longitude: 0.7305193},
  SS11: {latitude: 51.6172491, longitude: 0.537807},
  SS12: {latitude: 51.60537, longitude: 0.5205007},
  SS13: {latitude: 51.5750029, longitude: 0.5109302},
  SS14: {latitude: 51.5760335, longitude: 0.4746395},
  SS15: {latitude: 51.577489, longitude: 0.4281305},
  SS16: {latitude: 51.5625971, longitude: 0.4520758},
  SS17: {latitude: 51.5216078, longitude: 0.4376424},
  SS2: {latitude: 51.5508903, longitude: 0.7167546},
  SS22: {latitude: 51.556979, longitude: 0.7068231},
  SS3: {latitude: 51.5432969, longitude: 0.7891019},
  SS4: {latitude: 51.5930469, longitude: 0.7118562},
  SS5: {latitude: 51.6077523, longitude: 0.6479542},
  SS6: {latitude: 51.5886238, longitude: 0.6074751},
  SS7: {latitude: 51.5622938, longitude: 0.5777041},
  SS8: {latitude: 51.5221057, longitude: 0.5895804},
  SS9: {latitude: 51.5547671, longitude: 0.651723},
  SS99: {latitude: 51.5477702, longitude: 0.7142613},
  ST1: {latitude: 53.0273418, longitude: -2.1730317},
  ST10: {latitude: 52.9885754, longitude: -1.9646762},
  ST11: {latitude: 52.9657745, longitude: -2.0645769},
  ST12: {latitude: 52.946949, longitude: -2.1727546},
  ST13: {latitude: 53.1009844, longitude: -2.0193009},
  ST14: {latitude: 52.9043124, longitude: -1.8699946},
  ST15: {latitude: 52.9000776, longitude: -2.1504385},
  ST16: {latitude: 52.8135538, longitude: -2.1201818},
  ST17: {latitude: 52.7881373, longitude: -2.0991013},
  ST18: {latitude: 52.8150827, longitude: -2.0806107},
  ST19: {latitude: 52.7087806, longitude: -2.1473047},
  ST2: {latitude: 53.028141, longitude: -2.1354237},
  ST20: {latitude: 52.798281, longitude: -2.2761054},
  ST21: {latitude: 52.8725507, longitude: -2.2694515},
  ST3: {latitude: 52.9807695, longitude: -2.1231617},
  ST4: {latitude: 52.9945102, longitude: -2.1854192},
  ST5: {latitude: 53.0153757, longitude: -2.2395729},
  ST55: {latitude: 53.0141598, longitude: -2.2380231},
  ST6: {latitude: 53.0579381, longitude: -2.1895987},
  ST7: {latitude: 53.0885898, longitude: -2.2685631},
  ST8: {latitude: 53.1155274, longitude: -2.167896},
  ST9: {latitude: 53.0528082, longitude: -2.0960983},
  SW10: {latitude: 51.483784, longitude: -0.1827911},
  SW11: {latitude: 51.4681801, longitude: -0.1637256},
  SW12: {latitude: 51.4463283, longitude: -0.1491401},
  SW13: {latitude: 51.4761464, longitude: -0.2438054},
  SW14: {latitude: 51.4653809, longitude: -0.2669998},
  SW15: {latitude: 51.4570342, longitude: -0.2284869},
  SW16: {latitude: 51.4212906, longitude: -0.1292383},
  SW17: {latitude: 51.4307971, longitude: -0.1648874},
  SW18: {latitude: 51.4512533, longitude: -0.191462},
  SW19: {latitude: 51.4241552, longitude: -0.2029208},
  SW1A: {latitude: 51.5044592, longitude: -0.1321624},
  SW1E: {latitude: 51.4979064, longitude: -0.1397427},
  SW1H: {latitude: 51.4987321, longitude: -0.1337132},
  SW1P: {latitude: 51.4900482, longitude: -0.133214},
  SW1V: {latitude: 51.4894932, longitude: -0.1399734},
  SW1W: {latitude: 51.4925553, longitude: -0.1509311},
  SW1X: {latitude: 51.4982019, longitude: -0.1566313},
  SW1Y: {latitude: 51.5074759, longitude: -0.1345996},
  SW2: {latitude: 51.4493013, longitude: -0.1198466},
  SW20: {latitude: 51.4109597, longitude: -0.2277548},
  SW3: {latitude: 51.4891244, longitude: -0.1657226},
  SW4: {latitude: 51.4611107, longitude: -0.1364914},
  SW5: {latitude: 51.4915827, longitude: -0.1919239},
  SW6: {latitude: 51.4766351, longitude: -0.2012224},
  SW7: {latitude: 51.4962781, longitude: -0.1770136},
  SW8: {latitude: 51.4765695, longitude: -0.1320148},
  SW9: {latitude: 51.4693401, longitude: -0.1138947},
  SW95: {latitude: 51.4803984, longitude: -0.1362742},
  SY1: {latitude: 52.7226132, longitude: -2.7405434},
  SY10: {latitude: 52.8394661, longitude: -3.1235551},
  SY11: {latitude: 52.8699722, longitude: -3.0312225},
  SY12: {latitude: 52.9028027, longitude: -2.8954535},
  SY13: {latitude: 52.9521685, longitude: -2.6900901},
  SY14: {latitude: 53.0312383, longitude: -2.7680979},
  SY15: {latitude: 52.5532761, longitude: -3.1331948},
  SY16: {latitude: 52.5206495, longitude: -3.3122813},
  SY17: {latitude: 52.5171419, longitude: -3.4690989},
  SY18: {latitude: 52.4415588, longitude: -3.5494041},
  SY19: {latitude: 52.5793884, longitude: -3.6346543},
  SY2: {latitude: 52.705579, longitude: -2.729248},
  SY20: {latitude: 52.6147887, longitude: -3.81884},
  SY21: {latitude: 52.6581949, longitude: -3.2070323},
  SY22: {latitude: 52.7568466, longitude: -3.186804},
  SY23: {latitude: 52.3800111, longitude: -4.051249},
  SY24: {latitude: 52.4727828, longitude: -4.0207042},
  SY25: {latitude: 52.2379435, longitude: -3.9371965},
  SY3: {latitude: 52.6989988, longitude: -2.7732128},
  SY4: {latitude: 52.7980636, longitude: -2.753822},
  SY5: {latitude: 52.6515091, longitude: -2.8328135},
  SY6: {latitude: 52.5371062, longitude: -2.791617},
  SY7: {latitude: 52.4254259, longitude: -2.8867442},
  SY8: {latitude: 52.3650723, longitude: -2.6953443},
  SY9: {latitude: 52.4991445, longitude: -2.9906924},
  SY99: {latitude: 52.7128256, longitude: -2.74961},
  TA1: {latitude: 51.0132224, longitude: -3.1028526},
  TA10: {latitude: 51.0334527, longitude: -2.8257148},
  TA11: {latitude: 51.0605815, longitude: -2.7024096},
  TA12: {latitude: 50.974841, longitude: -2.7730116},
  TA13: {latitude: 50.9466906, longitude: -2.8102347},
  TA14: {latitude: 50.9468145, longitude: -2.7515634},
  TA15: {latitude: 50.9511535, longitude: -2.7169146},
  TA16: {latitude: 50.9094738, longitude: -2.7935591},
  TA17: {latitude: 50.9082091, longitude: -2.8361593},
  TA18: {latitude: 50.8829255, longitude: -2.7874829},
  TA19: {latitude: 50.9351637, longitude: -2.9154632},
  TA2: {latitude: 51.0340308, longitude: -3.1010171},
  TA20: {latitude: 50.8735523, longitude: -2.9622162},
  TA21: {latitude: 50.9777888, longitude: -3.2445571},
  TA22: {latitude: 51.0456933, longitude: -3.5451925},
  TA23: {latitude: 51.1625334, longitude: -3.352683},
  TA24: {latitude: 51.1819504, longitude: -3.5105467},
  TA3: {latitude: 50.9936898, longitude: -3.037039},
  TA4: {latitude: 51.074692, longitude: -3.2714873},
  TA5: {latitude: 51.1428039, longitude: -3.094884},
  TA6: {latitude: 51.1256664, longitude: -3.0008114},
  TA7: {latitude: 51.131561, longitude: -2.910703},
  TA8: {latitude: 51.2451467, longitude: -2.9950311},
  TA9: {latitude: 51.2255918, longitude: -2.9567138},
  TD1: {latitude: 55.6231746, longitude: -2.810917},
  TD10: {latitude: 55.7114784, longitude: -2.4518628},
  TD11: {latitude: 55.7877855, longitude: -2.3139948},
  TD12: {latitude: 55.6527612, longitude: -2.2410299},
  TD13: {latitude: 55.929849, longitude: -2.3714898},
  TD14: {latitude: 55.8673888, longitude: -2.1245054},
  TD15: {latitude: 55.7473641, longitude: -2.0146884},
  TD2: {latitude: 55.7309958, longitude: -2.7543989},
  TD3: {latitude: 55.7018161, longitude: -2.5737927},
  TD4: {latitude: 55.642449, longitude: -2.6720572},
  TD5: {latitude: 55.5881056, longitude: -2.4173178},
  TD6: {latitude: 55.5818814, longitude: -2.6932118},
  TD7: {latitude: 55.5365991, longitude: -2.8730161},
  TD8: {latitude: 55.4759086, longitude: -2.542383},
  TD9: {latitude: 55.3973065, longitude: -2.7767413},
  TF1: {latitude: 52.7031424, longitude: -2.5029461},
  TF10: {latitude: 52.7694651, longitude: -2.3870759},
  TF11: {latitude: 52.6651286, longitude: -2.3582963},
  TF12: {latitude: 52.6120064, longitude: -2.4817746},
  TF13: {latitude: 52.5787304, longitude: -2.5824227},
  TF2: {latitude: 52.7002332, longitude: -2.4399297},
  TF3: {latitude: 52.6674608, longitude: -2.4483576},
  TF4: {latitude: 52.6626967, longitude: -2.4715605},
  TF5: {latitude: 52.717189, longitude: -2.5392219},
  TF6: {latitude: 52.7362755, longitude: -2.5560077},
  TF7: {latitude: 52.63923, longitude: -2.4504763},
  TF8: {latitude: 52.6293306, longitude: -2.4821233},
  TF9: {latitude: 52.8968634, longitude: -2.4700531},
  TN1: {latitude: 51.1346687, longitude: 0.2665338},
  TN10: {latitude: 51.2120053, longitude: 0.2840864},
  TN11: {latitude: 51.2070078, longitude: 0.2646847},
  TN12: {latitude: 51.1724422, longitude: 0.4445547},
  TN13: {latitude: 51.2768935, longitude: 0.1838655},
  TN14: {latitude: 51.2978503, longitude: 0.1574783},
  TN15: {latitude: 51.302716, longitude: 0.2746409},
  TN16: {latitude: 51.2930684, longitude: 0.0517089},
  TN17: {latitude: 51.0962819, longitude: 0.5367581},
  TN18: {latitude: 51.0428062, longitude: 0.5226677},
  TN19: {latitude: 51.0027867, longitude: 0.4058702},
  TN2: {latitude: 51.1279359, longitude: 0.2750576},
  TN20: {latitude: 51.0167888, longitude: 0.2503568},
  TN21: {latitude: 50.9581826, longitude: 0.2628954},
  TN22: {latitude: 50.9820991, longitude: 0.1003886},
  TN23: {latitude: 51.1399102, longitude: 0.8570045},
  TN24: {latitude: 51.1497728, longitude: 0.8877433},
  TN25: {latitude: 51.1412359, longitude: 0.9384339},
  TN26: {latitude: 51.0964754, longitude: 0.797358},
  TN27: {latitude: 51.1678981, longitude: 0.6938213},
  TN28: {latitude: 50.9828035, longitude: 0.950948},
  TN29: {latitude: 50.9938289, longitude: 0.9325174},
  TN3: {latitude: 51.1208107, longitude: 0.2480518},
  TN30: {latitude: 51.0622974, longitude: 0.6967544},
  TN31: {latitude: 50.962869, longitude: 0.6855793},
  TN32: {latitude: 50.9791601, longitude: 0.4904213},
  TN33: {latitude: 50.9114028, longitude: 0.4750454},
  TN34: {latitude: 50.8650015, longitude: 0.5821191},
  TN35: {latitude: 50.8828713, longitude: 0.6140004},
  TN36: {latitude: 50.920303, longitude: 0.6990613},
  TN37: {latitude: 50.8723505, longitude: 0.5572632},
  TN38: {latitude: 50.8637392, longitude: 0.543696},
  TN39: {latitude: 50.8468689, longitude: 0.4514689},
  TN4: {latitude: 51.1455609, longitude: 0.254806},
  TN40: {latitude: 50.8450642, longitude: 0.4824058},
  TN5: {latitude: 51.0590304, longitude: 0.3650914},
  TN6: {latitude: 51.0522368, longitude: 0.1754135},
  TN7: {latitude: 51.0960303, longitude: 0.1026001},
  TN8: {latitude: 51.1951342, longitude: 0.0779767},
  TN9: {latitude: 51.1916379, longitude: 0.2749493},
  TQ1: {latitude: 50.4730506, longitude: -3.523599},
  TQ10: {latitude: 50.4234657, longitude: -3.8260896},
  TQ11: {latitude: 50.4823197, longitude: -3.7850715},
  TQ12: {latitude: 50.5294305, longitude: -3.6123156},
  TQ13: {latitude: 50.5945854, longitude: -3.7176059},
  TQ14: {latitude: 50.5507921, longitude: -3.5078648},
  TQ2: {latitude: 50.4764111, longitude: -3.546236},
  TQ3: {latitude: 50.443945, longitude: -3.5764405},
  TQ4: {latitude: 50.4228675, longitude: -3.5722576},
  TQ5: {latitude: 50.391781, longitude: -3.5234852},
  TQ6: {latitude: 50.3471274, longitude: -3.5905841},
  TQ7: {latitude: 50.2826457, longitude: -3.7844126},
  TQ8: {latitude: 50.2366074, longitude: -3.7718704},
  TQ9: {latitude: 50.4165597, longitude: -3.6910718},
  TR1: {latitude: 50.2626097, longitude: -5.0541868},
  TR10: {latitude: 50.1676099, longitude: -5.1189764},
  TR11: {latitude: 50.1498016, longitude: -5.0876959},
  TR12: {latitude: 50.042234, longitude: -5.1794424},
  TR13: {latitude: 50.1095854, longitude: -5.2866459},
  TR14: {latitude: 50.2107232, longitude: -5.2967361},
  TR15: {latitude: 50.2331276, longitude: -5.2380409},
  TR16: {latitude: 50.2326748, longitude: -5.2212503},
  TR17: {latitude: 50.1255013, longitude: -5.4684713},
  TR18: {latitude: 50.1174074, longitude: -5.5425056},
  TR19: {latitude: 50.1001216, longitude: -5.6316273},
  TR2: {latitude: 50.2545424, longitude: -4.9504488},
  TR20: {latitude: 50.1318144, longitude: -5.4879968},
  TR21: {latitude: 49.9189845, longitude: -6.2986255},
  TR22: {latitude: 49.895171, longitude: -6.340873},
  TR23: {latitude: 49.9536038, longitude: -6.3526466},
  TR24: {latitude: 49.9554022, longitude: -6.3353021},
  TR25: {latitude: 49.9642737, longitude: -6.2933395},
  TR26: {latitude: 50.2028293, longitude: -5.4789995},
  TR27: {latitude: 50.1828787, longitude: -5.4037493},
  TR3: {latitude: 50.2174347, longitude: -5.112456},
  TR4: {latitude: 50.2858425, longitude: -5.1375346},
  TR5: {latitude: 50.31016, longitude: -5.196735},
  TR6: {latitude: 50.3419388, longitude: -5.1530283},
  TR7: {latitude: 50.4138677, longitude: -5.0748401},
  TR8: {latitude: 50.4004251, longitude: -5.039462},
  TR9: {latitude: 50.4134665, longitude: -4.9352015},
  TS1: {latitude: 54.5719344, longitude: -1.2392024},
  TS10: {latitude: 54.6067666, longitude: -1.0693075},
  TS11: {latitude: 54.5876196, longitude: -1.0269506},
  TS12: {latitude: 54.5628683, longitude: -0.9670708},
  TS13: {latitude: 54.5496921, longitude: -0.8541928},
  TS14: {latitude: 54.5324596, longitude: -1.0625812},
  TS15: {latitude: 54.4872991, longitude: -1.3351828},
  TS16: {latitude: 54.5222224, longitude: -1.3559066},
  TS17: {latitude: 54.5355555, longitude: -1.3046467},
  TS18: {latitude: 54.5609693, longitude: -1.3240632},
  TS19: {latitude: 54.5771805, longitude: -1.3433587},
  TS2: {latitude: 54.5853647, longitude: -1.2376261},
  TS20: {latitude: 54.5866832, longitude: -1.3138689},
  TS21: {latitude: 54.628183, longitude: -1.4287816},
  TS22: {latitude: 54.6250233, longitude: -1.320442},
  TS23: {latitude: 54.6094056, longitude: -1.2851796},
  TS24: {latitude: 54.6967403, longitude: -1.2111481},
  TS25: {latitude: 54.6630533, longitude: -1.2252844},
  TS26: {latitude: 54.688955, longitude: -1.2326907},
  TS27: {latitude: 54.7239957, longitude: -1.2907917},
  TS28: {latitude: 54.7257395, longitude: -1.3749668},
  TS29: {latitude: 54.7107686, longitude: -1.4202463},
  TS3: {latitude: 54.5605009, longitude: -1.1968742},
  TS4: {latitude: 54.5559482, longitude: -1.2229129},
  TS5: {latitude: 54.5503419, longitude: -1.2523379},
  TS6: {latitude: 54.5656389, longitude: -1.1534611},
  TS7: {latitude: 54.5339607, longitude: -1.1831961},
  TS8: {latitude: 54.5216751, longitude: -1.2327726},
  TS9: {latitude: 54.4659991, longitude: -1.1652944},
  TW1: {latitude: 51.4510989, longitude: -0.3257026},
  TW10: {latitude: 51.4477641, longitude: -0.3029046},
  TW11: {latitude: 51.4263148, longitude: -0.3317674},
  TW12: {latitude: 51.4228861, longitude: -0.3697391},
  TW13: {latitude: 51.4389898, longitude: -0.4020137},
  TW14: {latitude: 51.4533965, longitude: -0.4217772},
  TW15: {latitude: 51.4311588, longitude: -0.4585262},
  TW16: {latitude: 51.4157677, longitude: -0.4169227},
  TW17: {latitude: 51.39821, longitude: -0.4476473},
  TW18: {latitude: 51.4276663, longitude: -0.5044353},
  TW19: {latitude: 51.4543018, longitude: -0.4985225},
  TW2: {latitude: 51.446354, longitude: -0.3544949},
  TW20: {latitude: 51.4274804, longitude: -0.5525407},
  TW3: {latitude: 51.4681228, longitude: -0.3638733},
  TW4: {latitude: 51.4654671, longitude: -0.3879716},
  TW5: {latitude: 51.4824354, longitude: -0.3862521},
  TW6: {latitude: 51.4709495, longitude: -0.4483159},
  TW7: {latitude: 51.4730054, longitude: -0.3358063},
  TW8: {latitude: 51.4873197, longitude: -0.3063655},
  TW9: {latitude: 51.4694559, longitude: -0.2927343},
  UB1: {latitude: 51.5155606, longitude: -0.3733091},
  UB10: {latitude: 51.5493776, longitude: -0.4519988},
  UB11: {latitude: 51.5113205, longitude: -0.4469162},
  UB18: {latitude: 51.5007178, longitude: -0.4026841},
  UB2: {latitude: 51.4995871, longitude: -0.3791468},
  UB3: {latitude: 51.5052003, longitude: -0.4245561},
  UB4: {latitude: 51.5259518, longitude: -0.4084729},
  UB5: {latitude: 51.5431381, longitude: -0.3764324},
  UB6: {latitude: 51.538982, longitude: -0.3406322},
  UB7: {latitude: 51.5044432, longitude: -0.4691618},
  UB8: {latitude: 51.5352408, longitude: -0.4738505},
  UB9: {latitude: 51.5862858, longitude: -0.4926586},
  W10: {latitude: 51.5230766, longitude: -0.2176568},
  W11: {latitude: 51.512272, longitude: -0.2164413},
  W12: {latitude: 51.5083087, longitude: -0.2407824},
  W13: {latitude: 51.5130201, longitude: -0.3212138},
  W14: {latitude: 51.494691, longitude: -0.2102541},
  W1A: {latitude: 51.5243788, longitude: -0.11279},
  W1B: {latitude: 51.5143738, longitude: -0.1409766},
  W1C: {latitude: 51.5144348, longitude: -0.1491314},
  W1D: {latitude: 51.5133117, longitude: -0.1327615},
  W1F: {latitude: 51.5134975, longitude: -0.1364725},
  W1G: {latitude: 51.5193162, longitude: -0.1482679},
  W1H: {latitude: 51.517687, longitude: -0.1611043},
  W1J: {latitude: 51.5079068, longitude: -0.1450205},
  W1K: {latitude: 51.5111191, longitude: -0.1510369},
  W1S: {latitude: 51.5112227, longitude: -0.1423455},
  W1T: {latitude: 51.5202472, longitude: -0.1367101},
  W1U: {latitude: 51.5187153, longitude: -0.1534804},
  W1W: {latitude: 51.5192066, longitude: -0.1409008},
  W2: {latitude: 51.5151251, longitude: -0.1854875},
  W3: {latitude: 51.5106335, longitude: -0.2679031},
  W4: {latitude: 51.4912309, longitude: -0.2640107},
  W5: {latitude: 51.5131903, longitude: -0.3024217},
  W6: {latitude: 51.4926401, longitude: -0.2287797},
  W7: {latitude: 51.5118598, longitude: -0.335921},
  W8: {latitude: 51.5011337, longitude: -0.1943202},
  W9: {latitude: 51.5247242, longitude: -0.1926416},
  WA1: {latitude: 53.3942536, longitude: -2.5714198},
  WA10: {latitude: 53.4542967, longitude: -2.7561819},
  WA11: {latitude: 53.4780797, longitude: -2.7197662},
  WA12: {latitude: 53.4533844, longitude: -2.6332824},
  WA13: {latitude: 53.3823451, longitude: -2.4693236},
  WA14: {latitude: 53.3878102, longitude: -2.3607423},
  WA15: {latitude: 53.3845913, longitude: -2.3259397},
  WA16: {latitude: 53.3030431, longitude: -2.3722288},
  WA2: {latitude: 53.4108251, longitude: -2.5811919},
  WA3: {latitude: 53.456371, longitude: -2.5477451},
  WA4: {latitude: 53.3653734, longitude: -2.5758118},
  WA5: {latitude: 53.3990847, longitude: -2.6388726},
  WA55: {latitude: 53.3912093, longitude: -2.6088591},
  WA6: {latitude: 53.2727629, longitude: -2.7247283},
  WA7: {latitude: 53.3305871, longitude: -2.7036909},
  WA8: {latitude: 53.3730238, longitude: -2.7415958},
  WA88: {latitude: 53.3679728, longitude: -2.7686736},
  WA9: {latitude: 53.4361271, longitude: -2.7192438},
  WC1A: {latitude: 51.5201536, longitude: -0.1203458},
  WC1B: {latitude: 51.5194545, longitude: -0.1259647},
  WC1E: {latitude: 51.5217107, longitude: -0.1328422},
  WC1H: {latitude: 51.5268445, longitude: -0.1256084},
  WC1N: {latitude: 51.5229255, longitude: -0.1197316},
  WC1R: {latitude: 51.5196199, longitude: -0.1158498},
  WC1V: {latitude: 51.5180929, longitude: -0.1165884},
  WC1X: {latitude: 51.5266751, longitude: -0.1151125},
  WC2A: {latitude: 51.5162229, longitude: -0.1142197},
  WC2B: {latitude: 51.5149298, longitude: -0.1204399},
  WC2E: {latitude: 51.5118792, longitude: -0.1233747},
  WC2H: {latitude: 51.5133603, longitude: -0.1273492},
  WC2N: {latitude: 51.509081, longitude: -0.1248873},
  WC2R: {latitude: 51.5116889, longitude: -0.1183208},
  WD17: {latitude: 51.663945, longitude: -0.4056406},
  WD18: {latitude: 51.6491262, longitude: -0.4146492},
  WD19: {latitude: 51.6308706, longitude: -0.390642},
  WD23: {latitude: 51.6452717, longitude: -0.3580507},
  WD24: {latitude: 51.6737504, longitude: -0.3981532},
  WD25: {latitude: 51.6870777, longitude: -0.3877274},
  WD3: {latitude: 51.6466313, longitude: -0.4824803},
  WD4: {latitude: 51.7059771, longitude: -0.4564485},
  WD5: {latitude: 51.7026256, longitude: -0.4163911},
  WD6: {latitude: 51.6573773, longitude: -0.2756334},
  WD7: {latitude: 51.6870763, longitude: -0.309921},
  WD99: {latitude: 51.648776, longitude: -0.422087},
  WF1: {latitude: 53.6874355, longitude: -1.4935886},
  WF10: {latitude: 53.7240007, longitude: -1.347783},
  WF11: {latitude: 53.7117458, longitude: -1.2561796},
  WF12: {latitude: 53.6833333, longitude: -1.6199223},
  WF13: {latitude: 53.6923035, longitude: -1.6467249},
  WF14: {latitude: 53.6797839, longitude: -1.6960552},
  WF15: {latitude: 53.7082837, longitude: -1.700436},
  WF16: {latitude: 53.7102031, longitude: -1.6692768},
  WF17: {latitude: 53.7188923, longitude: -1.6426028},
  WF2: {latitude: 53.6723728, longitude: -1.5124139},
  WF3: {latitude: 53.7239736, longitude: -1.5253183},
  WF4: {latitude: 53.6466346, longitude: -1.5193831},
  WF5: {latitude: 53.6804698, longitude: -1.5764287},
  WF6: {latitude: 53.7003289, longitude: -1.415639},
  WF7: {latitude: 53.66632, longitude: -1.3528117},
  WF8: {latitude: 53.6861759, longitude: -1.3004853},
  WF9: {latitude: 53.6063404, longitude: -1.3212719},
  WF90: {latitude: 53.6744344, longitude: -1.4908921},
  WN1: {latitude: 53.5533114, longitude: -2.6281505},
  WN2: {latitude: 53.5359217, longitude: -2.5821236},
  WN3: {latitude: 53.5288084, longitude: -2.6459714},
  WN4: {latitude: 53.4936763, longitude: -2.6443803},
  WN5: {latitude: 53.5319036, longitude: -2.6873957},
  WN6: {latitude: 53.5752593, longitude: -2.6718},
  WN7: {latitude: 53.4980465, longitude: -2.5184534},
  WN8: {latitude: 53.5531891, longitude: -2.7694762},
  WR1: {latitude: 52.1956174, longitude: -2.2220478},
  WR10: {latitude: 52.1149851, longitude: -2.0671085},
  WR11: {latitude: 52.0958405, longitude: -1.9290168},
  WR12: {latitude: 52.0414013, longitude: -1.8704376},
  WR13: {latitude: 52.0930845, longitude: -2.3428588},
  WR14: {latitude: 52.1144453, longitude: -2.3204072},
  WR15: {latitude: 52.3054003, longitude: -2.5688982},
  WR2: {latitude: 52.1883104, longitude: -2.2484883},
  WR3: {latitude: 52.2169397, longitude: -2.2139652},
  WR4: {latitude: 52.203734, longitude: -2.1898149},
  WR5: {latitude: 52.1748639, longitude: -2.2020856},
  WR6: {latitude: 52.2298799, longitude: -2.3821575},
  WR7: {latitude: 52.1965989, longitude: -2.0491854},
  WR8: {latitude: 52.074811, longitude: -2.2066668},
  WR9: {latitude: 52.2667884, longitude: -2.1583548},
  WR99: {latitude: 52.1948626, longitude: -2.203101},
  WS1: {latitude: 52.5794509, longitude: -1.9786869},
  WS10: {latitude: 52.5606417, longitude: -2.0224958},
  WS11: {latitude: 52.6880429, longitude: -2.0173886},
  WS12: {latitude: 52.7071392, longitude: -2.0024555},
  WS13: {latitude: 52.6925953, longitude: -1.8189572},
  WS14: {latitude: 52.6640162, longitude: -1.8161526},
  WS15: {latitude: 52.7585909, longitude: -1.9173233},
  WS2: {latitude: 52.5892854, longitude: -2.0043778},
  WS3: {latitude: 52.6197704, longitude: -1.9920867},
  WS4: {latitude: 52.6068687, longitude: -1.9587114},
  WS5: {latitude: 52.5659951, longitude: -1.9583275},
  WS6: {latitude: 52.6585504, longitude: -2.0231546},
  WS7: {latitude: 52.6797404, longitude: -1.9216495},
  WS8: {latitude: 52.6474687, longitude: -1.9332437},
  WS9: {latitude: 52.6099899, longitude: -1.9184422},
  WV1: {latitude: 52.5864721, longitude: -2.1158825},
  WV10: {latitude: 52.6191468, longitude: -2.1134738},
  WV11: {latitude: 52.6105811, longitude: -2.0719935},
  WV12: {latitude: 52.6058407, longitude: -2.0403978},
  WV13: {latitude: 52.5851575, longitude: -2.0581222},
  WV14: {latitude: 52.5572984, longitude: -2.0789308},
  WV15: {latitude: 52.5159774, longitude: -2.3744083},
  WV16: {latitude: 52.5095974, longitude: -2.4409185},
  WV2: {latitude: 52.5736442, longitude: -2.118343},
  WV3: {latitude: 52.5790352, longitude: -2.1565201},
  WV4: {latitude: 52.5614099, longitude: -2.1447119},
  WV5: {latitude: 52.5341081, longitude: -2.2103369},
  WV6: {latitude: 52.5968273, longitude: -2.1827471},
  WV7: {latitude: 52.6354827, longitude: -2.2794354},
  WV8: {latitude: 52.6259036, longitude: -2.1876739},
  WV9: {latitude: 52.6376624, longitude: -2.1435341},
  WV98: {latitude: 52.4053675, longitude: -2.2199919},
  WV99: {latitude: 52.6713503, longitude: -2.4202904},
  YO1: {latitude: 53.9586237, longitude: -1.0828142},
  YO10: {latitude: 53.9504564, longitude: -1.0575048},
  YO11: {latitude: 54.2639772, longitude: -0.3963875},
  YO12: {latitude: 54.273341, longitude: -0.4249517},
  YO13: {latitude: 54.287425, longitude: -0.4992911},
  YO14: {latitude: 54.1978665, longitude: -0.2981294},
  YO15: {latitude: 54.094995, longitude: -0.1766616},
  YO16: {latitude: 54.0956952, longitude: -0.2020607},
  YO17: {latitude: 54.1367836, longitude: -0.7568135},
  YO18: {latitude: 54.2589315, longitude: -0.7690067},
  YO19: {latitude: 53.905948, longitude: -1.0207826},
  YO21: {latitude: 54.4770514, longitude: -0.7104006},
  YO22: {latitude: 54.4508006, longitude: -0.6217825},
  YO23: {latitude: 53.9234845, longitude: -1.1234069},
  YO24: {latitude: 53.945938, longitude: -1.1169804},
  YO25: {latitude: 54.0040772, longitude: -0.4163603},
  YO26: {latitude: 53.9757464, longitude: -1.1783526},
  YO30: {latitude: 53.9871101, longitude: -1.1170367},
  YO31: {latitude: 53.9699082, longitude: -1.0644173},
  YO32: {latitude: 54.0124771, longitude: -1.0593934},
  YO41: {latitude: 53.9705289, longitude: -0.9005201},
  YO42: {latitude: 53.9238079, longitude: -0.7902264},
  YO43: {latitude: 53.8493882, longitude: -0.6843122},
  YO51: {latitude: 54.0900779, longitude: -1.3947245},
  YO60: {latitude: 54.0861015, longitude: -0.9389498},
  YO61: {latitude: 54.1179291, longitude: -1.1960242},
  YO62: {latitude: 54.2461752, longitude: -0.9943394},
  YO7: {latitude: 54.2246863, longitude: -1.3514255},
  YO8: {latitude: 53.7812636, longitude: -1.0606474},
  YO90: {latitude: 53.959708, longitude: -1.0902501},
  ZE1: {latitude: 60.1514981, longitude: -1.1705115},
  ZE2: {latitude: 60.3146317, longitude: -1.2291689},
  ZE3: {latitude: 59.8829471, longitude: -1.3043577},
};
